import * as React from 'react';
import React__default, { useRef, useDebugValue, createElement, useContext, createContext, useMemo, useState, useEffect, useCallback, forwardRef } from 'react';
import { Button, Span, Box, Typography, useId, SelectionSet, SelectionSetInput, SelectionSetLabel, SelectionSetTileContents, FlexBox, Callout, UncustomizableMarkup, SelectionSetTileDescription as SelectionSetTileDescription$1, SelectionSetTileImageContainer, FluidImage, SelectionSetTileName, SelectionSetTilePrice, ListboxSection, ListboxOption, Listbox, ListboxButton, ListboxPopover, ListboxList, ListboxOptionThumbnailContainer, ListboxOptionTextContainer, GridContainer, Row, Column, DiscountPrice, ColorSwatches, ColorSwatch, Link, ModalDialog, ModalDialogContent, ModalDialogNav, ModalDialogCloseButton, ModalDialogHeader, ModalDialogTitle, ModalDialogBody, ModalDialogFooter, ModalDialogButtons, Combobox, ComboboxInput, ComboboxPopover, ComboboxList, ComboboxOption, Collapsible, CollapsibleSummary, CollapsibleSummaryButton, CollapsibleContent, AlertBox, AlertBoxDismissButton, TextInput, SkeletonText, SkeletonTextLine, H2, Spinner, StandardForm, FormField, FormLabel, FormInputGroup, Dropdown, DropdownOption, ScreenClassProvider } from '@vp/swan';
import { WranglerDataContext, useManagedWranglerSelectionsContext, useWranglerDataContext, ManagedWranglerSelectionsContext, ManagedWranglerSelectionsProvider } from '@vp/wrangler-data-source';
import { RawPrice, PlusOrMinusPerUnit, PlusOrMinus, ComparativeDisplayType, PricePerUnit, TokenReplace, QtyStartingAtPrice } from '@vp/vp-tokenized-fragment';
import { TokenEngine } from '@vp/vp-js-token-engine';
import { getTracking } from '@vp/tracking';

const ResponseButtons$1 = ({ onSaveSelections, onCancel, saveChangesLabel, revertChangesLabel, }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { skin: "primary", width: "full-width", mb: "4", onClick: onSaveSelections }, saveChangesLabel),
        React__default.createElement(Button, { width: "full-width", onClick: onCancel }, revertChangesLabel)));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof (value, search, position) {
	return value.indexOf(search, position)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

/**
 * @param {string[]} array
 * @param {RegExp} pattern
 * @return {string[]}
 */
function filter (array, pattern) {
	return array.filter(function (value) { return !match(value, pattern) })
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length, siblings) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: '', siblings: siblings}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0, root.siblings), root, {length: -root.length}, props)
}

/**
 * @param {object} root
 */
function lift (root) {
	while (root.root)
		root = copy(root.root, {children: [root]});

	append(root, root.siblings);
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret$1 () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret$1() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f', abs(index ? points[index - 1] : 0)) != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret$1() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret$1()), root, parent, declarations), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret$1())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment (value, root, parent, siblings) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration (value, root, parent, length, siblings) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings)
}

/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */
function prefix (value, length, children) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// tab-size
		case 4789:
			return MOZ + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
				// default: fallthrough to below
			}
		// flex, flex-direction, scroll-snap-type, writing-mode
		case 6828: case 4268: case 2903:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/g, '') + (!match(value, /flex-|baseline/) ? MS + 'grid-row-' + replace(value, /flex-|-self/g, '') : '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/g, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// justify-self
		case 4200:
			if (!match(value, /flex-|baseline/)) return MS + 'grid-column-align' + substr(value, length) + value
			break
		// grid-template-(columns|rows)
		case 2592: case 3360:
			return MS + replace(value, 'template-', '') + value
		// grid-(row|column)-start
		case 4384: case 3616:
			if (children && children.some(function (element, index) { return length = index, match(element.props, /grid-\w+-end/) })) {
				return ~indexof(value + (children = children[length].value), 'span', 0) ? value : (MS + replace(value, '-start', '') + value + MS + 'grid-row-span:' + (~indexof(children, 'span', 0) ? match(children, /\d+/) : +match(children, /\d+/) - +match(value, /\d+/)) + ';')
			}
			return MS + replace(value, '-start', '') + value
		// grid-(row|column)-end
		case 4896: case 4128:
			return (children && children.some(function (element) { return match(element.props, /grid-\w+-start/) })) ? value : MS + replace(replace(value, '-end', '-span'), 'span ', '') + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch', 0) ? prefix(replace(value, 'stretch', 'fill-available'), length, children) + value : value
				}
			break
		// grid-(column|row)
		case 5152: case 5920:
			return replace(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (_, a, b, c, d, e, f) { return (MS + a + ':' + b + f) + (c ? (MS + a + '-span:' + (d ? e : +e - +b)) + f : '') + value })
		// position: sticky
		case 4949:
			// stick(y)?
			if (charat(value, length + 6) === 121)
				return replace(value, ':', ':' + WEBKIT) + value
			break
		// display: (flex|inline-flex|grid|inline-grid)
		case 6444:
			switch (charat(value, charat(value, 14) === 45 ? 18 : 11)) {
				// (inline-)?fle(x)
				case 120:
					return replace(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
				// (inline-)?gri(d)
				case 100:
					return replace(value, ':', ':' + MS) + value
			}
			break
		// scroll-margin, scroll-margin-(top|right|bottom|left)
		case 5719: case 2647: case 2135: case 3927: case 2391:
			return replace(value, 'scroll-', 'scroll-snap-') + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';

	for (var i = 0; i < children.length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: if (!strlen(element.value = element.props.join(','))) return ''
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children);
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(children = element.props, function (value) {
							switch (match(value, callback = /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									lift(copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
								// :placeholder
								case '::placeholder':
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}));
									lift(copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]}));
									lift(copy(element, {props: [value]}));
									assign(element, {props: filter(children, callback)});
									break
							}

							return ''
						})
			}
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var f="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",m="active",y="data-styled-version",v="6.1.19",g="/*!sc*/\n",S="undefined"!=typeof window&&"undefined"!=typeof document,w=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),E=/invalid hook call/i,N=new Set,P=function(t,n){if("production"!==process.env.NODE_ENV){var o=n?' with the id of "'.concat(n,'"'):"",s="The component ".concat(t).concat(o," has been created dynamically.\n")+"You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.\nSee https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.\n",i=console.error;try{var a=!0;console.error=function(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];E.test(t)?(a=!1,N.delete(s)):i.apply(void 0,__spreadArray$1([t],n,!1));},useRef(),a&&!N.has(s)&&(console.warn(s),N.add(s));}catch(e){E.test(e.message)&&N.delete(s);}finally{console.error=i;}}},_=Object.freeze([]),C=Object.freeze({});function I(e,t,n){return void 0===n&&(n=C),e.theme!==n.theme&&e.theme||t||n.theme}var A=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),O=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,D=/(^-|-$)/g;function R(e){return e.replace(O,"-").replace(D,"")}var T=/(a)(d)/gi,k=52,j=function(e){return String.fromCharCode(e+(e>25?39:97))};function x(e){var t,n="";for(t=Math.abs(e);t>k;t=t/k|0)n=j(t%k)+n;return (j(t%k)+n).replace(T,"$1-$2")}var V,F=5381,z=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},M=function(e){return z(F,e)};function $(e){return x(M(e)>>>0)}function B(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function G(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var L="function"==typeof Symbol&&Symbol.for,Y=L?Symbol.for("react.memo"):60115,q=L?Symbol.for("react.forward_ref"):60112,W={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},H={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},U={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},J=((V={})[q]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},V[Y]=U,V);function X(e){return ("type"in(t=e)&&t.type.$$typeof)===Y?U:"$$typeof"in e?J[e.$$typeof]:W;var t;}var Z=Object.defineProperty,K=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,ne=Object.prototype;function oe(e,t,n){if("string"!=typeof t){if(ne){var o=te(t);o&&o!==ne&&oe(e,o,n);}var r=K(t);Q&&(r=r.concat(Q(t)));for(var s=X(e),i=X(t),a=0;a<r.length;++a){var c=r[a];if(!(c in H||n&&n[c]||i&&c in i||s&&c in s)){var l=ee(t,c);try{Z(e,c,l);}catch(e){}}}}return e}function re(e){return "function"==typeof e}function se(e){return "object"==typeof e&&"styledComponentId"in e}function ie(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ae(e,t){if(0===e.length)return "";for(var n=e[0],o=1;o<e.length;o++)n+=t?t+e[o]:e[o];return n}function ce(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function le(e,t,n){if(void 0===n&&(n=!1),!n&&!ce(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var o=0;o<t.length;o++)e[o]=le(e[o],t[o]);else if(ce(t))for(var o in t)e[o]=le(e[o],t[o]);return e}function ue(e,t){Object.defineProperty(e,"toString",{value:t});}var pe="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",18:"ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"}:{};function de(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],o=[],r=1,s=e.length;r<s;r+=1)o.push(e[r]);return o.forEach(function(e){n=n.replace(/%[a-z]/,e);}),n}function he(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];return "production"===process.env.NODE_ENV?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):new Error(de.apply(void 0,__spreadArray$1([pe[t]],n,!1)).trim())}var fe=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}return e.prototype.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,r=o;e>=r;)if((r<<=1)<0)throw he(16,"".concat(e));this.groupSizes=new Uint32Array(r),this.groupSizes.set(n),this.length=r;for(var s=o;s<r;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=(s=0,t.length);s<a;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++);},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),o=n+t;this.groupSizes[e]=0;for(var r=n;r<o;r++)this.tag.deleteRule(n);}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],o=this.indexOfGroup(e),r=o+n,s=o;s<r;s++)t+="".concat(this.tag.getRule(s)).concat(g);return t},e}(),me=1<<30,ye=new Map,ve=new Map,ge=1,Se=function(e){if(ye.has(e))return ye.get(e);for(;ve.has(ge);)ge++;var t=ge++;if("production"!==process.env.NODE_ENV&&((0|t)<0||t>me))throw he(16,"".concat(t));return ye.set(e,t),ve.set(t,e),t},we=function(e,t){ge=t+1,ye.set(e,t),ve.set(t,e);},be="style[".concat(f,"][").concat(y,'="').concat(v,'"]'),Ee=new RegExp("^".concat(f,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),Ne=function(e,t,n){for(var o,r=n.split(","),s=0,i=r.length;s<i;s++)(o=r[s])&&e.registerName(t,o);},Pe=function(e,t){for(var n,o=(null!==(n=t.textContent)&&void 0!==n?n:"").split(g),r=[],s=0,i=o.length;s<i;s++){var a=o[s].trim();if(a){var c=a.match(Ee);if(c){var l=0|parseInt(c[1],10),u=c[2];0!==l&&(we(u,l),Ne(e,u,c[3]),e.getTag().insertRules(l,r)),r.length=0;}else r.push(a);}}},_e=function(e){for(var t=document.querySelectorAll(be),n=0,o=t.length;n<o;n++){var r=t[n];r&&r.getAttribute(f)!==m&&(Pe(e,r),r.parentNode&&r.parentNode.removeChild(r));}};function Ce(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null}var Ie=function(e){var t=document.head,n=e||t,o=document.createElement("style"),r=function(e){var t=Array.from(e.querySelectorAll("style[".concat(f,"]")));return t[t.length-1]}(n),s=void 0!==r?r.nextSibling:null;o.setAttribute(f,m),o.setAttribute(y,v);var i=Ce();return i&&o.setAttribute("nonce",i),n.insertBefore(o,s),o},Ae=function(){function e(e){this.element=Ie(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,o=t.length;n<o;n++){var r=t[n];if(r.ownerNode===e)return r}throw he(17)}(this.element),this.length=0;}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Oe=function(){function e(e){this.element=Ie(e),this.nodes=this.element.childNodes,this.length=0;}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return !1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),De=function(){function e(e){this.rules=[],this.length=0;}return e.prototype.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--;},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),Re=S,Te={isServer:!S,useCSSOMInjection:!w},ke=function(){function e(e,n,o){void 0===e&&(e=C),void 0===n&&(n={});var r=this;this.options=__assign(__assign({},Te),e),this.gs=n,this.names=new Map(o),this.server=!!e.isServer,!this.server&&S&&Re&&(Re=!1,_e(this)),ue(this,function(){return function(e){for(var t=e.getTag(),n=t.length,o="",r=function(n){var r=function(e){return ve.get(e)}(n);if(void 0===r)return "continue";var s=e.names.get(r),i=t.getGroup(n);if(void 0===s||!s.size||0===i.length)return "continue";var a="".concat(f,".g").concat(n,'[id="').concat(r,'"]'),c="";void 0!==s&&s.forEach(function(e){e.length>0&&(c+="".concat(e,","));}),o+="".concat(i).concat(a,'{content:"').concat(c,'"}').concat(g);},s=0;s<n;s++)r(s);return o}(r)});}return e.registerId=function(e){return Se(e)},e.prototype.rehydrate=function(){!this.server&&S&&_e(this);},e.prototype.reconstructWithOptions=function(n,o){return void 0===o&&(o=!0),new e(__assign(__assign({},this.options),n),this.gs,o&&this.names||void 0)},e.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new De(n):t?new Ae(n):new Oe(n)}(this.options),new fe(e)));var e;},e.prototype.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},e.prototype.registerName=function(e,t){if(Se(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},e.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(Se(e),n);},e.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},e.prototype.clearRules=function(e){this.getTag().clearGroup(Se(e)),this.clearNames(e);},e.prototype.clearTag=function(){this.tag=void 0;},e}(),je=/&/g,xe=/^\s*\/\/.*$/gm;function Ve(e,t){return e.map(function(e){return "rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return "".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=Ve(e.children,t)),e})}function Fe(e){var t,n,o,r=void 0===e?C:e,s=r.options,i=void 0===s?C:s,a=r.plugins,c=void 0===a?_:a,l=function(e,o,r){return r.startsWith(n)&&r.endsWith(n)&&r.replaceAll(n,"").length>0?".".concat(t):e},u=c.slice();u.push(function(e){e.type===RULESET&&e.value.includes("&")&&(e.props[0]=e.props[0].replace(je,n).replace(o,l));}),i.prefix&&u.push(prefixer),u.push(stringify);var p=function(e,r,s,a){void 0===r&&(r=""),void 0===s&&(s=""),void 0===a&&(a="&"),t=a,n=r,o=new RegExp("\\".concat(n,"\\b"),"g");var c=e.replace(xe,""),l=compile(s||r?"".concat(s," ").concat(r," { ").concat(c," }"):c);i.namespace&&(l=Ve(l,i.namespace));var p=[];return serialize(l,middleware(u.concat(rulesheet(function(e){return p.push(e)})))),p};return p.hash=c.length?c.reduce(function(e,t){return t.name||he(15),z(e,t.name)},F).toString():"",p}var ze=new ke,Me=Fe(),$e=React__default.createContext({shouldForwardProp:void 0,styleSheet:ze,stylis:Me});$e.Consumer;React__default.createContext(void 0);function Le(){return useContext($e)}var qe=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=Me);var o=n.name+t.hash;e.hasNameForId(n.id,o)||e.insertRules(n.id,o,t(n.rules,o,"@keyframes"));},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,ue(this,function(){throw he(12,String(n.name))});}return e.prototype.getName=function(e){return void 0===e&&(e=Me),this.name+e.hash},e}(),We=function(e){return e>="A"&&e<="Z"};function He(e){for(var t="",n=0;n<e.length;n++){var o=e[n];if(1===n&&"-"===o&&"-"===e[0])return e;We(o)?t+="-"+o.toLowerCase():t+=o;}return t.startsWith("ms-")?"-"+t:t}var Ue=function(e){return null==e||!1===e||""===e},Je=function(t){var n,o,r=[];for(var s in t){var i=t[s];t.hasOwnProperty(s)&&!Ue(i)&&(Array.isArray(i)&&i.isCss||re(i)?r.push("".concat(He(s),":"),i,";"):ce(i)?r.push.apply(r,__spreadArray$1(__spreadArray$1(["".concat(s," {")],Je(i),!1),["}"],!1)):r.push("".concat(He(s),": ").concat((n=s,null==(o=i)||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||n in unitlessKeys||n.startsWith("--")?String(o).trim():"".concat(o,"px")),";")));}return r};function Xe(e,t,n,o){if(Ue(e))return [];if(se(e))return [".".concat(e.styledComponentId)];if(re(e)){if(!re(s=e)||s.prototype&&s.prototype.isReactComponent||!t)return [e];var r=e(t);return "production"===process.env.NODE_ENV||"object"!=typeof r||Array.isArray(r)||r instanceof qe||ce(r)||null===r||console.error("".concat(B(e)," is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")),Xe(r,t,n,o)}var s;return e instanceof qe?n?(e.inject(n,o),[e.getName(o)]):[e]:ce(e)?Je(e):Array.isArray(e)?Array.prototype.concat.apply(_,e.map(function(e){return Xe(e,t,n,o)})):[e.toString()]}function Ze(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!se(n))return !1}return !0}var Ke=M(v),Qe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&Ze(e),this.componentId=t,this.baseHash=z(Ke,t),this.baseStyle=n,ke.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))o=ie(o,this.staticRulesId);else {var r=ae(Xe(this.rules,e,t,n)),s=x(z(this.baseHash,r)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(r,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i);}o=ie(o,s),this.staticRulesId=s;}else {for(var a=z(this.baseHash,n.hash),c="",l=0;l<this.rules.length;l++){var u=this.rules[l];if("string"==typeof u)c+=u,"production"!==process.env.NODE_ENV&&(a=z(a,u));else if(u){var p=ae(Xe(u,e,t,n));a=z(a,p+l),c+=p;}}if(c){var d=x(a>>>0);t.hasNameForId(this.componentId,d)||t.insertRules(this.componentId,d,n(c,".".concat(d),void 0,this.componentId)),o=ie(o,d);}}return o},e}(),et=React__default.createContext(void 0);et.Consumer;var rt={},st=new Set;function it(e,r,s){var i=se(e),a=e,c=!G(e),p=r.attrs,d=void 0===p?_:p,h=r.componentId,f=void 0===h?function(e,t){var n="string"!=typeof e?"sc":R(e);rt[n]=(rt[n]||0)+1;var o="".concat(n,"-").concat($(v+n+rt[n]));return t?"".concat(t,"-").concat(o):o}(r.displayName,r.parentComponentId):h,m=r.displayName,y=void 0===m?function(e){return G(e)?"styled.".concat(e):"Styled(".concat(B(e),")")}(e):m,g=r.displayName&&r.componentId?"".concat(R(r.displayName),"-").concat(r.componentId):r.componentId||f,S=i&&a.attrs?a.attrs.concat(d).filter(Boolean):d,w=r.shouldForwardProp;if(i&&a.shouldForwardProp){var b=a.shouldForwardProp;if(r.shouldForwardProp){var E=r.shouldForwardProp;w=function(e,t){return b(e,t)&&E(e,t)};}else w=b;}var N=new Qe(s,g,i?a.componentStyle:void 0);function O(e,r){return function(e,r,s){var i=e.attrs,a=e.componentStyle,c=e.defaultProps,p=e.foldedComponentIds,d=e.styledComponentId,h=e.target,f=React__default.useContext(et),m=Le(),y=e.shouldForwardProp||m.shouldForwardProp;"production"!==process.env.NODE_ENV&&useDebugValue(d);var v=I(r,f,c)||C,g=function(e,n,o){for(var r,s=__assign(__assign({},n),{className:void 0,theme:o}),i=0;i<e.length;i+=1){var a=re(r=e[i])?r(s):r;for(var c in a)s[c]="className"===c?ie(s[c],a[c]):"style"===c?__assign(__assign({},s[c]),a[c]):a[c];}return n.className&&(s.className=ie(s.className,n.className)),s}(i,r,v),S=g.as||h,w={};for(var b in g)void 0===g[b]||"$"===b[0]||"as"===b||"theme"===b&&g.theme===v||("forwardedAs"===b?w.as=g.forwardedAs:y&&!y(b,S)||(w[b]=g[b],y||"development"!==process.env.NODE_ENV||isPropValid(b)||st.has(b)||!A.has(S)||(st.add(b),console.warn('styled-components: it looks like an unknown prop "'.concat(b,'" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));var E=function(e,t){var n=Le(),o=e.generateAndInjectStyles(t,n.styleSheet,n.stylis);return "production"!==process.env.NODE_ENV&&useDebugValue(o),o}(a,g);"production"!==process.env.NODE_ENV&&e.warnTooManyClasses&&e.warnTooManyClasses(E);var N=ie(p,d);return E&&(N+=" "+E),g.className&&(N+=" "+g.className),w[G(S)&&!A.has(S)?"class":"className"]=N,s&&(w.ref=s),createElement(S,w)}(D,e,r)}O.displayName=y;var D=React__default.forwardRef(O);return D.attrs=S,D.componentStyle=N,D.displayName=y,D.shouldForwardProp=w,D.foldedComponentIds=i?ie(a.foldedComponentIds,a.styledComponentId):"",D.styledComponentId=g,D.target=i?a.target:e,Object.defineProperty(D,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=i?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var o=0,r=t;o<r.length;o++)le(e,r[o],!0);return e}({},a.defaultProps,e):e;}}),"production"!==process.env.NODE_ENV&&(P(y,g),D.warnTooManyClasses=function(e,t){var n={},o=!1;return function(r){if(!o&&(n[r]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'.concat(t,'"'):"";console.warn("Over ".concat(200," classes were generated for component ").concat(e).concat(s,".\n")+"Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),o=!0,n={};}}}(y,g)),ue(D,function(){return ".".concat(D.styledComponentId)}),c&&oe(D,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),D}function at(e,t){for(var n=[e[0]],o=0,r=t.length;o<r;o+=1)n.push(t[o],e[o+1]);return n}var ct=function(e){return Object.assign(e,{isCss:!0})};function lt(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];if(re(t)||ce(t))return ct(Xe(at(_,__spreadArray$1([t],n,!0))));var r=t;return 0===n.length&&1===r.length&&"string"==typeof r[0]?Xe(r):ct(Xe(at(r,n)))}function ut(n,o,r){if(void 0===r&&(r=C),!o)throw he(1,o);var s=function(t){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return n(o,r,lt.apply(void 0,__spreadArray$1([t],s,!1)))};return s.attrs=function(e){return ut(n,o,__assign(__assign({},r),{attrs:Array.prototype.concat(r.attrs,e).filter(Boolean)}))},s.withConfig=function(e){return ut(n,o,__assign(__assign({},r),e))},s}var pt=function(e){return ut(it,e)},dt=pt;A.forEach(function(e){dt[e]=pt(e);});"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");var wt="__sc-".concat(f,"__");"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window[wt]||(window[wt]=0),1===window[wt]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window[wt]+=1);

var quantityLabel$d = "Quantity";
var quantityFlyoutHeader$d = "Choose your quantity";
var quantityFlyoutCTA$d = "Select this quantity";
var closeButton$d = "Close";
var pricePlaceholder$d = "...";
var priceLabel$d = "Price";
var unitPriceLabel$d = "Unit price";
var incompatibilityMessage$d = "Not available with other selections: ";
var select$d = "Select...";
var percentSavings$d = "{{{PERCENT}}}% savings";
var sale$d = "sale";
var amountSavings$d = "{{{AMOUNT}}} savings / unit";
var amountSavingsWithSale$d = "{{{AMOUNT}}} savings / unit + sale";
var seeMoreQuantities$d = "See more quantities";
var required$d = "Required";
var sample$d = "Sample";
var estimatedQuantity$d = "Estimated quantity";
var numberOfRecipients$d = "{{{COUNT}}} Recipients";
var recommendedCallout$d = "Recommended";
var newCallout$d = "New";
var incompatibleLabel$d = "Incompatible";
var outOfStockCallout$d = "Out of stock";
var dismissAlert$d = "Dismiss alert";
var unwindingMessage_1$d = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$d = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$d = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$d = "Incompatible with more than {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1$d = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} was unselected.";
var unwindingAlertMessage_2$d = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}} were unselected.";
var unwindingAlertMessage_3$d = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}} were unselected.";
var unwindingAlertMessage_more$d = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: More than {{{ATTRIBUTE_COUNT}}} options were unselected.";
var fullRangedHelperText$d = "{{{MINIMUM}}} {{{UNIT}}} to {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$d = "At least {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$d = "Enter a value between {{{MINIMUM}}} to {{{MAXIMUM}}} pages, including cover ";
var rangePartialRangedHelperTextForBooklets$d = "At least {{{MINIMUM}}} pages, including cover ";
var rangedGeneralInputError$d = "Input is invalid";
var rangedBetweenRangesError$d = "Closest numbers are {{{LOWER}}} {{{UNIT}}} and {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$d = "Number can't exceed 8 decimals";
var rangedMinInputValueError$d = "The minimum number is {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$d = "The maximum number is {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$d = "Input must be a number";
var requiredAttributeFieldError$d = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$d = "Closest numbers are {{{LOWER}}} pages and {{{HIGHER}}} pages ";
var rangedMinInputValueErrorForBooklets$d = "The minimum number is {{{MINIMUM}}} pages ";
var rangedMaxInputValueErrorForBooklets$d = "The maximum number is {{{MAXIMUM}}} pages ";
var requiredAttributeFieldErrorForBooklets$d = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} pages, including cover ";
var requiredInformationToast$d = "Please provide all required information.";
var quantityComboboxHelperText$d = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$d = "Show pricing guide";
var quantityComboboxPricingGuide$d = "Pricing guide";
var quantityComboboxFlyoutConfirmation$d = "Confirm";
var quantityComboboxFlyoutCancel$d = "Cancel";
var quantityComboboxPlaceholderText = "Enter quantity...";
var enUs = {
	quantityLabel: quantityLabel$d,
	quantityFlyoutHeader: quantityFlyoutHeader$d,
	quantityFlyoutCTA: quantityFlyoutCTA$d,
	closeButton: closeButton$d,
	pricePlaceholder: pricePlaceholder$d,
	priceLabel: priceLabel$d,
	unitPriceLabel: unitPriceLabel$d,
	incompatibilityMessage: incompatibilityMessage$d,
	select: select$d,
	percentSavings: percentSavings$d,
	sale: sale$d,
	amountSavings: amountSavings$d,
	amountSavingsWithSale: amountSavingsWithSale$d,
	seeMoreQuantities: seeMoreQuantities$d,
	required: required$d,
	sample: sample$d,
	estimatedQuantity: estimatedQuantity$d,
	numberOfRecipients: numberOfRecipients$d,
	recommendedCallout: recommendedCallout$d,
	newCallout: newCallout$d,
	incompatibleLabel: incompatibleLabel$d,
	outOfStockCallout: outOfStockCallout$d,
	dismissAlert: dismissAlert$d,
	unwindingMessage_1: unwindingMessage_1$d,
	unwindingMessage_2: unwindingMessage_2$d,
	unwindingMessage_3: unwindingMessage_3$d,
	unwindingMessage_more: unwindingMessage_more$d,
	unwindingAlertMessage_1: unwindingAlertMessage_1$d,
	unwindingAlertMessage_2: unwindingAlertMessage_2$d,
	unwindingAlertMessage_3: unwindingAlertMessage_3$d,
	unwindingAlertMessage_more: unwindingAlertMessage_more$d,
	fullRangedHelperText: fullRangedHelperText$d,
	rangePartialRangedHelperText: rangePartialRangedHelperText$d,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$d,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$d,
	rangedGeneralInputError: rangedGeneralInputError$d,
	rangedBetweenRangesError: rangedBetweenRangesError$d,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$d,
	rangedMinInputValueError: rangedMinInputValueError$d,
	rangedMaxInputValueError: rangedMaxInputValueError$d,
	rangedNotANumberError: rangedNotANumberError$d,
	requiredAttributeFieldError: requiredAttributeFieldError$d,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$d,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$d,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$d,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$d,
	requiredInformationToast: requiredInformationToast$d,
	quantityComboboxHelperText: quantityComboboxHelperText$d,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$d,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$d,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$d,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$d,
	quantityComboboxPlaceholderText: quantityComboboxPlaceholderText
};

var quantityLabel$c = "Antal";
var quantityFlyoutHeader$c = "Vælg antal";
var quantityFlyoutCTA$c = "Vælg dette antal";
var closeButton$c = "Luk";
var pricePlaceholder$c = "...";
var priceLabel$c = "Pris";
var unitPriceLabel$c = "Stykpris";
var incompatibilityMessage$c = "Ikke tilgængelig sammen med andre valg: ";
var select$c = "Vælg...";
var percentSavings$c = "{{{PERCENT}}}% besparelser";
var sale$c = "udsalg";
var amountSavings$c = "{{{AMOUNT}}} besparelser/stk.";
var amountSavingsWithSale$c = "{{{AMOUNT}}} besparelser/stk. + udsalg";
var seeMoreQuantities$c = "Se flere mængder";
var required$c = "Skal udfyldes";
var sample$c = "Vareprøve";
var estimatedQuantity$c = "Estimeret antal";
var numberOfRecipients$c = "{{{COUNT}}} Modtagere";
var recommendedCallout$c = "Anbefalet";
var newCallout$c = "Nyt";
var incompatibleLabel$c = "Inkompatibel";
var outOfStockCallout$c = "Ikke på lager";
var dismissAlert$c = "Luk meddelelse";
var unwindingMessage_1$c = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$c = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$c = "Inkompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$c = "Inkompatibel med mere end {{{ATTRIBUTE_COUNT}}} valgmuligheder.";
var unwindingAlertMessage_1$c = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} blev fravalgt.";
var unwindingAlertMessage_2$c = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}} blev fravalgt.";
var unwindingAlertMessage_3$c = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}} blev fravalgt.";
var unwindingAlertMessage_more$c = "For at være kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: Mere end {{{ATTRIBUTE_COUNT}}} valgmuligheder blev fravalgt.";
var fullRangedHelperText$c = "{{{MINIMUM}}} {{{UNIT}}} til {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$c = "Mindst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$c = "Indtast en værdi mellem {{{MINIMUM}}} og {{{MAXIMUM}}} sider, inklusive forside ";
var rangePartialRangedHelperTextForBooklets$c = "Mindst {{{MINIMUM}}} sider, inklusive forside ";
var rangedGeneralInputError$c = "Inputtet er ugyldigt";
var rangedBetweenRangesError$c = "De nærmeste tal er {{{LOWER}}} {{{UNIT}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$c = "Tallet må ikke have over 8 decimaler";
var rangedMinInputValueError$c = "Minimumtallet er {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$c = "Maksimumtallet er {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$c = "Det indtastede skal være et tal";
var requiredAttributeFieldError$c = "Indtast en værdi mellem {{{LOWER}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$c = "Det tætteste antal er {{{LOWER}}} sider og {{{HIGHER}}} sider ";
var rangedMinInputValueErrorForBooklets$c = "Minimumsantallet er {{{MINIMUM}}} sider ";
var rangedMaxInputValueErrorForBooklets$c = "Maksimumsantallet er {{{MAXIMUM}}} sider ";
var requiredAttributeFieldErrorForBooklets$c = "Indtast en værdi mellem {{{LOWER}}} og {{{HIGHER}}} sider, inklusive forside ";
var requiredInformationToast$c = "Giv os alle de nødvendige oplysninger.";
var quantityComboboxHelperText$c = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$c = "Vis prisguide";
var quantityComboboxPricingGuide$c = "Prisguide";
var quantityComboboxFlyoutConfirmation$c = "Bekræft";
var quantityComboboxFlyoutCancel$c = "Annuller";
var daDk = {
	quantityLabel: quantityLabel$c,
	quantityFlyoutHeader: quantityFlyoutHeader$c,
	quantityFlyoutCTA: quantityFlyoutCTA$c,
	closeButton: closeButton$c,
	pricePlaceholder: pricePlaceholder$c,
	priceLabel: priceLabel$c,
	unitPriceLabel: unitPriceLabel$c,
	incompatibilityMessage: incompatibilityMessage$c,
	select: select$c,
	percentSavings: percentSavings$c,
	sale: sale$c,
	amountSavings: amountSavings$c,
	amountSavingsWithSale: amountSavingsWithSale$c,
	seeMoreQuantities: seeMoreQuantities$c,
	required: required$c,
	sample: sample$c,
	estimatedQuantity: estimatedQuantity$c,
	numberOfRecipients: numberOfRecipients$c,
	recommendedCallout: recommendedCallout$c,
	newCallout: newCallout$c,
	incompatibleLabel: incompatibleLabel$c,
	outOfStockCallout: outOfStockCallout$c,
	dismissAlert: dismissAlert$c,
	unwindingMessage_1: unwindingMessage_1$c,
	unwindingMessage_2: unwindingMessage_2$c,
	unwindingMessage_3: unwindingMessage_3$c,
	unwindingMessage_more: unwindingMessage_more$c,
	unwindingAlertMessage_1: unwindingAlertMessage_1$c,
	unwindingAlertMessage_2: unwindingAlertMessage_2$c,
	unwindingAlertMessage_3: unwindingAlertMessage_3$c,
	unwindingAlertMessage_more: unwindingAlertMessage_more$c,
	fullRangedHelperText: fullRangedHelperText$c,
	rangePartialRangedHelperText: rangePartialRangedHelperText$c,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$c,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$c,
	rangedGeneralInputError: rangedGeneralInputError$c,
	rangedBetweenRangesError: rangedBetweenRangesError$c,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$c,
	rangedMinInputValueError: rangedMinInputValueError$c,
	rangedMaxInputValueError: rangedMaxInputValueError$c,
	rangedNotANumberError: rangedNotANumberError$c,
	requiredAttributeFieldError: requiredAttributeFieldError$c,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$c,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$c,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$c,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$c,
	requiredInformationToast: requiredInformationToast$c,
	quantityComboboxHelperText: quantityComboboxHelperText$c,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$c,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$c,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$c,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$c
};

var quantityLabel$b = "Menge";
var quantityFlyoutHeader$b = "Bestellmenge auswählen";
var quantityFlyoutCTA$b = "Diese Menge auswählen";
var closeButton$b = "Schließen";
var pricePlaceholder$b = "...";
var priceLabel$b = "Preis";
var unitPriceLabel$b = "Stückpreis";
var incompatibilityMessage$b = "Nicht mit anderen Optionen verfügbar: ";
var select$b = "Auswählen...";
var percentSavings$b = "{{{PERCENT}}} % Ersparnis";
var sale$b = "Sale";
var amountSavings$b = "{{{AMOUNT}}} Ersparnis / Stück";
var amountSavingsWithSale$b = "{{{AMOUNT}}} Ersparnis / Stück + Sale";
var seeMoreQuantities$b = "Weitere Mengen";
var required$b = "Erforderlich";
var sample$b = "Muster";
var estimatedQuantity$b = "Voraussichtliche Menge";
var numberOfRecipients$b = "{{{COUNT}}} Personen";
var recommendedCallout$b = "Unsere Empfehlung";
var newCallout$b = "Neu";
var incompatibleLabel$b = "Nicht kombinierbar";
var outOfStockCallout$b = "Nicht auf Lager";
var dismissAlert$b = "Warnung schließen";
var unwindingMessage_1$b = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$b = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}} und {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$b = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} und {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$b = "Nicht kombinierbar mit mehr als {{{ATTRIBUTE_COUNT}}} Optionen.";
var unwindingAlertMessage_1$b = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurde {{{ATTRIBUTE1}}} {{{OPTION1}}} abgewählt.";
var unwindingAlertMessage_2$b = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden {{{ATTRIBUTE1}}} {{{OPTION1}}} und {{{ATTRIBUTE2}}} {{{OPTION2}}} abgewählt.";
var unwindingAlertMessage_3$b = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} und {{{ATTRIBUTE3}}} {{{OPTION3}}} abgewählt.";
var unwindingAlertMessage_more$b = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden mehr als {{{ATTRIBUTE_COUNT}}} Optionen abgewählt.";
var fullRangedHelperText$b = "{{{MINIMUM}}} {{{UNIT}}} bis {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$b = "Mindestens {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$b = "Geben Sie einen Wert zwischen {{{MINIMUM}}} und {{{MAXIMUM}}} für die Anzahl Seiten ein, einschließlich Einband ";
var rangePartialRangedHelperTextForBooklets$b = "Mindestens {{{MINIMUM}}} Seiten, einschließlich Einband ";
var rangedGeneralInputError$b = "Eingabe ist ungültig";
var rangedBetweenRangesError$b = "Die nächsten Werte sind {{{LOWER}}} {{{UNIT}}} und {{{HIGHER}}} {{{UNIT}}}.";
var rangedDecimalPrecisionError$b = "Die Zahl darf nicht mehr als acht Dezimalstellen aufweisen.";
var rangedMinInputValueError$b = "Die kleinste Zahl ist {{{MINIMUM}}} {{{UNIT}}}.";
var rangedMaxInputValueError$b = "Die größte Zahl ist {{{MAXIMUM}}} {{{UNIT}}}.";
var rangedNotANumberError$b = "Eingabe muss eine Zahl sein";
var requiredAttributeFieldError$b = "Geben Sie einen Wert zwischen {{{LOWER}}} und {{{HIGHER}}} {{{UNIT}}} ein";
var rangedBetweenRangesErrorForBooklets$b = "Die nächstkleinere Zahl ist {{{LOWER}}} Seiten und die nächstgrößere {{{HIGHER}}} Seiten ";
var rangedMinInputValueErrorForBooklets$b = "Die kleinste Zahl ist {{{MINIMUM}}} Seiten ";
var rangedMaxInputValueErrorForBooklets$b = "Die größte Zahl ist {{{MAXIMUM}}} Seiten ";
var requiredAttributeFieldErrorForBooklets$b = "Geben Sie einen Wert zwischen {{{LOWER}}} und {{{HIGHER}}} für die Anzahl Seiten ein, einschließlich Einband ";
var requiredInformationToast$b = "Bitte geben Sie alle notwendigen Informationen an.";
var quantityComboboxHelperText$b = "Mindestens {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$b = "Preisliste anzeigen";
var quantityComboboxPricingGuide$b = "Preisliste";
var quantityComboboxFlyoutConfirmation$b = "Bestätigen";
var quantityComboboxFlyoutCancel$b = "Abbrechen";
var deDe = {
	quantityLabel: quantityLabel$b,
	quantityFlyoutHeader: quantityFlyoutHeader$b,
	quantityFlyoutCTA: quantityFlyoutCTA$b,
	closeButton: closeButton$b,
	pricePlaceholder: pricePlaceholder$b,
	priceLabel: priceLabel$b,
	unitPriceLabel: unitPriceLabel$b,
	incompatibilityMessage: incompatibilityMessage$b,
	select: select$b,
	percentSavings: percentSavings$b,
	sale: sale$b,
	amountSavings: amountSavings$b,
	amountSavingsWithSale: amountSavingsWithSale$b,
	seeMoreQuantities: seeMoreQuantities$b,
	required: required$b,
	sample: sample$b,
	estimatedQuantity: estimatedQuantity$b,
	numberOfRecipients: numberOfRecipients$b,
	recommendedCallout: recommendedCallout$b,
	newCallout: newCallout$b,
	incompatibleLabel: incompatibleLabel$b,
	outOfStockCallout: outOfStockCallout$b,
	dismissAlert: dismissAlert$b,
	unwindingMessage_1: unwindingMessage_1$b,
	unwindingMessage_2: unwindingMessage_2$b,
	unwindingMessage_3: unwindingMessage_3$b,
	unwindingMessage_more: unwindingMessage_more$b,
	unwindingAlertMessage_1: unwindingAlertMessage_1$b,
	unwindingAlertMessage_2: unwindingAlertMessage_2$b,
	unwindingAlertMessage_3: unwindingAlertMessage_3$b,
	unwindingAlertMessage_more: unwindingAlertMessage_more$b,
	fullRangedHelperText: fullRangedHelperText$b,
	rangePartialRangedHelperText: rangePartialRangedHelperText$b,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$b,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$b,
	rangedGeneralInputError: rangedGeneralInputError$b,
	rangedBetweenRangesError: rangedBetweenRangesError$b,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$b,
	rangedMinInputValueError: rangedMinInputValueError$b,
	rangedMaxInputValueError: rangedMaxInputValueError$b,
	rangedNotANumberError: rangedNotANumberError$b,
	requiredAttributeFieldError: requiredAttributeFieldError$b,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$b,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$b,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$b,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$b,
	requiredInformationToast: requiredInformationToast$b,
	quantityComboboxHelperText: quantityComboboxHelperText$b,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$b,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$b,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$b,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$b
};

var quantityLabel$a = "Quantity";
var quantityFlyoutHeader$a = "Choose your quantity";
var quantityFlyoutCTA$a = "Select this quantity";
var closeButton$a = "Close";
var pricePlaceholder$a = "...";
var priceLabel$a = "Price";
var unitPriceLabel$a = "Unit price";
var incompatibilityMessage$a = "Not available with other selections: ";
var select$a = "Select...";
var percentSavings$a = "{{{PERCENT}}}% savings";
var sale$a = "sale";
var amountSavings$a = "{{{AMOUNT}}} savings/unit";
var amountSavingsWithSale$a = "{{{AMOUNT}}} savings/unit + sale";
var seeMoreQuantities$a = "See more quantities";
var required$a = "Required";
var sample$a = "Sample";
var estimatedQuantity$a = "Estimated quantity";
var numberOfRecipients$a = "{{{COUNT}}} Recipients";
var recommendedCallout$a = "Recommended";
var newCallout$a = "New";
var incompatibleLabel$a = "Incompatible";
var outOfStockCallout$a = "Out of stock";
var dismissAlert$a = "Dismiss alert";
var unwindingMessage_1$a = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$a = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$a = "Incompatible with {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$a = "Incompatible with more than {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1$a = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} was unselected.";
var unwindingAlertMessage_2$a = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} & {{{ATTRIBUTE2}}} {{{OPTION2}}} were unselected.";
var unwindingAlertMessage_3$a = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} & {{{ATTRIBUTE3}}} {{{OPTION3}}} were unselected.";
var unwindingAlertMessage_more$a = "To be compatible with {{{ATTRIBUTE}}} {{{OPTION}}}: More than {{{ATTRIBUTE_COUNT}}} options were unselected.";
var fullRangedHelperText$a = "{{{MINIMUM}}} {{{UNIT}}} to {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$a = "At least {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$a = "Enter a value between {{{MINIMUM}}} to {{{MAXIMUM}}} pages, including cover ";
var rangePartialRangedHelperTextForBooklets$a = "At least {{{MINIMUM}}} pages, including cover ";
var rangedGeneralInputError$a = "Input is invalid";
var rangedBetweenRangesError$a = "Closest numbers are {{{LOWER}}} {{{UNIT}}} and {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$a = "Number can't exceed 8 decimals";
var rangedMinInputValueError$a = "The minimum number is {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$a = "The maximum number is {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$a = "Input must be a number";
var requiredAttributeFieldError$a = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$a = "Closest numbers are {{{LOWER}}} pages and {{{HIGHER}}} pages ";
var rangedMinInputValueErrorForBooklets$a = "The minimum number is {{{MINIMUM}}} pages ";
var rangedMaxInputValueErrorForBooklets$a = "The maximum number is {{{MAXIMUM}}} pages ";
var requiredAttributeFieldErrorForBooklets$a = "Enter a value between {{{LOWER}}} to {{{HIGHER}}} pages, including cover ";
var requiredInformationToast$a = "Please provide all required information.";
var quantityComboboxHelperText$a = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$a = "Show pricing guide";
var quantityComboboxPricingGuide$a = "Pricing guide";
var quantityComboboxFlyoutConfirmation$a = "Confirm";
var quantityComboboxFlyoutCancel$a = "Cancel";
var enGb = {
	quantityLabel: quantityLabel$a,
	quantityFlyoutHeader: quantityFlyoutHeader$a,
	quantityFlyoutCTA: quantityFlyoutCTA$a,
	closeButton: closeButton$a,
	pricePlaceholder: pricePlaceholder$a,
	priceLabel: priceLabel$a,
	unitPriceLabel: unitPriceLabel$a,
	incompatibilityMessage: incompatibilityMessage$a,
	select: select$a,
	percentSavings: percentSavings$a,
	sale: sale$a,
	amountSavings: amountSavings$a,
	amountSavingsWithSale: amountSavingsWithSale$a,
	seeMoreQuantities: seeMoreQuantities$a,
	required: required$a,
	sample: sample$a,
	estimatedQuantity: estimatedQuantity$a,
	numberOfRecipients: numberOfRecipients$a,
	recommendedCallout: recommendedCallout$a,
	newCallout: newCallout$a,
	incompatibleLabel: incompatibleLabel$a,
	outOfStockCallout: outOfStockCallout$a,
	dismissAlert: dismissAlert$a,
	unwindingMessage_1: unwindingMessage_1$a,
	unwindingMessage_2: unwindingMessage_2$a,
	unwindingMessage_3: unwindingMessage_3$a,
	unwindingMessage_more: unwindingMessage_more$a,
	unwindingAlertMessage_1: unwindingAlertMessage_1$a,
	unwindingAlertMessage_2: unwindingAlertMessage_2$a,
	unwindingAlertMessage_3: unwindingAlertMessage_3$a,
	unwindingAlertMessage_more: unwindingAlertMessage_more$a,
	fullRangedHelperText: fullRangedHelperText$a,
	rangePartialRangedHelperText: rangePartialRangedHelperText$a,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$a,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$a,
	rangedGeneralInputError: rangedGeneralInputError$a,
	rangedBetweenRangesError: rangedBetweenRangesError$a,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$a,
	rangedMinInputValueError: rangedMinInputValueError$a,
	rangedMaxInputValueError: rangedMaxInputValueError$a,
	rangedNotANumberError: rangedNotANumberError$a,
	requiredAttributeFieldError: requiredAttributeFieldError$a,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$a,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$a,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$a,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$a,
	requiredInformationToast: requiredInformationToast$a,
	quantityComboboxHelperText: quantityComboboxHelperText$a,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$a,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$a,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$a,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$a
};

var quantityLabel$9 = "Cantidad";
var quantityFlyoutHeader$9 = "Elige la cantidad";
var quantityFlyoutCTA$9 = "Selecciona esta cantidad";
var closeButton$9 = "Cerrar";
var pricePlaceholder$9 = "…";
var priceLabel$9 = "Precio";
var unitPriceLabel$9 = "Precio unitario";
var incompatibilityMessage$9 = "No disponible con otras selecciones: ";
var select$9 = "Elegir…";
var percentSavings$9 = "{{{PERCENT}}}% de ahorro";
var sale$9 = "rebajas";
var amountSavings$9 = "{{{AMOUNT}}} de ahorro / unidad";
var amountSavingsWithSale$9 = "{{{AMOUNT}}} de ahorro / unidad + descuento";
var seeMoreQuantities$9 = "Ver más cantidades";
var required$9 = "Obligatorio";
var sample$9 = "Muestra";
var estimatedQuantity$9 = "Cantidad estimada";
var numberOfRecipients$9 = "{{{COUNT}}} destinatarios";
var recommendedCallout$9 = "Recomendado";
var newCallout$9 = "Novedad";
var incompatibleLabel$9 = "Incompatible";
var outOfStockCallout$9 = "Agotado";
var dismissAlert$9 = "Descartar alerta";
var unwindingMessage_1$9 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}}.";
var unwindingMessage_2$9 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}} y {{{OPTION2}}} {{{ATTRIBUTE2}}}.";
var unwindingMessage_3$9 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}}, {{{OPTION2}}} {{{ATTRIBUTE2}}} y {{{OPTION3}}} {{{ATTRIBUTE3}}}.";
var unwindingMessage_more$9 = "Incompatible con más de {{{ATTRIBUTE_COUNT}}} opciones.";
var unwindingAlertMessage_1$9 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se ha deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}}.";
var unwindingAlertMessage_2$9 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}} y {{{OPTION2}}} {{{ATTRIBUTE2}}}.";
var unwindingAlertMessage_3$9 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}}, {{{OPTION2}}} {{{ATTRIBUTE2}}} y {{{OPTION3}}} {{{ATTRIBUTE3}}}.";
var unwindingAlertMessage_more$9 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado más de {{{ATTRIBUTE_COUNT}}} opciones.";
var fullRangedHelperText$9 = "De {{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$9 = "Al menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$9 = "Introduce un número de páginas entre {{{MINIMUM}}} y {{{MAXIMUM}}} (portada incluida) ";
var rangePartialRangedHelperTextForBooklets$9 = "Al menos {{{MINIMUM}}} páginas (portada incluida) ";
var rangedGeneralInputError$9 = "El valor de entrada no es válido";
var rangedBetweenRangesError$9 = "Los números más cercanos son {{{LOWER}}} {{{UNIT}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$9 = "El número no puede exceder los 8 decimales";
var rangedMinInputValueError$9 = "El número mínimo es {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$9 = "El número máximo es {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$9 = "El valor de entrada debe ser un número";
var requiredAttributeFieldError$9 = "Introduce un valor entre {{{LOWER}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$9 = "Los números más cercanos son {{{LOWER}}} páginas y {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets$9 = "El número mínimo es {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets$9 = "El número máximo es {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets$9 = "Introduce un número de páginas entre {{{LOWER}}} y {{{HIGHER}}} (portada incluida) ";
var requiredInformationToast$9 = "Por favor, indica toda la información obligatoria.";
var quantityComboboxHelperText$9 = "Mínimo: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$9 = "Mostrar la guía de precios";
var quantityComboboxPricingGuide$9 = "Guía de precios";
var quantityComboboxFlyoutConfirmation$9 = "Confirmar";
var quantityComboboxFlyoutCancel$9 = "Cancelar";
var esEs = {
	quantityLabel: quantityLabel$9,
	quantityFlyoutHeader: quantityFlyoutHeader$9,
	quantityFlyoutCTA: quantityFlyoutCTA$9,
	closeButton: closeButton$9,
	pricePlaceholder: pricePlaceholder$9,
	priceLabel: priceLabel$9,
	unitPriceLabel: unitPriceLabel$9,
	incompatibilityMessage: incompatibilityMessage$9,
	select: select$9,
	percentSavings: percentSavings$9,
	sale: sale$9,
	amountSavings: amountSavings$9,
	amountSavingsWithSale: amountSavingsWithSale$9,
	seeMoreQuantities: seeMoreQuantities$9,
	required: required$9,
	sample: sample$9,
	estimatedQuantity: estimatedQuantity$9,
	numberOfRecipients: numberOfRecipients$9,
	recommendedCallout: recommendedCallout$9,
	newCallout: newCallout$9,
	incompatibleLabel: incompatibleLabel$9,
	outOfStockCallout: outOfStockCallout$9,
	dismissAlert: dismissAlert$9,
	unwindingMessage_1: unwindingMessage_1$9,
	unwindingMessage_2: unwindingMessage_2$9,
	unwindingMessage_3: unwindingMessage_3$9,
	unwindingMessage_more: unwindingMessage_more$9,
	unwindingAlertMessage_1: unwindingAlertMessage_1$9,
	unwindingAlertMessage_2: unwindingAlertMessage_2$9,
	unwindingAlertMessage_3: unwindingAlertMessage_3$9,
	unwindingAlertMessage_more: unwindingAlertMessage_more$9,
	fullRangedHelperText: fullRangedHelperText$9,
	rangePartialRangedHelperText: rangePartialRangedHelperText$9,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$9,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$9,
	rangedGeneralInputError: rangedGeneralInputError$9,
	rangedBetweenRangesError: rangedBetweenRangesError$9,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$9,
	rangedMinInputValueError: rangedMinInputValueError$9,
	rangedMaxInputValueError: rangedMaxInputValueError$9,
	rangedNotANumberError: rangedNotANumberError$9,
	requiredAttributeFieldError: requiredAttributeFieldError$9,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$9,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$9,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$9,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$9,
	requiredInformationToast: requiredInformationToast$9,
	quantityComboboxHelperText: quantityComboboxHelperText$9,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$9,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$9,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$9,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$9
};

var quantityLabel$8 = "Cantidad";
var quantityFlyoutHeader$8 = "Elija la cantidad";
var quantityFlyoutCTA$8 = "Seleccionar esta cantidad";
var closeButton$8 = "Cerrar";
var pricePlaceholder$8 = "...";
var priceLabel$8 = "Precio";
var unitPriceLabel$8 = "Precio unitario";
var incompatibilityMessage$8 = "No está disponible con otras opciones seleccionadas: ";
var select$8 = "Seleccionar...";
var percentSavings$8 = "{{{PERCENT}}}% de ahorro";
var sale$8 = "ofertas";
var amountSavings$8 = "ahorro de {{{AMOUNT}}}/unidad";
var amountSavingsWithSale$8 = "ahorro de {{{AMOUNT}}}/unidad + oferta";
var seeMoreQuantities$8 = "Ver más cantidades";
var required$8 = "Obligatorio";
var sample$8 = "Muestra";
var estimatedQuantity$8 = "Cantidad estimada";
var numberOfRecipients$8 = "{{{COUNT}}} destinatarios";
var recommendedCallout$8 = "Recomendado";
var newCallout$8 = "Nuevo";
var incompatibleLabel$8 = "No es compatible";
var outOfStockCallout$8 = "Agotado";
var dismissAlert$8 = "Descartar alerta";
var unwindingMessage_1$8 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$8 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}} y {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$8 = "No es compatible con {{{ATTRIBUTE1}}} {{{OPTION1}}},{{{ATTRIBUTE2}}} {{{OPTION2}}} y {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$8 = "No es compatible con más de {{{ATTRIBUTE_COUNT}}} opciones.";
var unwindingAlertMessage_1$8 = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingAlertMessage_2$8 = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}} y {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingAlertMessage_3$8 = "Para que sea compatible con {{{ATTRIBUTE}}}{{{OPTION}}}: se deseleccionó {{{ATTRIBUTE1}}} {{{OPTION1}}} , {{{ATTRIBUTE2}}}{{{OPTION2}}} y {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingAlertMessage_more$8 = "Para que sea compatible con {{{ATTRIBUTE}}} {{{OPTION}}}: Se deseleccionaron más de {{{ATTRIBUTE_COUNT}}} opciones.";
var fullRangedHelperText$8 = "{{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$8 = "Por lo menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$8 = "Ingrese una cantidad entre {{{MINIMUM}}} a {{{MAXIMUM}}} páginas, incluyendo la cubierta ";
var rangePartialRangedHelperTextForBooklets$8 = "Por lo menos {{{MINIMUM}}} páginas, incluyendo la cubierta ";
var rangedGeneralInputError$8 = "El dato ingresado no es válido";
var rangedBetweenRangesError$8 = "Los números más cercanos son {{{LOWER}}} {{{UNIT}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$8 = "El número no puede sobrepasar 8 decimales";
var rangedMinInputValueError$8 = "El número mínimo es {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$8 = "El número máximo es {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$8 = "El dato ingresado debe ser un número";
var requiredAttributeFieldError$8 = "Ingresar una cantidad entre {{{LOWER}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$8 = "Los números más cercanos son de {{{LOWER}}} páginas y {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets$8 = "El número mínimo es de {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets$8 = "El número máximo es de {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets$8 = "Ingrese una cantidad entre {{{LOWER}}} a {{{HIGHER}}} páginas, incluyendo la cubierta ";
var requiredInformationToast$8 = "Proporcione toda la información obligatoria.";
var quantityComboboxHelperText$8 = "Mínimo: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$8 = "Ver guía de precios";
var quantityComboboxPricingGuide$8 = "Guía de precios";
var quantityComboboxFlyoutConfirmation$8 = "Confirmar";
var quantityComboboxFlyoutCancel$8 = "Cancelar";
var esUs = {
	quantityLabel: quantityLabel$8,
	quantityFlyoutHeader: quantityFlyoutHeader$8,
	quantityFlyoutCTA: quantityFlyoutCTA$8,
	closeButton: closeButton$8,
	pricePlaceholder: pricePlaceholder$8,
	priceLabel: priceLabel$8,
	unitPriceLabel: unitPriceLabel$8,
	incompatibilityMessage: incompatibilityMessage$8,
	select: select$8,
	percentSavings: percentSavings$8,
	sale: sale$8,
	amountSavings: amountSavings$8,
	amountSavingsWithSale: amountSavingsWithSale$8,
	seeMoreQuantities: seeMoreQuantities$8,
	required: required$8,
	sample: sample$8,
	estimatedQuantity: estimatedQuantity$8,
	numberOfRecipients: numberOfRecipients$8,
	recommendedCallout: recommendedCallout$8,
	newCallout: newCallout$8,
	incompatibleLabel: incompatibleLabel$8,
	outOfStockCallout: outOfStockCallout$8,
	dismissAlert: dismissAlert$8,
	unwindingMessage_1: unwindingMessage_1$8,
	unwindingMessage_2: unwindingMessage_2$8,
	unwindingMessage_3: unwindingMessage_3$8,
	unwindingMessage_more: unwindingMessage_more$8,
	unwindingAlertMessage_1: unwindingAlertMessage_1$8,
	unwindingAlertMessage_2: unwindingAlertMessage_2$8,
	unwindingAlertMessage_3: unwindingAlertMessage_3$8,
	unwindingAlertMessage_more: unwindingAlertMessage_more$8,
	fullRangedHelperText: fullRangedHelperText$8,
	rangePartialRangedHelperText: rangePartialRangedHelperText$8,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$8,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$8,
	rangedGeneralInputError: rangedGeneralInputError$8,
	rangedBetweenRangesError: rangedBetweenRangesError$8,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$8,
	rangedMinInputValueError: rangedMinInputValueError$8,
	rangedMaxInputValueError: rangedMaxInputValueError$8,
	rangedNotANumberError: rangedNotANumberError$8,
	requiredAttributeFieldError: requiredAttributeFieldError$8,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$8,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$8,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$8,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$8,
	requiredInformationToast: requiredInformationToast$8,
	quantityComboboxHelperText: quantityComboboxHelperText$8,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$8,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$8,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$8,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$8
};

var quantityLabel$7 = "Määrä";
var quantityFlyoutHeader$7 = "Valitse haluamasi määrä";
var quantityFlyoutCTA$7 = "Valitse tämä määrä";
var closeButton$7 = "Sulje";
var pricePlaceholder$7 = "...";
var priceLabel$7 = "Hinta";
var unitPriceLabel$7 = "Yksikköhinta";
var incompatibilityMessage$7 = "Ei saatavilla muiden valintojen kohdalla: ";
var select$7 = "Valitse...";
var percentSavings$7 = "{{{PERCENT}}} %:n säästöt";
var sale$7 = "Ale";
var amountSavings$7 = "{{{AMOUNT}}} %:n säästöt/kpl";
var amountSavingsWithSale$7 = "{{{AMOUNT}}} %:n säästöt/kpl + ale";
var seeMoreQuantities$7 = "Katso lisää kappalemääriä";
var required$7 = "Vaaditaan";
var sample$7 = "Näytekappale";
var estimatedQuantity$7 = "Arvioitu määrä";
var numberOfRecipients$7 = "{{{COUNT}}} Vastaanottajat";
var recommendedCallout$7 = "Suositellut";
var newCallout$7 = "Uutta";
var incompatibleLabel$7 = "Yhteensopimaton";
var outOfStockCallout$7 = "Tilapäisesti lopussa";
var dismissAlert$7 = "Ohita ilmoitus";
var unwindingMessage_1$7 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$7 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}} ja {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$7 = "Yhteensopimaton seuraavien kanssa: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} ja {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$7 = "Yhteensopimaton useamman kuin {{{ATTRIBUTE_COUNT}}} vaihtoehdon kanssa.";
var unwindingAlertMessage_1$7 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} poistettu.";
var unwindingAlertMessage_2$7 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} ja {{{ATTRIBUTE2}}} {{{OPTION2}}} poistettu.";
var unwindingAlertMessage_3$7 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} ja {{{ATTRIBUTE3}}} {{{OPTION3}}} poistettu.";
var unwindingAlertMessage_more$7 = "Yhteensopiva seuraavien kanssa: {{{ATTRIBUTE}}} {{{OPTION}}}: Useampi kuin {{{ATTRIBUTE_COUNT}}} vaihtoehtoa poistettu.";
var fullRangedHelperText$7 = "{{{MINIMUM}}} {{{UNIT}}} vastaanottaja {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$7 = "Vähintään {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$7 = "Syötä arvo väliltä {{{MINIMUM}}}–{{{MAXIMUM}}} sivua, kansi mukaan lukien ";
var rangePartialRangedHelperTextForBooklets$7 = "Vähintään {{{MINIMUM}}} sivua, kansi mukaan lukien ";
var rangedGeneralInputError$7 = "Tieto on virheellinen";
var rangedBetweenRangesError$7 = "Lähimmät numerot ovat {{{LOWER}}} {{{UNIT}}} ja {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$7 = "Luku ei saa ylittää kahdeksaa desimaalia";
var rangedMinInputValueError$7 = "Vähimmäisluku on {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$7 = "Enimmäisluku on {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$7 = "Syötteen on oltava numero";
var requiredAttributeFieldError$7 = "Anna arvo välillä {{{LOWER}}} ja {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$7 = "Lähimmät numerot ovat {{{LOWER}}} sivua ja {{{HIGHER}}} sivua ";
var rangedMinInputValueErrorForBooklets$7 = "Vähimmäisluku on {{{MINIMUM}}} sivua ";
var rangedMaxInputValueErrorForBooklets$7 = "Enimmäisluku on {{{MAXIMUM}}} sivua ";
var requiredAttributeFieldErrorForBooklets$7 = "Syötä arvo väliltä {{{LOWER}}}–{{{HIGHER}}} sivua, kansi mukaan lukien ";
var requiredInformationToast$7 = "Anna kaikki tarvittavat tiedot.";
var quantityComboboxHelperText$7 = "Minimi: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$7 = "Näytä hinnoitteluopas";
var quantityComboboxPricingGuide$7 = "Hinnoitteluopas";
var quantityComboboxFlyoutConfirmation$7 = "Vahvista";
var quantityComboboxFlyoutCancel$7 = "Peruuta";
var fiFi = {
	quantityLabel: quantityLabel$7,
	quantityFlyoutHeader: quantityFlyoutHeader$7,
	quantityFlyoutCTA: quantityFlyoutCTA$7,
	closeButton: closeButton$7,
	pricePlaceholder: pricePlaceholder$7,
	priceLabel: priceLabel$7,
	unitPriceLabel: unitPriceLabel$7,
	incompatibilityMessage: incompatibilityMessage$7,
	select: select$7,
	percentSavings: percentSavings$7,
	sale: sale$7,
	amountSavings: amountSavings$7,
	amountSavingsWithSale: amountSavingsWithSale$7,
	seeMoreQuantities: seeMoreQuantities$7,
	required: required$7,
	sample: sample$7,
	estimatedQuantity: estimatedQuantity$7,
	numberOfRecipients: numberOfRecipients$7,
	recommendedCallout: recommendedCallout$7,
	newCallout: newCallout$7,
	incompatibleLabel: incompatibleLabel$7,
	outOfStockCallout: outOfStockCallout$7,
	dismissAlert: dismissAlert$7,
	unwindingMessage_1: unwindingMessage_1$7,
	unwindingMessage_2: unwindingMessage_2$7,
	unwindingMessage_3: unwindingMessage_3$7,
	unwindingMessage_more: unwindingMessage_more$7,
	unwindingAlertMessage_1: unwindingAlertMessage_1$7,
	unwindingAlertMessage_2: unwindingAlertMessage_2$7,
	unwindingAlertMessage_3: unwindingAlertMessage_3$7,
	unwindingAlertMessage_more: unwindingAlertMessage_more$7,
	fullRangedHelperText: fullRangedHelperText$7,
	rangePartialRangedHelperText: rangePartialRangedHelperText$7,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$7,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$7,
	rangedGeneralInputError: rangedGeneralInputError$7,
	rangedBetweenRangesError: rangedBetweenRangesError$7,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$7,
	rangedMinInputValueError: rangedMinInputValueError$7,
	rangedMaxInputValueError: rangedMaxInputValueError$7,
	rangedNotANumberError: rangedNotANumberError$7,
	requiredAttributeFieldError: requiredAttributeFieldError$7,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$7,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$7,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$7,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$7,
	requiredInformationToast: requiredInformationToast$7,
	quantityComboboxHelperText: quantityComboboxHelperText$7,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$7,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$7,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$7,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$7
};

var quantityLabel$6 = "Quantité";
var quantityFlyoutHeader$6 = "Choisissez la quantité";
var quantityFlyoutCTA$6 = "Sélectionner cette quantité";
var closeButton$6 = "Fermer";
var pricePlaceholder$6 = "...";
var priceLabel$6 = "Prix";
var unitPriceLabel$6 = "Prix ​​unitaire";
var incompatibilityMessage$6 = "Non disponible avec les autres sélections : ";
var select$6 = "Sélectionnez...";
var percentSavings$6 = "{{{PERCENT}}}% d’économie";
var sale$6 = "solde";
var amountSavings$6 = "{{{AMOUNT}}}% d’économie/unité";
var amountSavingsWithSale$6 = "{{{AMOUNT}}}% d’économie/unité + solde";
var seeMoreQuantities$6 = "Afficher plus de quantités";
var required$6 = "Obligatoire";
var sample$6 = "Échantillon";
var estimatedQuantity$6 = "Quantité estimée";
var numberOfRecipients$6 = "{{{COUNT}}} destinataires";
var recommendedCallout$6 = "Recommandé";
var newCallout$6 = "Nouveau";
var incompatibleLabel$6 = "Incompatible";
var outOfStockCallout$6 = "En rupture de stock";
var dismissAlert$6 = "Ignorer l’alerte";
var unwindingMessage_1$6 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$6 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$6 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$6 = "Incompatible avec plus de {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1$6 = "Pour être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} a été désélectionné.";
var unwindingAlertMessage_2$6 = "Pour être compatibles avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}} ont été désélectionnés.";
var unwindingAlertMessage_3$6 = "Pour être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}} ont été désélectionnés.";
var unwindingAlertMessage_more$6 = "Pour être compatibles avec {{{ATTRIBUTE}}} {{{OPTION}}} : plus de {{{ATTRIBUTE_COUNT}}} options ont été désélectionnées.";
var fullRangedHelperText$6 = "{{{MINIMUM}}} {{{UNIT}}} à {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$6 = "Au moins {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$6 = "Saisissez un nombre de pages compris entre {{{MINIMUM}}} et {{{MAXIMUM}}}, couverture incluse ";
var rangePartialRangedHelperTextForBooklets$6 = "Au moins {{{MINIMUM}}} pages, couverture incluse ";
var rangedGeneralInputError$6 = "L’entrée n’est pas valide";
var rangedBetweenRangesError$6 = "Les nombres les plus proches sont {{{LOWER}}} {{{UNIT}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$6 = "Le nombre ne peut pas dépasser 8 décimales";
var rangedMinInputValueError$6 = "Le nombre minimum est de {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$6 = "Le nombre maximum est de {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$6 = "L'entrée doit être un nombre";
var requiredAttributeFieldError$6 = "Saisir une valeur comprise entre {{{LOWER}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$6 = "Les nombres de pages les plus proches sont {{{LOWER}}} et {{{HIGHER}}} ";
var rangedMinInputValueErrorForBooklets$6 = "Le nombre minimum de pages est de {{{MINIMUM}}} ";
var rangedMaxInputValueErrorForBooklets$6 = "Le nombre maximum de pages est de {{{MAXIMUM}}} ";
var requiredAttributeFieldErrorForBooklets$6 = "Saisissez un nombre de pages compris entre {{{LOWER}}} et {{{HIGHER}}}, couverture incluse ";
var requiredInformationToast$6 = "Veuillez fournir toutes les informations requises.";
var quantityComboboxHelperText$6 = "Minimum : {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$6 = "Afficher le guide des prix";
var quantityComboboxPricingGuide$6 = "Guide des prix";
var quantityComboboxFlyoutConfirmation$6 = "Confirmer";
var quantityComboboxFlyoutCancel$6 = "Annuler";
var frCa = {
	quantityLabel: quantityLabel$6,
	quantityFlyoutHeader: quantityFlyoutHeader$6,
	quantityFlyoutCTA: quantityFlyoutCTA$6,
	closeButton: closeButton$6,
	pricePlaceholder: pricePlaceholder$6,
	priceLabel: priceLabel$6,
	unitPriceLabel: unitPriceLabel$6,
	incompatibilityMessage: incompatibilityMessage$6,
	select: select$6,
	percentSavings: percentSavings$6,
	sale: sale$6,
	amountSavings: amountSavings$6,
	amountSavingsWithSale: amountSavingsWithSale$6,
	seeMoreQuantities: seeMoreQuantities$6,
	required: required$6,
	sample: sample$6,
	estimatedQuantity: estimatedQuantity$6,
	numberOfRecipients: numberOfRecipients$6,
	recommendedCallout: recommendedCallout$6,
	newCallout: newCallout$6,
	incompatibleLabel: incompatibleLabel$6,
	outOfStockCallout: outOfStockCallout$6,
	dismissAlert: dismissAlert$6,
	unwindingMessage_1: unwindingMessage_1$6,
	unwindingMessage_2: unwindingMessage_2$6,
	unwindingMessage_3: unwindingMessage_3$6,
	unwindingMessage_more: unwindingMessage_more$6,
	unwindingAlertMessage_1: unwindingAlertMessage_1$6,
	unwindingAlertMessage_2: unwindingAlertMessage_2$6,
	unwindingAlertMessage_3: unwindingAlertMessage_3$6,
	unwindingAlertMessage_more: unwindingAlertMessage_more$6,
	fullRangedHelperText: fullRangedHelperText$6,
	rangePartialRangedHelperText: rangePartialRangedHelperText$6,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$6,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$6,
	rangedGeneralInputError: rangedGeneralInputError$6,
	rangedBetweenRangesError: rangedBetweenRangesError$6,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$6,
	rangedMinInputValueError: rangedMinInputValueError$6,
	rangedMaxInputValueError: rangedMaxInputValueError$6,
	rangedNotANumberError: rangedNotANumberError$6,
	requiredAttributeFieldError: requiredAttributeFieldError$6,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$6,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$6,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$6,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$6,
	requiredInformationToast: requiredInformationToast$6,
	quantityComboboxHelperText: quantityComboboxHelperText$6,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$6,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$6,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$6,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$6
};

var quantityLabel$5 = "Quantité";
var quantityFlyoutHeader$5 = "Choisissez la quantité";
var quantityFlyoutCTA$5 = "Choisir cette quantité";
var closeButton$5 = "Fermer";
var pricePlaceholder$5 = "...";
var priceLabel$5 = "Prix";
var unitPriceLabel$5 = "Prix unitaire";
var incompatibilityMessage$5 = "Non disponible avec vos autres choix : ";
var select$5 = "Sélectionner...";
var percentSavings$5 = "{{{PERCENT}}}% économisés";
var sale$5 = "offre exclusive";
var amountSavings$5 = "{{{AMOUNT}}} économisés / unité";
var amountSavingsWithSale$5 = "{{{AMOUNT}}} économisés / unité + promotion";
var seeMoreQuantities$5 = "Voir plus de quantités";
var required$5 = "Obligatoire";
var sample$5 = "Échantillon statistique";
var estimatedQuantity$5 = "Quantité estimée";
var numberOfRecipients$5 = "{{{COUNT}}} Destinataires";
var recommendedCallout$5 = "Recommandé";
var newCallout$5 = "Nouveau";
var incompatibleLabel$5 = "Incompatible";
var outOfStockCallout$5 = "En rupture de stock";
var dismissAlert$5 = "Ignorer le message d’alerte";
var unwindingMessage_1$5 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$5 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$5 = "Incompatible avec {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$5 = "Incompatible avec plus de {{{ATTRIBUTE_COUNT}}} options.";
var unwindingAlertMessage_1$5 = "Être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} n'a pas été sélectionné.";
var unwindingAlertMessage_2$5 = "Être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}} et {{{ATTRIBUTE2}}} {{{OPTION2}}} n'a pas été sélectionné.";
var unwindingAlertMessage_3$5 = "Être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} : {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} et {{{ATTRIBUTE3}}} {{{OPTION3}}} n'a pas été sélectionné.";
var unwindingAlertMessage_more$5 = "Être compatible avec {{{ATTRIBUTE}}} {{{OPTION}}} :  Plus de {{{ATTRIBUTE_COUNT}}} n'ont pas été sélectionnées.";
var fullRangedHelperText$5 = "{{{MINIMUM}}} {{{UNIT}}} à {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$5 = "Au moins {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$5 = "Saisissez une valeur comprise entre {{{MINIMUM}}} à {{{MAXIMUM}}} pages, couverture comprise ";
var rangePartialRangedHelperTextForBooklets$5 = "Au moins {{{MINIMUM}}} pages, couverture comprise ";
var rangedGeneralInputError$5 = "Entrée non valide";
var rangedBetweenRangesError$5 = "Les valeurs les plus proches sont {{{LOWER}}} {{{UNIT}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$5 = "Le nombre ne peut pas dépasser 8 décimales";
var rangedMinInputValueError$5 = "Nombre minimum : {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$5 = "Nombre maximum : {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$5 = "La valeur saisie doit être un nombre";
var requiredAttributeFieldError$5 = "Saisissez une valeur comprise entre {{{LOWER}}} et {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$5 = "Les valeurs les plus proches sont  {{{LOWER}}} pages et {{{HIGHER}}} pages ";
var rangedMinInputValueErrorForBooklets$5 = "Nombre minimum : {{{MINIMUM}}} pages ";
var rangedMaxInputValueErrorForBooklets$5 = "Nombre maximum : {{{MAXIMUM}}} pages ";
var requiredAttributeFieldErrorForBooklets$5 = "Saisissez une valeur comprise entre {{{LOWER}}} à {{{HIGHER}}} pages, couverture comprise ";
var requiredInformationToast$5 = "Veuillez fournir toutes les informations requises.";
var quantityComboboxHelperText$5 = "Minimum :{{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$5 = "Afficher le guide des prix";
var quantityComboboxPricingGuide$5 = "Guide des prix";
var quantityComboboxFlyoutConfirmation$5 = "Confirmer";
var quantityComboboxFlyoutCancel$5 = "Annuler";
var frFr = {
	quantityLabel: quantityLabel$5,
	quantityFlyoutHeader: quantityFlyoutHeader$5,
	quantityFlyoutCTA: quantityFlyoutCTA$5,
	closeButton: closeButton$5,
	pricePlaceholder: pricePlaceholder$5,
	priceLabel: priceLabel$5,
	unitPriceLabel: unitPriceLabel$5,
	incompatibilityMessage: incompatibilityMessage$5,
	select: select$5,
	percentSavings: percentSavings$5,
	sale: sale$5,
	amountSavings: amountSavings$5,
	amountSavingsWithSale: amountSavingsWithSale$5,
	seeMoreQuantities: seeMoreQuantities$5,
	required: required$5,
	sample: sample$5,
	estimatedQuantity: estimatedQuantity$5,
	numberOfRecipients: numberOfRecipients$5,
	recommendedCallout: recommendedCallout$5,
	newCallout: newCallout$5,
	incompatibleLabel: incompatibleLabel$5,
	outOfStockCallout: outOfStockCallout$5,
	dismissAlert: dismissAlert$5,
	unwindingMessage_1: unwindingMessage_1$5,
	unwindingMessage_2: unwindingMessage_2$5,
	unwindingMessage_3: unwindingMessage_3$5,
	unwindingMessage_more: unwindingMessage_more$5,
	unwindingAlertMessage_1: unwindingAlertMessage_1$5,
	unwindingAlertMessage_2: unwindingAlertMessage_2$5,
	unwindingAlertMessage_3: unwindingAlertMessage_3$5,
	unwindingAlertMessage_more: unwindingAlertMessage_more$5,
	fullRangedHelperText: fullRangedHelperText$5,
	rangePartialRangedHelperText: rangePartialRangedHelperText$5,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$5,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$5,
	rangedGeneralInputError: rangedGeneralInputError$5,
	rangedBetweenRangesError: rangedBetweenRangesError$5,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$5,
	rangedMinInputValueError: rangedMinInputValueError$5,
	rangedMaxInputValueError: rangedMaxInputValueError$5,
	rangedNotANumberError: rangedNotANumberError$5,
	requiredAttributeFieldError: requiredAttributeFieldError$5,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$5,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$5,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$5,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$5,
	requiredInformationToast: requiredInformationToast$5,
	quantityComboboxHelperText: quantityComboboxHelperText$5,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$5,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$5,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$5,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$5
};

var quantityLabel$4 = "Quantità";
var quantityFlyoutHeader$4 = "Scegli una quantità";
var quantityFlyoutCTA$4 = "Seleziona questa quantità";
var closeButton$4 = "Chiudi";
var pricePlaceholder$4 = "...";
var priceLabel$4 = "Prezzo";
var unitPriceLabel$4 = "Prezzo unitario";
var incompatibilityMessage$4 = "Ora disponibile con altre opzioni selezionate: ";
var select$4 = "Seleziona...";
var percentSavings$4 = "{{{PERCENT}}}% risparmiato";
var sale$4 = "saldi";
var amountSavings$4 = "{{{AMOUNT}}} risparmio / unità";
var amountSavingsWithSale$4 = "{{{AMOUNT}}} risparmio / unità + offerta";
var seeMoreQuantities$4 = "Vedi altre quantità";
var required$4 = "Obbligatorio";
var sample$4 = "Campione";
var estimatedQuantity$4 = "Quantità stimata";
var numberOfRecipients$4 = "{{{COUNT}}} Destinatari";
var recommendedCallout$4 = "Scelta consigliata";
var newCallout$4 = "Novità";
var incompatibleLabel$4 = "Incompatibile";
var outOfStockCallout$4 = "Articolo non disponibile";
var dismissAlert$4 = "Ignora avviso";
var unwindingMessage_1$4 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$4 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$4 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$4 = "Incompatibile con più di {{{ATTRIBUTE_COUNT}}} opzioni.";
var unwindingAlertMessage_1$4 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} è stato deselezionato.";
var unwindingAlertMessage_2$4 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}} sono stati deselezionati.";
var unwindingAlertMessage_3$4 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}} sono stati deselezionati.";
var unwindingAlertMessage_more$4 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: Sono state deselezionate più di {{{ATTRIBUTE_COUNT}}} opzioni.";
var fullRangedHelperText$4 = "Da {{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$4 = "Almeno {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$4 = "Inserisci un valore tra {{{MINIMUM}}} e {{{MAXIMUM}}} pagine, inclusa la copertina ";
var rangePartialRangedHelperTextForBooklets$4 = "Almeno {{{MINIMUM}}} pagine, inclusa la copertina ";
var rangedGeneralInputError$4 = "Inserimento non valido";
var rangedBetweenRangesError$4 = "I numeri più vicini sono {{{LOWER}}} {{{UNIT}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$4 = "Il numero non può avere più di 8 decimali";
var rangedMinInputValueError$4 = "Il numero minimo è {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$4 = "Il numero massimo è {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$4 = "Il valore inserito deve essere un numero";
var requiredAttributeFieldError$4 = "Inserisci un valore compreso tra {{{LOWER}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$4 = "I numeri più vicini sono {{{LOWER}}} pagine e {{{HIGHER}}} pagine ";
var rangedMinInputValueErrorForBooklets$4 = "Il numero minimo è {{{MINIMUM}}} pagine ";
var rangedMaxInputValueErrorForBooklets$4 = "Il numero massimo è {{{MAXIMUM}}} pagine ";
var requiredAttributeFieldErrorForBooklets$4 = "Inserisci un valore tra {{{LOWER}}} e {{{HIGHER}}} inclusa la copertina ";
var requiredInformationToast$4 = "Inserisci tutte le informazioni necessarie.";
var quantityComboboxHelperText$4 = "Minimo {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$4 = "Mostra guida ai prezzi";
var quantityComboboxPricingGuide$4 = "Guida ai prezzi";
var quantityComboboxFlyoutConfirmation$4 = "Conferma";
var quantityComboboxFlyoutCancel$4 = "Annulla";
var itIt = {
	quantityLabel: quantityLabel$4,
	quantityFlyoutHeader: quantityFlyoutHeader$4,
	quantityFlyoutCTA: quantityFlyoutCTA$4,
	closeButton: closeButton$4,
	pricePlaceholder: pricePlaceholder$4,
	priceLabel: priceLabel$4,
	unitPriceLabel: unitPriceLabel$4,
	incompatibilityMessage: incompatibilityMessage$4,
	select: select$4,
	percentSavings: percentSavings$4,
	sale: sale$4,
	amountSavings: amountSavings$4,
	amountSavingsWithSale: amountSavingsWithSale$4,
	seeMoreQuantities: seeMoreQuantities$4,
	required: required$4,
	sample: sample$4,
	estimatedQuantity: estimatedQuantity$4,
	numberOfRecipients: numberOfRecipients$4,
	recommendedCallout: recommendedCallout$4,
	newCallout: newCallout$4,
	incompatibleLabel: incompatibleLabel$4,
	outOfStockCallout: outOfStockCallout$4,
	dismissAlert: dismissAlert$4,
	unwindingMessage_1: unwindingMessage_1$4,
	unwindingMessage_2: unwindingMessage_2$4,
	unwindingMessage_3: unwindingMessage_3$4,
	unwindingMessage_more: unwindingMessage_more$4,
	unwindingAlertMessage_1: unwindingAlertMessage_1$4,
	unwindingAlertMessage_2: unwindingAlertMessage_2$4,
	unwindingAlertMessage_3: unwindingAlertMessage_3$4,
	unwindingAlertMessage_more: unwindingAlertMessage_more$4,
	fullRangedHelperText: fullRangedHelperText$4,
	rangePartialRangedHelperText: rangePartialRangedHelperText$4,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$4,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$4,
	rangedGeneralInputError: rangedGeneralInputError$4,
	rangedBetweenRangesError: rangedBetweenRangesError$4,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$4,
	rangedMinInputValueError: rangedMinInputValueError$4,
	rangedMaxInputValueError: rangedMaxInputValueError$4,
	rangedNotANumberError: rangedNotANumberError$4,
	requiredAttributeFieldError: requiredAttributeFieldError$4,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$4,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$4,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$4,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$4,
	requiredInformationToast: requiredInformationToast$4,
	quantityComboboxHelperText: quantityComboboxHelperText$4,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$4,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$4,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$4,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$4
};

var quantityLabel$3 = "Antall";
var quantityFlyoutHeader$3 = "Velg antall";
var quantityFlyoutCTA$3 = "Velg dette antallet";
var closeButton$3 = "Lukk";
var pricePlaceholder$3 = "...";
var priceLabel$3 = "Pris";
var unitPriceLabel$3 = "Enhetspris";
var incompatibilityMessage$3 = "Ikke tilgjengelig med andre valg: ";
var select$3 = "Velg...";
var percentSavings$3 = "{{{PERCENT}}} % besparelse";
var sale$3 = "salg";
var amountSavings$3 = "{{{AMOUNT}}} besparelse/enhet";
var amountSavingsWithSale$3 = "{{{AMOUNT}}} besparelse/enhet + salg";
var seeMoreQuantities$3 = "Se flere antall";
var required$3 = "Obligatorisk";
var sample$3 = "Prøve";
var estimatedQuantity$3 = "Estimert antall";
var numberOfRecipients$3 = "{{{COUNT}}} Mottakere";
var recommendedCallout$3 = "Anbefalt";
var newCallout$3 = "Nyhet";
var incompatibleLabel$3 = "Uforenlig";
var outOfStockCallout$3 = "Utsolgt";
var dismissAlert$3 = "Avvis varsel";
var unwindingMessage_1$3 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$3 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$3 = "Uforenlig med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$3 = "Uforenlig med mer enn {{{ATTRIBUTE_COUNT}}} alternativer.";
var unwindingAlertMessage_1$3 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} ble valgt bort.";
var unwindingAlertMessage_2$3 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} og {{{ATTRIBUTE2}}} {{{OPTION2}}} ble valgt bort.";
var unwindingAlertMessage_3$3 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} og {{{ATTRIBUTE3}}} {{{OPTION3}}} ble valgt bort.";
var unwindingAlertMessage_more$3 = "Å være forenlig med {{{ATTRIBUTE}}} {{{OPTION}}}: Mer enn {{{ATTRIBUTE_COUNT}}} alternativer ble valgt bort.";
var fullRangedHelperText$3 = "{{{MINIMUM}}} {{{UNIT}}} til {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$3 = "Minst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$3 = "Skriv inn en verdi mellom {{{MINIMUM}}} og {{{MAXIMUM}}} sider, inkludert omslag ";
var rangePartialRangedHelperTextForBooklets$3 = "Minst {{{MINIMUM}}} sider, inkludert omslag ";
var rangedGeneralInputError$3 = "Inndata er ugyldig";
var rangedBetweenRangesError$3 = "De nærmeste tallene er {{{LOWER}}} {{{UNIT}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$3 = "Tallet kan ikke ha mer enn 8 desimaler";
var rangedMinInputValueError$3 = "Minimumsantall er {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$3 = "Maksimalt antall er {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$3 = "Inndata må være et tall";
var requiredAttributeFieldError$3 = "Skriv inn en verdi mellom {{{LOWER}}} og {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$3 = "De nærmeste antallene er {{{LOWER}}} sider og {{{HIGHER}}} sider ";
var rangedMinInputValueErrorForBooklets$3 = "Minimumsantall er {{{MINIMUM}}} sider ";
var rangedMaxInputValueErrorForBooklets$3 = "Maksimalt antall er {{{MAXIMUM}}} sider ";
var requiredAttributeFieldErrorForBooklets$3 = "Skriv inn en verdi mellom {{{LOWER}}} og {{{HIGHER}}} sider, inkludert omslag ";
var requiredInformationToast$3 = "Angi alle opplysninger som kreves.";
var quantityComboboxHelperText$3 = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$3 = "Vis prisoversikt";
var quantityComboboxPricingGuide$3 = "Prisoversikt";
var quantityComboboxFlyoutConfirmation$3 = "Bekreft";
var quantityComboboxFlyoutCancel$3 = "Avbryt";
var nbNo = {
	quantityLabel: quantityLabel$3,
	quantityFlyoutHeader: quantityFlyoutHeader$3,
	quantityFlyoutCTA: quantityFlyoutCTA$3,
	closeButton: closeButton$3,
	pricePlaceholder: pricePlaceholder$3,
	priceLabel: priceLabel$3,
	unitPriceLabel: unitPriceLabel$3,
	incompatibilityMessage: incompatibilityMessage$3,
	select: select$3,
	percentSavings: percentSavings$3,
	sale: sale$3,
	amountSavings: amountSavings$3,
	amountSavingsWithSale: amountSavingsWithSale$3,
	seeMoreQuantities: seeMoreQuantities$3,
	required: required$3,
	sample: sample$3,
	estimatedQuantity: estimatedQuantity$3,
	numberOfRecipients: numberOfRecipients$3,
	recommendedCallout: recommendedCallout$3,
	newCallout: newCallout$3,
	incompatibleLabel: incompatibleLabel$3,
	outOfStockCallout: outOfStockCallout$3,
	dismissAlert: dismissAlert$3,
	unwindingMessage_1: unwindingMessage_1$3,
	unwindingMessage_2: unwindingMessage_2$3,
	unwindingMessage_3: unwindingMessage_3$3,
	unwindingMessage_more: unwindingMessage_more$3,
	unwindingAlertMessage_1: unwindingAlertMessage_1$3,
	unwindingAlertMessage_2: unwindingAlertMessage_2$3,
	unwindingAlertMessage_3: unwindingAlertMessage_3$3,
	unwindingAlertMessage_more: unwindingAlertMessage_more$3,
	fullRangedHelperText: fullRangedHelperText$3,
	rangePartialRangedHelperText: rangePartialRangedHelperText$3,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$3,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$3,
	rangedGeneralInputError: rangedGeneralInputError$3,
	rangedBetweenRangesError: rangedBetweenRangesError$3,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$3,
	rangedMinInputValueError: rangedMinInputValueError$3,
	rangedMaxInputValueError: rangedMaxInputValueError$3,
	rangedNotANumberError: rangedNotANumberError$3,
	requiredAttributeFieldError: requiredAttributeFieldError$3,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$3,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$3,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$3,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$3,
	requiredInformationToast: requiredInformationToast$3,
	quantityComboboxHelperText: quantityComboboxHelperText$3,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$3,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$3,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$3,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$3
};

var quantityLabel$2 = "Aantal";
var quantityFlyoutHeader$2 = "Kies het aantal";
var quantityFlyoutCTA$2 = "Dit aantal selecteren";
var closeButton$2 = "Sluiten";
var pricePlaceholder$2 = "...";
var priceLabel$2 = "Prijs";
var unitPriceLabel$2 = "Prijs per stuk";
var incompatibilityMessage$2 = "Niet beschikbaar met andere opties: ";
var select$2 = "Selecteren...";
var percentSavings$2 = "{{{PERCENT}}}% korting";
var sale$2 = "Sale";
var amountSavings$2 = "{{{AMOUNT}}} korting per stuk";
var amountSavingsWithSale$2 = "{{{AMOUNT}}} korting per stuk + sale";
var seeMoreQuantities$2 = "Meer hoeveelheden weergeven";
var required$2 = "Verplicht";
var sample$2 = "Proefmonster";
var estimatedQuantity$2 = "Geschat aantal";
var numberOfRecipients$2 = "{{{COUNT}}} ontvangers";
var recommendedCallout$2 = "Aanbevolen";
var newCallout$2 = "Nieuw";
var incompatibleLabel$2 = "Incompatibel";
var outOfStockCallout$2 = "Niet op voorraad";
var dismissAlert$2 = "Melding sluiten";
var unwindingMessage_1$2 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$2 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}} en {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$2 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} en {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$2 = "Incompatibel met meer dan {{{ATTRIBUTE_COUNT}}} opties.";
var unwindingAlertMessage_1$2 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} is gedeselecteerd.";
var unwindingAlertMessage_2$2 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} en {{{ATTRIBUTE2}}} {{{OPTION2}}} zijn gedeselecteerd.";
var unwindingAlertMessage_3$2 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} en {{{ATTRIBUTE3}}} {{{OPTION3}}} zijn gedeselecteerd.";
var unwindingAlertMessage_more$2 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: meer dan {{{ATTRIBUTE_COUNT}}} opties zijn gedeselecteerd.";
var fullRangedHelperText$2 = "{{{MINIMUM}}} {{{UNIT}}} tot {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$2 = "Minimaal {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$2 = "Voer een waarde van {{{MINIMUM}}} tot {{{MAXIMUM}}} pagina's in, inclusief omslag ";
var rangePartialRangedHelperTextForBooklets$2 = "Ten minste {{{MINIMUM}}} pagina's, inclusief omslag ";
var rangedGeneralInputError$2 = "Invoer is ongeldig";
var rangedBetweenRangesError$2 = "Dichtstbijzijnde getallen zijn {{{LOWER}}} {{{UNIT}}} en {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$2 = "Getal kan niet meer dan 8 decimalen hebben";
var rangedMinInputValueError$2 = "Het minimumgetal is {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$2 = "Het maximumgetal is {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$2 = "Invoer moet een getal zijn";
var requiredAttributeFieldError$2 = "Voer een waarde in tussen {{{LOWER}}} en {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$2 = "Dichtstbijzijnde getallen zijn {{{LOWER}}} pagina's en {{{HIGHER}}} pagina's ";
var rangedMinInputValueErrorForBooklets$2 = "Het minimumgetal is {{{MINIMUM}}} pagina's ";
var rangedMaxInputValueErrorForBooklets$2 = "Het maximumgetal is {{{MAXIMUM}}} pagina's ";
var requiredAttributeFieldErrorForBooklets$2 = "Voer een waarde van {{{LOWER}}} tot {{{HIGHER}}} pagina's in, inclusief omslag ";
var requiredInformationToast$2 = "Vul alle vereiste gegevens in.";
var quantityComboboxHelperText$2 = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$2 = "Prijsgids tonen";
var quantityComboboxPricingGuide$2 = "Prijsgids";
var quantityComboboxFlyoutConfirmation$2 = "Bevestigen";
var quantityComboboxFlyoutCancel$2 = "Annuleren";
var nlNl = {
	quantityLabel: quantityLabel$2,
	quantityFlyoutHeader: quantityFlyoutHeader$2,
	quantityFlyoutCTA: quantityFlyoutCTA$2,
	closeButton: closeButton$2,
	pricePlaceholder: pricePlaceholder$2,
	priceLabel: priceLabel$2,
	unitPriceLabel: unitPriceLabel$2,
	incompatibilityMessage: incompatibilityMessage$2,
	select: select$2,
	percentSavings: percentSavings$2,
	sale: sale$2,
	amountSavings: amountSavings$2,
	amountSavingsWithSale: amountSavingsWithSale$2,
	seeMoreQuantities: seeMoreQuantities$2,
	required: required$2,
	sample: sample$2,
	estimatedQuantity: estimatedQuantity$2,
	numberOfRecipients: numberOfRecipients$2,
	recommendedCallout: recommendedCallout$2,
	newCallout: newCallout$2,
	incompatibleLabel: incompatibleLabel$2,
	outOfStockCallout: outOfStockCallout$2,
	dismissAlert: dismissAlert$2,
	unwindingMessage_1: unwindingMessage_1$2,
	unwindingMessage_2: unwindingMessage_2$2,
	unwindingMessage_3: unwindingMessage_3$2,
	unwindingMessage_more: unwindingMessage_more$2,
	unwindingAlertMessage_1: unwindingAlertMessage_1$2,
	unwindingAlertMessage_2: unwindingAlertMessage_2$2,
	unwindingAlertMessage_3: unwindingAlertMessage_3$2,
	unwindingAlertMessage_more: unwindingAlertMessage_more$2,
	fullRangedHelperText: fullRangedHelperText$2,
	rangePartialRangedHelperText: rangePartialRangedHelperText$2,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$2,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$2,
	rangedGeneralInputError: rangedGeneralInputError$2,
	rangedBetweenRangesError: rangedBetweenRangesError$2,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$2,
	rangedMinInputValueError: rangedMinInputValueError$2,
	rangedMaxInputValueError: rangedMaxInputValueError$2,
	rangedNotANumberError: rangedNotANumberError$2,
	requiredAttributeFieldError: requiredAttributeFieldError$2,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$2,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$2,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$2,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$2,
	requiredInformationToast: requiredInformationToast$2,
	quantityComboboxHelperText: quantityComboboxHelperText$2,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$2,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$2,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$2,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$2
};

var quantityLabel$1 = "Quantidade";
var quantityFlyoutHeader$1 = "Escolha a quantidade";
var quantityFlyoutCTA$1 = "Selecionar esta quantidade";
var closeButton$1 = "Fechar";
var pricePlaceholder$1 = "...";
var priceLabel$1 = "Preço";
var unitPriceLabel$1 = "Preço à unidade";
var incompatibilityMessage$1 = "Não disponível com outras seleções: ";
var select$1 = "Selecionar...";
var percentSavings$1 = "Poupança de {{{PERCENT}}}%";
var sale$1 = "venda";
var amountSavings$1 = "Poupança de {{{AMOUNT}}} / unidade";
var amountSavingsWithSale$1 = "Poupança de {{{AMOUNT}}} / unidade+ promoção";
var seeMoreQuantities$1 = "Ver mais quantidades";
var required$1 = "Obrigatório";
var sample$1 = "Amostra";
var estimatedQuantity$1 = "Quantidade estimada";
var numberOfRecipients$1 = "{{{COUNT}}} destinatários";
var recommendedCallout$1 = "Recomendado";
var newCallout$1 = "Novidade";
var incompatibleLabel$1 = "Incompatível";
var outOfStockCallout$1 = "Esgotado";
var dismissAlert$1 = "Dispensar alerta";
var unwindingMessage_1$1 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2$1 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3$1 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more$1 = "Incompatível com mais de {{{ATTRIBUTE_COUNT}}} opções.";
var unwindingAlertMessage_1$1 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} foi desmarcado.";
var unwindingAlertMessage_2$1 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}} foram desmarcados.";
var unwindingAlertMessage_3$1 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}} foram desmarcados.";
var unwindingAlertMessage_more$1 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: Mais de {{{ATTRIBUTE_COUNT}}} opções foram desmarcadas.";
var fullRangedHelperText$1 = "{{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText$1 = "Pelo menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets$1 = "Introduza um valor entre {{{MINIMUM}}} e {{{MAXIMUM}}} páginas, incluindo a capa ";
var rangePartialRangedHelperTextForBooklets$1 = "Pelo menos, {{{MINIMUM}}} páginas, incluindo a capa ";
var rangedGeneralInputError$1 = "A entrada é inválida";
var rangedBetweenRangesError$1 = "Os números mais próximos são {{{LOWER}}} {{{UNIT}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError$1 = "O número não pode ter mais de 8 decimais";
var rangedMinInputValueError$1 = "O número mínimo é {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError$1 = "O número máximo é {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError$1 = "O valor de entrada tem de ser um número";
var requiredAttributeFieldError$1 = "Introduza um valor entre {{{LOWER}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets$1 = "Os números mais próximos são {{{LOWER}}} páginas e {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets$1 = "O número mínimo são {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets$1 = "O número máximo são {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets$1 = "Introduza um valor entre {{{LOWER}}} e {{{HIGHER}}} páginas, incluindo a capa ";
var requiredInformationToast$1 = "Indique todas as informações necessárias.";
var quantityComboboxHelperText$1 = "Mínimo: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide$1 = "Mostrar guia de preços";
var quantityComboboxPricingGuide$1 = "Guia de preços";
var quantityComboboxFlyoutConfirmation$1 = "Confirmar";
var quantityComboboxFlyoutCancel$1 = "Cancelar";
var ptPt = {
	quantityLabel: quantityLabel$1,
	quantityFlyoutHeader: quantityFlyoutHeader$1,
	quantityFlyoutCTA: quantityFlyoutCTA$1,
	closeButton: closeButton$1,
	pricePlaceholder: pricePlaceholder$1,
	priceLabel: priceLabel$1,
	unitPriceLabel: unitPriceLabel$1,
	incompatibilityMessage: incompatibilityMessage$1,
	select: select$1,
	percentSavings: percentSavings$1,
	sale: sale$1,
	amountSavings: amountSavings$1,
	amountSavingsWithSale: amountSavingsWithSale$1,
	seeMoreQuantities: seeMoreQuantities$1,
	required: required$1,
	sample: sample$1,
	estimatedQuantity: estimatedQuantity$1,
	numberOfRecipients: numberOfRecipients$1,
	recommendedCallout: recommendedCallout$1,
	newCallout: newCallout$1,
	incompatibleLabel: incompatibleLabel$1,
	outOfStockCallout: outOfStockCallout$1,
	dismissAlert: dismissAlert$1,
	unwindingMessage_1: unwindingMessage_1$1,
	unwindingMessage_2: unwindingMessage_2$1,
	unwindingMessage_3: unwindingMessage_3$1,
	unwindingMessage_more: unwindingMessage_more$1,
	unwindingAlertMessage_1: unwindingAlertMessage_1$1,
	unwindingAlertMessage_2: unwindingAlertMessage_2$1,
	unwindingAlertMessage_3: unwindingAlertMessage_3$1,
	unwindingAlertMessage_more: unwindingAlertMessage_more$1,
	fullRangedHelperText: fullRangedHelperText$1,
	rangePartialRangedHelperText: rangePartialRangedHelperText$1,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets$1,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets$1,
	rangedGeneralInputError: rangedGeneralInputError$1,
	rangedBetweenRangesError: rangedBetweenRangesError$1,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError$1,
	rangedMinInputValueError: rangedMinInputValueError$1,
	rangedMaxInputValueError: rangedMaxInputValueError$1,
	rangedNotANumberError: rangedNotANumberError$1,
	requiredAttributeFieldError: requiredAttributeFieldError$1,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets$1,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets$1,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets$1,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets$1,
	requiredInformationToast: requiredInformationToast$1,
	quantityComboboxHelperText: quantityComboboxHelperText$1,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide$1,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide$1,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation$1,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel$1
};

var quantityLabel = "Antal";
var quantityFlyoutHeader = "Välj antal";
var quantityFlyoutCTA = "Välj det här antalet";
var closeButton = "Stäng";
var pricePlaceholder = "...";
var priceLabel = "Pris";
var unitPriceLabel = "Pris per enhet";
var incompatibilityMessage = "Går inte att välja med andra val: ";
var select = "Välj...";
var percentSavings = "{{{PERCENT}}} % rabatt";
var sale = "rea";
var amountSavings = "{{{AMOUNT}}} rabatt / enhet";
var amountSavingsWithSale = "{{{AMOUNT}}} rabatt / enhet + rea";
var seeMoreQuantities = "Se fler antal";
var required = "Obligatoriskt";
var sample = "Varuprov";
var estimatedQuantity = "Beräknat antal";
var numberOfRecipients = "{{{COUNT}}} Mottagare";
var recommendedCallout = "Rekommenderas";
var newCallout = "Nyhet";
var incompatibleLabel = "Ej kompatibel";
var outOfStockCallout = "Ej i lager";
var dismissAlert = "Avvisa avisering";
var unwindingMessage_1 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}} eller {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Ej kompatibel med {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} eller {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Ej kompatibel med mer än {{{ATTRIBUTE_COUNT}}} alternativ.";
var unwindingAlertMessage_1 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingAlertMessage_2 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}} och {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingAlertMessage_3 = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} och {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingAlertMessage_more = "För att bli kompatibel med {{{ATTRIBUTE}}} {{{OPTION}}}: avmarkerades fler än {{{ATTRIBUTE_COUNT}}} alternativ.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} till {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Minst {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Ange ett värde mellan {{{MINIMUM}}} och {{{MAXIMUM}}} sidor, inklusive omslag ";
var rangePartialRangedHelperTextForBooklets = "Minst {{{MINIMUM}}} sidor, inklusive omslag ";
var rangedGeneralInputError = "Inmatningen är ogiltig";
var rangedBetweenRangesError = "De närmaste talen är {{{LOWER}}} {{{UNIT}}} och {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Talet får ha högst 8 decimaler";
var rangedMinInputValueError = "Lägsta giltiga tal är {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Högsta giltiga tal är {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Inmatningen måste vara ett tal";
var requiredAttributeFieldError = "Ange ett värde mellan {{{LOWER}}} och {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Det närmaste talet är {{{LOWER}}} sidor och {{{HIGHER}}} sidor ";
var rangedMinInputValueErrorForBooklets = "Lägsta giltiga tal är {{{MINIMUM}}} sidor ";
var rangedMaxInputValueErrorForBooklets = "Högsta giltiga tal är {{{MAXIMUM}}} sidor ";
var requiredAttributeFieldErrorForBooklets = "Ange ett värde mellan {{{LOWER}}} och {{{HIGHER}}} sidor, inklusive omslag ";
var requiredInformationToast = "Ange all obligatorisk information, tack.";
var quantityComboboxHelperText = "Minimum: {{{MINIMUM}}}";
var quantityComboboxShowPricingGuide = "Visa prisguide";
var quantityComboboxPricingGuide = "Prisguide";
var quantityComboboxFlyoutConfirmation = "Bekräfta";
var quantityComboboxFlyoutCancel = "Avbryt";
var svSe = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast,
	quantityComboboxHelperText: quantityComboboxHelperText,
	quantityComboboxShowPricingGuide: quantityComboboxShowPricingGuide,
	quantityComboboxPricingGuide: quantityComboboxPricingGuide,
	quantityComboboxFlyoutConfirmation: quantityComboboxFlyoutConfirmation,
	quantityComboboxFlyoutCancel: quantityComboboxFlyoutCancel
};

const resources = {
    // en-US is the source language.
    "en-us": enUs,
    "da-dk": daDk,
    "de-at": deDe,
    "de-ch": deDe,
    "de-de": deDe,
    "en-au": enGb,
    "en-ca": enUs,
    "en-gb": enGb,
    "en-ie": enGb,
    "en-in": enGb,
    "en-nz": enGb,
    "en-sg": enGb,
    "es-es": esEs,
    "es-us": esUs,
    "fi-fi": fiFi,
    "fr-ca": frCa,
    "fr-be": frFr,
    "fr-ch": frFr,
    "fr-fr": frFr,
    "it-ch": itIt,
    "it-it": itIt,
    "nb-no": nbNo,
    "nl-be": nlNl,
    "nl-nl": nlNl,
    "pt-pt": ptPt,
    "sv-se": svSe,
};
const getLocalizationsFor = (locale) => {
    return resources[locale.toLowerCase()];
};

const TheLocalizationContext = createContext(undefined);
const ProductOptionsTranslations = (props) => {
    const localization = useMemo(() => getLocalizationsFor(props.locale), [props.locale]);
    return (React__default.createElement(TheLocalizationContext.Provider, { value: localization }, localization && props.children));
};
const useProductOptionsTranslations = () => {
    const ctx = useContext(TheLocalizationContext);
    if (ctx === undefined) {
        throw new Error("useProductOptionsTranslations must be used with localization provider");
    }
    return {
        i18n: (key) => ctx[key],
        i18nUnsafe: (key) => ctx[key],
    };
};

const SecondaryPlusOrMinusFullPrices$1 = ({ choice, locale, currency, fractionDigits, pricePlaceholder, vatInc = false, hideVatMessage = true, }) => {
    const { differentialListPrice, differentialDiscountPrice } = choice;
    const discountedPrice = differentialDiscountPrice ?? differentialListPrice;
    // If both the list and discounted price are zero, then we just want to show "+$0.00".
    // The "+" is added through the zero-price CSS class.
    if (discountedPrice === 0 && differentialListPrice === 0) {
        return (React__default.createElement("span", { className: "zero-price" },
            "+",
            React__default.createElement(RawPrice, { placeHolderText: pricePlaceholder, pricingInfo: {
                    currency,
                    minimumFractionDigits: fractionDigits,
                    culture: locale,
                    listPrice: 0,
                    discountPrice: 0,
                    vatInc,
                    hideVatMessage,
                } })));
    }
    // If we want to prevent the "Base Price" text from appearing, and the list price is zero but the discounted price is not,
    // then we can take advantage of a feature of PlusOrMinusPerUnit where it hides the "Base Price" cross out, just showing the
    // discount. But in that case it also hides the "/ea" label.
    const PricingComponent = differentialListPrice === 0 && discountedPrice !== 0 ? PlusOrMinusPerUnit : PlusOrMinus;
    return (React__default.createElement(PricingComponent, { placeHolderText: pricePlaceholder, pricingInfo: {
            currency,
            minimumFractionDigits: fractionDigits,
            culture: locale,
            priceDifference: differentialListPrice ?? 0, // should this be default to 0
            priceDifferenceDiscounted: discountedPrice ?? 0, // should this be default to 0
        } }));
};

const SecondaryPlusOrMinusPerUnitPrices = ({ choice, locale, currency, fractionDigits, pricePlaceholder, hideZeroPrice = false, }) => {
    const { differentialUnitDiscountPrice, differentialUnitListPrice } = choice;
    const priceDifference = differentialUnitListPrice ?? 0;
    const priceDifferenceDiscounted = differentialUnitDiscountPrice ?? 0;
    if (hideZeroPrice && priceDifference === 0 && priceDifferenceDiscounted === 0) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return (React__default.createElement(PlusOrMinusPerUnit, { placeHolderText: pricePlaceholder, pricingInfo: {
            currency,
            minimumFractionDigits: fractionDigits,
            culture: locale,
            priceDifference,
            priceDifferenceDiscounted,
            comparativeDisplayType: ComparativeDisplayType.CustomerFriendly,
        } }));
};

function hasPrices(differentialUnitListPrice, differentialUnitDiscountPrice) {
    return !!differentialUnitListPrice || !!differentialUnitDiscountPrice;
}
const OptionPriceDisplay = (props) => {
    const component = OptionPriceDisplayInner(props);
    if (component && props.showPriceWithParentheses) {
        return React__default.createElement(React__default.Fragment, null,
            "(",
            component,
            ")");
    }
    return component || React__default.createElement(React__default.Fragment, null);
};
const OptionPriceDisplayInner = ({ choice, priceDisplayMode, locale, currency, fractionDigits, hideZeroPrice = true, vatInc = false, hideVatMessage = true, tenant, }) => {
    const { i18n } = useProductOptionsTranslations();
    let component = undefined;
    switch (priceDisplayMode) {
        case "differential-total": {
            component = (React__default.createElement(SecondaryPlusOrMinusFullPrices$1, { choice: choice, pricePlaceholder: i18n("pricePlaceholder"), locale: locale, currency: currency, fractionDigits: fractionDigits, vatInc: vatInc, hideVatMessage: hideVatMessage }));
            break;
        }
        case "differential-unit": {
            if (hasPrices(choice.differentialUnitListPrice, choice.differentialUnitDiscountPrice)) {
                component = (React__default.createElement(SecondaryPlusOrMinusPerUnitPrices, { choice: choice, pricePlaceholder: i18n("pricePlaceholder"), locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: hideZeroPrice }));
            }
            break;
        }
        case "unit": {
            if (hasPrices(choice.unitDiscountedPrice, choice.unitListPrice)) {
                component = (React__default.createElement(PricePerUnit, { tenant: tenant, placeHolderText: i18n("pricePlaceholder"), pricingInfo: {
                        currency,
                        minimumFractionDigits: fractionDigits,
                        culture: locale,
                        unitDiscountPrice: choice.unitDiscountedPrice ?? 0,
                        unitListPrice: choice.unitListPrice ?? 0,
                        vatInc,
                        hideVatMessage,
                    } }));
            }
            break;
        }
        case "total": {
            if (hasPrices(choice.totalDiscountedPrice, choice.totalListPrice)) {
                component = (React__default.createElement(RawPrice, { tenant: tenant, placeHolderText: i18n("pricePlaceholder"), pricingInfo: {
                        currency,
                        minimumFractionDigits: fractionDigits,
                        culture: locale,
                        discountPrice: choice.totalDiscountedPrice ?? 0,
                        listPrice: choice.totalListPrice ?? 0,
                        vatInc,
                        hideVatMessage,
                    } }));
            }
            break;
        }
    }
    return component;
};

const ProductOptionContext = React__default.createContext(undefined);

class ValidationResult {
    _messages = [];
    addValidation(message) {
        this._messages.push(message);
    }
    get messages() {
        return this._messages;
    }
}

class DecoratorResult {
    _mutations = [];
    addMutation(mutation) {
        this._mutations.push(mutation);
    }
    get mutations() {
        return this._mutations;
    }
}

function imageValidator(productOption, hideImagesProp) {
    const result = new ValidationResult();
    // do not hide images by default
    let hideImages = false;
    if (hideImagesProp === true) {
        hideImages = true;
    }
    else {
        const allChoicesHaveImages = productOption.choices.every((choice) => {
            return !!choice.image;
        });
        if (!allChoicesHaveImages) {
            hideImages = true;
            result.addValidation("At least one choice is missing a thumbnail image. `hideImages` flag will be set to true.");
        }
    }
    return {
        messages: result.messages,
        hideImages,
    };
}

const isProductOptionModelList = (productOption) => {
    return !productOption.choices.some((option) => "minimum" in option);
};
const containsListAndRange = (productOption) => {
    return (productOption.choices.some((option) => "key" in option) &&
        productOption.choices.some((option) => "minimum" in option));
};

function styleValidator(productOption, skinInput, hideImages, hideDescriptions) {
    const result = new ValidationResult();
    // If every key is a hex code and there are no images, render a color-swatch
    const rangedOver = getRangedOverrides(productOption, skinInput);
    const listOver = getListOverrides(hideImages, productOption, result, rangedOver.style, rangedOver.skin, hideDescriptions);
    return {
        messages: result.messages,
        style: listOver.style,
        skin: listOver.skin,
    };
}
function getRangedOverrides(productOptions, skinInput) {
    return { style: productOptions.style, skin: skinInput };
}
function getListOverrides(hideImages, productOption, result, style, skin, hideDescriptions) {
    if (isProductOptionModelList(productOption)) {
        if (hideImages &&
            productOption.choices.length > 0 &&
            productOption.choices.every((x) => /^#[0-9A-F]{6}(?:\/#[0-9A-F]{6})?$/i.test(x.key))) {
            result.addValidation(`The ${style} ${skin} was converted to a standard color-swatch as all keys have a hex code`);
            style = "color-swatch";
            skin = "standard";
        }
        if (style === "buttons" && skin === "wide" && hideImages && hideDescriptions) {
            result.addValidation(`The 'button' skin was changed to 'tight' from 'wide' because there are no images, descriptions or savings to display.`);
            skin = "tight";
        }
        const QuantityDropdownSkin = "standard";
        if (style === "dropdown" && productOption.key === "Quantity" && skin !== QuantityDropdownSkin) {
            result.addValidation(`The "dropdown" skin was changed to "${QuantityDropdownSkin}" from ${skin} because "Quantity" dropdowns should always use "${QuantityDropdownSkin}" skin.`);
            skin = QuantityDropdownSkin;
        }
    }
    return { style, skin };
}

function hasUnitPrices(choices) {
    return choices.some((choice) => (choice.unitListPrice ?? 0) !== 0 || (choice.unitDiscountedPrice ?? 0) !== 0);
}
function hasListPrices(choices) {
    return choices.some((choice) => (choice.totalListPrice ?? 0) !== 0 || (choice.totalDiscountedPrice ?? 0) !== 0);
}
function hasDifferentialUnitPrices(choices) {
    return choices.some((choice) => (choice.differentialUnitListPrice ?? 0) !== 0 ||
        (choice.differentialUnitDiscountPrice ?? 0) !== 0);
}
function hasDifferentialListPrices(choices) {
    return choices.some((choice) => (choice.differentialListPrice ?? 0) !== 0 || (choice.differentialDiscountPrice ?? 0) !== 0);
}
function priceDisplayModeValidator(productOption, priceDisplayMode) {
    const result = new ValidationResult();
    let outHidePrices = "differential-unit";
    if (priceDisplayMode === "none") {
        outHidePrices = "none";
    }
    else if (priceDisplayMode === "differential-unit") {
        if (productOption.key === "Quantity" && productOption.style === "dropdown") {
            // quantity product option should show unit prices
            if (hasUnitPrices(productOption.choices)) {
                result.addValidation("Quantity should display 'Unit' prices. 'differential-unit' was changed to 'unit'");
                outHidePrices = "unit";
            }
            else {
                result.addValidation("Quantity should display 'Unit' prices, but there are no unit prices to display. 'differential-unit' was changed to 'none'");
                outHidePrices = "none";
            }
        }
        else {
            if (hasDifferentialUnitPrices(productOption.choices)) {
                outHidePrices = "differential-unit";
            }
            else {
                result.addValidation("None of the choices have unit differential prices. Prices will not be shown.");
                outHidePrices = "none";
            }
        }
    }
    else if (priceDisplayMode === "differential-total") {
        if (productOption.key === "Quantity" && hasListPrices(productOption.choices)) {
            // quantity product option should show total prices
            result.addValidation("Quantity should display 'Total' prices. 'differential-total' was changed to 'total'");
            outHidePrices = "total";
        }
        else if (hasDifferentialListPrices(productOption.choices)) {
            outHidePrices = "differential-total";
        }
        else {
            result.addValidation("None of the choices have total differential prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    else if (priceDisplayMode === "unit") {
        if (hasUnitPrices(productOption.choices)) {
            outHidePrices = "unit";
        }
        else {
            result.addValidation("None of the choices have unit prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    else if (priceDisplayMode === "total") {
        if (hasListPrices(productOption.choices)) {
            outHidePrices = "total";
        }
        else {
            result.addValidation("None of the choices have total prices. Prices will not be shown.");
            outHidePrices = "none";
        }
    }
    return {
        messages: result.messages,
        priceDisplayMode: outHidePrices,
    };
}

function styleDecorator(productOption, style, skin) {
    const result = new DecoratorResult();
    if (productOption.style !== style) {
        result.addMutation({
            type: "add",
            reason: "style was undefined, setting to default style",
            oldState: productOption.style,
            newState: style,
        });
        productOption.style = style;
    }
    return result;
}

function descriptionValidator(productOption, hideDescriptionsProp) {
    const validationResults = new ValidationResult();
    // do not hide descriptions by default
    let hideDescriptions = false;
    if (hideDescriptionsProp === true) {
        hideDescriptions = true;
    }
    else {
        const optionDescriptionValidator = new OptionDescriptionValidator(productOption);
        const { result, violations } = optionDescriptionValidator.validateDescriptions();
        hideDescriptions = !result;
        Object.entries(violations).map(([choiceKey, choiceViolations]) => {
            choiceViolations.map((violation) => validationResults.addValidation(`Option value key ${choiceKey} failed description validation with code ${violation}`));
        });
    }
    return {
        hideDescriptions,
        messages: validationResults.messages,
    };
}
var DescriptionViolationCode;
(function (DescriptionViolationCode) {
    DescriptionViolationCode["EMPTY_DESCRIPTION"] = "EmptyDescription";
    DescriptionViolationCode["DESCRIPTION_CONTAINS_LINK"] = "DescriptionContainsLink";
    DescriptionViolationCode["DESCRIPTION_CONTAINS_MEDIA"] = "DescriptionContainsMedia";
    DescriptionViolationCode["DESCRIPTION_TOO_LONG_OR_TOO_SHORT"] = "DescriptionTooLongOrTooShort";
})(DescriptionViolationCode || (DescriptionViolationCode = {}));
class OptionDescriptionValidator {
    individualViolationCounter;
    validationResult;
    productOption;
    constructor(productOption) {
        this.productOption = productOption;
        this.validationResult = {};
        this.individualViolationCounter = Object.values(DescriptionViolationCode).reduce((result, violationCode) => {
            result[violationCode] = 0;
            return result;
        }, {});
    }
    validateDescriptions() {
        const result = this.getGroupValidationResults() && this.getIndividualValidationResults();
        return {
            result,
            violations: { ...this.validationResult },
        };
    }
    getGroupValidationResults() {
        const groupValidations = [this.descriptionTooLong];
        return groupValidations.every((validation) => validation.bind(this)());
    }
    getIndividualValidationResults() {
        return this.productOption.choices.every((choice) => this.validateIndividualDescription(choice));
    }
    validateIndividualDescription(productOptionListModel) {
        return (!this.descriptionContainsLink(productOptionListModel) &&
            !this.descriptionContainsMedia(productOptionListModel) &&
            !this.hasHappenedNthTime(() => !this.descriptionIsEmpty(productOptionListModel), DescriptionViolationCode.EMPTY_DESCRIPTION, 2));
    }
    hasHappenedNthTime(passPredicate, violationCode, numberOfTimes) {
        const result = passPredicate();
        if (!result && this.individualViolationCounter[violationCode] >= numberOfTimes) {
            return true;
        }
        return false;
    }
    descriptionTooLong() {
        const allKeyDescriptionPairs = (this.productOption.choices
            .filter((choice) => !this.descriptionIsEmpty(choice))
            .map((choice) => ({ key: choice.key, description: choice.description }))
            .filter((keyDescriptionPair) => !!keyDescriptionPair.description)
            .map((keyDescriptionPair) => {
            const cleanedDescription = this.cleanUpDescription(keyDescriptionPair.description || "");
            return { key: keyDescriptionPair.key, description: cleanedDescription };
        }) || []);
        const averageLength = this.calculateAverage(allKeyDescriptionPairs.map((keyDescriptionPair) => keyDescriptionPair.description.length));
        const result = allKeyDescriptionPairs.every(({ key, description }) => {
            if (description.length > 0.5 * averageLength && description.length < 1.5 * averageLength) {
                return true;
            }
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_TOO_LONG_OR_TOO_SHORT);
            return false;
        });
        return result;
    }
    descriptionIsEmpty(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (!description) {
            this.addDescriptionViolation(key, DescriptionViolationCode.EMPTY_DESCRIPTION);
            return true;
        }
        const cleanedDescription = this.cleanUpDescription(description);
        if (!/\S/g.test(cleanedDescription)) {
            this.addDescriptionViolation(key, DescriptionViolationCode.EMPTY_DESCRIPTION);
            return true;
        }
        return false;
    }
    descriptionContainsLink(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (/<a>|<a (.|\n)*?>/g.test(description || "")) {
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_CONTAINS_LINK);
            return true;
        }
        return false;
    }
    descriptionContainsMedia(productOptionListModel) {
        const { description, key } = productOptionListModel;
        if (/<(img|picture|video)>|<(img|picture|video) (.|\n)*?>/g.test(description || "")) {
            this.addDescriptionViolation(key, DescriptionViolationCode.DESCRIPTION_CONTAINS_MEDIA);
            return true;
        }
        return false;
    }
    addDescriptionViolation(optionChoiceKey, violation) {
        if (!this.validationResult[optionChoiceKey]) {
            this.validationResult[optionChoiceKey] = [];
        }
        if (!this.validationResult[optionChoiceKey].includes(violation)) {
            this.validationResult[optionChoiceKey].push(violation);
            this.individualViolationCounter[violation]++;
        }
    }
    /**
     * Remove html tags and html white space (nbsp) from input string
     * @param description input string
     * @returns cleaned up string
     */
    cleanUpDescription(description) {
        return description.replaceAll(/<(.|\n)*?>/g, "").replaceAll("&nbsp;", " ");
    }
    calculateAverage(array) {
        return array.reduce((total, current) => total + current, 0) / array.length;
    }
}

function savingsValidator(productOption, savingsFormat) {
    const result = new ValidationResult();
    let outSavingsFormat = savingsFormat;
    if (savingsFormat !== "hidden") {
        const hasSomeSavingsValue = productOption.choices.some((choice) => {
            return (choice.savingsPercent ?? 0) > 0 || (choice.savingsTotal ?? 0) > 0;
        });
        if (!hasSomeSavingsValue) {
            result.addValidation("None of the choices have savings data. savingsFormat will be 'hidden'.");
        }
        else {
            const hasSomeNegativeSavings = productOption.choices.some((choice) => {
                return (choice.savingsPercent ?? 0) < 0 || (choice.savingsTotal ?? 0) < 0;
            });
            if (hasSomeNegativeSavings) {
                result.addValidation("Some of choices have negative savings. This can be confusing the customer. savingsFormat will be 'hidden'");
            }
        }
    }
    return {
        messages: result.messages,
        savingsFormat: outSavingsFormat,
    };
}

function optionNameDecorator(productOption, i18n) {
    const result = new DecoratorResult();
    if (productOption.key === "Quantity") {
        result.addMutation({
            type: "update",
            reason: "quantity should use translations of quantityLabel as name",
            oldState: productOption.name,
            newState: i18n("quantityLabel"),
        });
        productOption.name = i18n("quantityLabel");
    }
    return result;
}

function calloutDecorator(productOption, i18n) {
    const result = new DecoratorResult();
    const reservedCalloutStrings = {
        legacy_recommended: "recommendedCallout",
        legacy_new: "newCallout",
        legacy_incompatible: "incompatibleLabel",
        legacy_outofstock: "outOfStockCallout",
    };
    if (isProductOptionModelList(productOption)) {
        productOption.choices.map((choice) => {
            choice.callouts?.map((callout) => {
                Object.entries(reservedCalloutStrings).map(([reservedString, localizationKey]) => {
                    if (callout.text.toLowerCase() === reservedString) {
                        const calloutTranslated = i18n(localizationKey);
                        result.addMutation({
                            type: "update",
                            reason: `Reserved callout text ${reservedString} should use translations of ${localizationKey}`,
                            oldState: callout.text,
                            newState: calloutTranslated,
                        });
                        callout.text = calloutTranslated;
                    }
                });
            });
        });
    }
    return result;
}

function rangeDecorator(productOption) {
    const result = new DecoratorResult();
    if (containsListAndRange(productOption)) {
        const choices = productOption.choices.filter((choice) => "minimum" in choice);
        result.addMutation({
            type: "remove",
            reason: "choices have list models, filtering out list models for ranges",
            oldState: productOption.choices,
            newState: choices,
        });
        productOption.choices = choices;
    }
    return result;
}

function clone(obj) {
    if (obj === undefined)
        return undefined;
    return JSON.parse(JSON.stringify(obj));
}

const ProductOptionProvider = ({ productOption, skin, priceDisplayMode = "differential-unit", hideImages, hideDescriptions, showFormErrors = false, uiDensityQuantityUpdate = false, savingsFormat = "percent", children, }) => {
    const { i18n } = useProductOptionsTranslations();
    const listValidationsResult = useListValidations(productOption, savingsFormat, hideImages, priceDisplayMode, hideDescriptions, skin);
    const rangedValidationResult = useRangeValidations(productOption);
    const validationsResult = Object.assign({}, listValidationsResult, rangedValidationResult);
    const isValid = !productOption.isRequired || (productOption.isRequired && !!productOption.selectedKey);
    // run some logic here to decorate the product option
    const context = useMemo(() => {
        // run all the decorators here
        const cloned = clone(productOption);
        const decoratorMutations = [
            ...styleDecorator(cloned, validationsResult.style, validationsResult.skin).mutations,
            ...optionNameDecorator(cloned, i18n).mutations,
            ...calloutDecorator(cloned, i18n).mutations,
            ...rangeDecorator(cloned).mutations,
        ];
        return {
            validationMessages: validationsResult.messages,
            decoratorMutations,
            productOption: cloned,
            skin: validationsResult.skin,
            priceDisplayMode: validationsResult.priceDisplayMode,
            hideImages: validationsResult.hideImages,
            hideDescriptions: validationsResult.hideDescriptions,
            savingsFormat: validationsResult.savingsFormat,
            showFormErrors: showFormErrors && !isValid,
            uiDensityQuantityUpdate,
            selectedOptionText: getSelectedOptionText(productOption),
        };
    }, [productOption, validationsResult]);
    return React__default.createElement(ProductOptionContext.Provider, { value: context }, children);
};
function useRangeValidations(productOption) {
    return useMemo(() => {
        if (!isProductOptionModelList(productOption)) {
            return {
                style: "textbox",
                skin: "wide",
                messages: ["Ranged attributes only have one possible UI at this time."],
            };
        }
        if (containsListAndRange(productOption)) {
            return {
                messages: ["Ranged attributes can only have range options; list options filtered out"],
            };
        }
    }, [productOption]);
}
function useListValidations(productOption, savingsFormat, hideImages, priceDisplayMode, hideDescriptions, skin = "standard") {
    return useMemo(() => {
        if (isProductOptionModelList(productOption)) {
            // run all the validators here
            const { messages: savingsMessages, ...savingsRest } = savingsValidator(productOption, savingsFormat);
            const { messages: imageMessages, ...imageRest } = imageValidator(productOption, hideImages);
            const { messages: priceDisplayModeMessages, ...priceDisplayModeRest } = priceDisplayModeValidator(productOption, priceDisplayMode);
            const { messages: descriptionMessages, ...descriptionRest } = descriptionValidator(productOption, hideDescriptions);
            const { messages: styleMessages, ...styleRest } = styleValidator(productOption, skin, imageRest.hideImages, descriptionRest.hideDescriptions);
            return {
                hideImages: imageRest.hideImages,
                style: styleRest.style,
                skin: styleRest.skin,
                priceDisplayMode: priceDisplayModeRest.priceDisplayMode,
                hideDescriptions: descriptionRest.hideDescriptions,
                savingsFormat: savingsRest.savingsFormat,
                messages: [
                    ...imageMessages,
                    ...styleMessages,
                    ...priceDisplayModeMessages,
                    ...descriptionMessages,
                    ...savingsMessages,
                ],
            };
        }
    }, [skin, priceDisplayMode, hideImages, hideDescriptions, productOption, savingsFormat]);
}
function getSelectedOptionText(productOption) {
    if (isProductOptionModelList(productOption)) {
        return productOption.choices.find((c) => c.key === productOption.selectedKey)?.name;
    }
    return productOption.selectedKey;
}

const useProductOptionContext = () => {
    const ctx = useContext(ProductOptionContext);
    if (!ctx) {
        throw new Error("useProductOptionContext must be used within a ProductOptionProvider");
    }
    return ctx;
};

const SimpleTitleText = ({ showSelectedOptionText }) => {
    const { productOption, showFormErrors, selectedOptionText } = useProductOptionContext();
    const requiredAsterisk = "*";
    return (React__default.createElement(React__default.Fragment, null,
        productOption.name,
        productOption.isRequired && !showFormErrors && (React__default.createElement(Span, { "aria-hidden": "true", fontSkin: "body-standard" }, requiredAsterisk)),
        productOption.isRequired && showFormErrors && (React__default.createElement(Span, { textColor: "error", fontSkin: "body-standard" }, requiredAsterisk)),
        showSelectedOptionText && (React__default.createElement(Span, { "aria-hidden": "true", fontSkin: "body-standard", ml: "3" }, selectedOptionText))));
};

const SimpleTitle = ({ titleId, showSelectedOptionText }) => {
    const { productOption } = useProductOptionContext();
    return (React__default.createElement(Box, { mb: "2" },
        React__default.createElement(Typography, { id: titleId, fontSkin: "body-standard-bold", "aria-required": productOption.isRequired ? "true" : undefined, as: "label" },
            React__default.createElement(SimpleTitleText, { showSelectedOptionText: showSelectedOptionText }))));
};

const MinimalButtonSkin = ({ option, locale, currency, fractionDigits, showIncompatibleChoices, priceDisplayMode = "differential-unit", tenant, onChanged, }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const titleId = useId();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", skin: "buttons", selectedValue: option.selectedKey, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId, "aria-required": option.isRequired }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice) => (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible },
            React__default.createElement(SelectionSetLabel, { mr: "3", mb: "3", style: { padding: "0px 10px", height: "4em" } },
                React__default.createElement(SelectionSetTileContents, null,
                    React__default.createElement(FlexBox, { flexDirection: "column" },
                        React__default.createElement(Typography, { fontSize: "small", fontWeight: "bold" }, choice.name),
                        priceDisplayMode === "none" || choice.key === option.selectedKey ? (React__default.createElement(React__default.Fragment, null, "\xa0")) : (React__default.createElement(OptionPriceDisplay, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true, tenant: tenant })))))))))));
};

const SelectionSetTileCallouts = ({ callouts }) => {
    return (React__default.createElement(React__default.Fragment, null, callouts?.map((callout) => {
        return (React__default.createElement(Callout, { key: callout.key, skin: callout.style ?? "accent", emphasis: "low" }, callout.text));
    })));
};

/**
 * marked v13.0.2 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

/**
 * Gets the original marked default options.
 */
function _getDefaults() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
let _defaults = _getDefaults();
function changeDefaults(newDefaults) {
    _defaults = newDefaults;
}

/**
 * Helpers
 */
const escapeTest = /[&<>"']/;
const escapeReplace = new RegExp(escapeTest.source, 'g');
const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
const escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape$1(html, encode) {
    if (encode) {
        if (escapeTest.test(html)) {
            return html.replace(escapeReplace, getEscapeReplacement);
        }
    }
    else {
        if (escapeTestNoEncode.test(html)) {
            return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
    }
    return html;
}
const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, (_, n) => {
        n = n.toLowerCase();
        if (n === 'colon')
            return ':';
        if (n.charAt(0) === '#') {
            return n.charAt(1) === 'x'
                ? String.fromCharCode(parseInt(n.substring(2), 16))
                : String.fromCharCode(+n.substring(1));
        }
        return '';
    });
}
const caret = /(^|[^\[])\^/g;
function edit(regex, opt) {
    let source = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    const obj = {
        replace: (name, val) => {
            let valSource = typeof val === 'string' ? val : val.source;
            valSource = valSource.replace(caret, '$1');
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: () => {
            return new RegExp(source, opt);
        }
    };
    return obj;
}
function cleanUrl(href) {
    try {
        href = encodeURI(href).replace(/%25/g, '%');
    }
    catch (e) {
        return null;
    }
    return href;
}
const noopTest = { exec: () => null };
function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    const row = tableRow.replace(/\|/g, (match, offset, str) => {
        let escaped = false;
        let curr = offset;
        while (--curr >= 0 && str[curr] === '\\')
            escaped = !escaped;
        if (escaped) {
            // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
        }
        else {
            // add space before unescaped |
            return ' |';
        }
    }), cells = row.split(/ \|/);
    let i = 0;
    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
        cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
        cells.pop();
    }
    if (count) {
        if (cells.length > count) {
            cells.splice(count);
        }
        else {
            while (cells.length < count)
                cells.push('');
        }
    }
    for (; i < cells.length; i++) {
        // leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
}
/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param str
 * @param c
 * @param invert Remove suffix of non-c chars instead. Default falsey.
 */
function rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) {
        return '';
    }
    // Length of suffix matching the invert condition.
    let suffLen = 0;
    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) {
            suffLen++;
        }
        else if (currChar !== c && invert) {
            suffLen++;
        }
        else {
            break;
        }
    }
    return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
        return -1;
    }
    let level = 0;
    for (let i = 0; i < str.length; i++) {
        if (str[i] === '\\') {
            i++;
        }
        else if (str[i] === b[0]) {
            level++;
        }
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) {
                return i;
            }
        }
    }
    return -1;
}

function outputLink(cap, link, raw, lexer) {
    const href = link.href;
    const title = link.title ? escape$1(link.title) : null;
    const text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
        lexer.state.inLink = true;
        const token = {
            type: 'link',
            raw,
            href,
            title,
            text,
            tokens: lexer.inlineTokens(text)
        };
        lexer.state.inLink = false;
        return token;
    }
    return {
        type: 'image',
        raw,
        href,
        title,
        text: escape$1(text)
    };
}
function indentCodeCompensation(raw, text) {
    const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
        return text;
    }
    const indentToCode = matchIndentToCode[1];
    return text
        .split('\n')
        .map(node => {
        const matchIndentInNode = node.match(/^\s+/);
        if (matchIndentInNode === null) {
            return node;
        }
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) {
            return node.slice(indentToCode.length);
        }
        return node;
    })
        .join('\n');
}
/**
 * Tokenizer
 */
class _Tokenizer {
    options;
    rules; // set by the lexer
    lexer; // set by the lexer
    constructor(options) {
        this.options = options || _defaults;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) {
            return {
                type: 'space',
                raw: cap[0]
            };
        }
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(/^ {1,4}/gm, '');
            return {
                type: 'code',
                raw: cap[0],
                codeBlockStyle: 'indented',
                text: !this.options.pedantic
                    ? rtrim(text, '\n')
                    : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = indentCodeCompensation(raw, cap[3] || '');
            return {
                type: 'code',
                raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            // remove trailing #s
            if (/#$/.test(text)) {
                const trimmed = rtrim(text, '#');
                if (this.options.pedantic) {
                    text = trimmed.trim();
                }
                else if (!trimmed || / $/.test(trimmed)) {
                    // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
            }
            return {
                type: 'heading',
                raw: cap[0],
                depth: cap[1].length,
                text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) {
            return {
                type: 'hr',
                raw: rtrim(cap[0], '\n')
            };
        }
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = rtrim(cap[0], '\n').split('\n');
            let raw = '';
            let text = '';
            const tokens = [];
            while (lines.length > 0) {
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for (i = 0; i < lines.length; i++) {
                    // get lines up to a continuation
                    if (/^ {0,3}>/.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    }
                    else if (!inBlockquote) {
                        currentLines.push(lines[i]);
                    }
                    else {
                        break;
                    }
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join('\n');
                const currentText = currentRaw
                    // precede setext continuation with 4 spaces so it isn't a setext
                    .replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, '\n    $1')
                    .replace(/^ {0,3}>[ \t]?/gm, '');
                raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                text = text ? `${text}\n${currentText}` : currentText;
                // parse blockquote lines as top level tokens
                // merge paragraphs if this is a continuation
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                // if there is no continuation then we are done
                if (lines.length === 0) {
                    break;
                }
                const lastToken = tokens[tokens.length - 1];
                if (lastToken?.type === 'code') {
                    // blockquote continuation cannot be preceded by a code block
                    break;
                }
                else if (lastToken?.type === 'blockquote') {
                    // include continuation in nested blockquote
                    const oldToken = lastToken;
                    const newText = oldToken.raw + '\n' + lines.join('\n');
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                }
                else if (lastToken?.type === 'list') {
                    // include continuation in nested list
                    const oldToken = lastToken;
                    const newText = oldToken.raw + '\n' + lines.join('\n');
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens[tokens.length - 1].raw.length).split('\n');
                    continue;
                }
            }
            return {
                type: 'blockquote',
                raw,
                tokens,
                text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list = {
                type: 'list',
                raw: '',
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : '',
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) {
                bull = isordered ? bull : '[*+-]';
            }
            // Get next list item
            const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
            let endsWithBlankLine = false;
            // Check if current bullet point can start a new List Item
            while (src) {
                let endEarly = false;
                let raw = '';
                let itemContents = '';
                if (!(cap = itemRegex.exec(src))) {
                    break;
                }
                if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
                    break;
                }
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t) => ' '.repeat(3 * t.length));
                let nextLine = src.split('\n', 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                }
                else if (blankLine) {
                    indent = cap[1].length + 1;
                }
                else {
                    indent = cap[2].search(/[^ ]/); // Find first non-space char
                    indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && /^ *$/.test(nextLine)) { // Items begin with at most one blank line
                    raw += nextLine + '\n';
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                    const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                    const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                    const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                    // Check if following lines should be included in List Item
                    while (src) {
                        const rawLine = src.split('\n', 1)[0];
                        nextLine = rawLine;
                        // Re-align to follow commonmark nesting rules
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                        }
                        // End list item if found code fences
                        if (fencesBeginRegex.test(nextLine)) {
                            break;
                        }
                        // End list item if found start of new heading
                        if (headingBeginRegex.test(nextLine)) {
                            break;
                        }
                        // End list item if found start of new bullet
                        if (nextBulletRegex.test(nextLine)) {
                            break;
                        }
                        // Horizontal rule found
                        if (hrRegex.test(src)) {
                            break;
                        }
                        if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) { // Dedent if possible
                            itemContents += '\n' + nextLine.slice(indent);
                        }
                        else {
                            // not enough indentation
                            if (blankLine) {
                                break;
                            }
                            // paragraph continuation unless last line was a different block level element
                            if (line.search(/[^ ]/) >= 4) { // indented code block
                                break;
                            }
                            if (fencesBeginRegex.test(line)) {
                                break;
                            }
                            if (headingBeginRegex.test(line)) {
                                break;
                            }
                            if (hrRegex.test(line)) {
                                break;
                            }
                            itemContents += '\n' + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) { // Check if current line is blank
                            blankLine = true;
                        }
                        raw += rawLine + '\n';
                        src = src.substring(rawLine.length + 1);
                        line = nextLine.slice(indent);
                    }
                }
                if (!list.loose) {
                    // If the previous item ended with a blank line, the list is loose
                    if (endsWithBlankLine) {
                        list.loose = true;
                    }
                    else if (/\n *\n *$/.test(raw)) {
                        endsWithBlankLine = true;
                    }
                }
                let istask = null;
                let ischecked;
                // Check for task list items
                if (this.options.gfm) {
                    istask = /^\[[ xX]\] /.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== '[ ] ';
                        itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                    }
                }
                list.items.push({
                    type: 'list_item',
                    raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list.raw += raw;
            }
            // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
            list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
            list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
            list.raw = list.raw.trimEnd();
            // Item child tokens handled here at end because we needed to have the final item to trim it first
            for (let i = 0; i < list.items.length; i++) {
                this.lexer.state.top = false;
                list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                if (!list.loose) {
                    // Check if list should be loose
                    const spacers = list.items[i].tokens.filter(t => t.type === 'space');
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some(t => /\n.*\n/.test(t.raw));
                    list.loose = hasMultipleLineBreaks;
                }
            }
            // Set all items to loose if list is loose
            if (list.loose) {
                for (let i = 0; i < list.items.length; i++) {
                    list.items[i].loose = true;
                }
            }
            return list;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: 'html',
                block: true,
                raw: cap[0],
                pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
            const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
            return {
                type: 'def',
                tag,
                raw: cap[0],
                href,
                title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) {
            return;
        }
        if (!/[:|]/.test(cap[2])) {
            // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
        }
        const headers = splitCells(cap[1]);
        const aligns = cap[2].replace(/^\||\| *$/g, '').split('|');
        const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : [];
        const item = {
            type: 'table',
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) {
            // header and align columns must be equal, rows can be different.
            return;
        }
        for (const align of aligns) {
            if (/^ *-+: *$/.test(align)) {
                item.align.push('right');
            }
            else if (/^ *:-+: *$/.test(align)) {
                item.align.push('center');
            }
            else if (/^ *:-+ *$/.test(align)) {
                item.align.push('left');
            }
            else {
                item.align.push(null);
            }
        }
        for (let i = 0; i < headers.length; i++) {
            item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
        }
        for (const row of rows) {
            item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
        }
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) {
            return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === '\n'
                ? cap[1].slice(0, -1)
                : cap[1];
            return {
                type: 'paragraph',
                raw: cap[0],
                text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) {
            return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) {
            return {
                type: 'escape',
                raw: cap[0],
                text: escape$1(cap[1])
            };
        }
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
                this.lexer.state.inLink = true;
            }
            else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
                this.lexer.state.inLink = false;
            }
            if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                this.lexer.state.inRawBlock = true;
            }
            else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
                this.lexer.state.inRawBlock = false;
            }
            return {
                type: 'html',
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                // commonmark requires matching angle brackets
                if (!(/>$/.test(trimmedUrl))) {
                    return;
                }
                // ending angle bracket cannot be escaped
                const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
                    return;
                }
            }
            else {
                // find closing parenthesis
                const lastParenIndex = findClosingBracket(cap[2], '()');
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = '';
                }
            }
            let href = cap[2];
            let title = '';
            if (this.options.pedantic) {
                // split pedantic href and title
                const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                if (link) {
                    href = link[1];
                    title = link[3];
                }
            }
            else {
                title = cap[3] ? cap[3].slice(1, -1) : '';
            }
            href = href.trim();
            if (/^</.test(href)) {
                if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
                    // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                }
                else {
                    href = href.slice(1, -1);
                }
            }
            return outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title
            }, cap[0], this.lexer);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src))
            || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(/\s+/g, ' ');
            const link = links[linkString.toLowerCase()];
            if (!link) {
                const text = cap[0].charAt(0);
                return {
                    type: 'text',
                    raw: text,
                    text
                };
            }
            return outputLink(cap, link, cap[0], this.lexer);
        }
    }
    emStrong(src, maskedSrc, prevChar = '') {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match)
            return;
        // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
        if (match[3] && prevChar.match(/[\p{L}\p{N}]/u))
            return;
        const nextChar = match[1] || match[2] || '';
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
            const lLength = [...match[0]].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            // Clip maskedSrc to same section of string as src (move to lexer?)
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while ((match = endReg.exec(maskedSrc)) != null) {
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim)
                    continue; // skip single * in __abc*abc__
                rLength = [...rDelim].length;
                if (match[3] || match[4]) { // found another Left Delim
                    delimTotal += rLength;
                    continue;
                }
                else if (match[5] || match[6]) { // either Left or Right Delim
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue; // CommonMark Emphasis Rules 9-10
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0)
                    continue; // Haven't found enough closing delimiters
                // Remove extra characters. *a*** -> *a*
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                // char length can be >1 for unicode characters;
                const lastCharLength = [...match[0]][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                // Create `em` if smallest delimiter has odd char count. *a***
                if (Math.min(lLength, rLength) % 2) {
                    const text = raw.slice(1, -1);
                    return {
                        type: 'em',
                        raw,
                        text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
                // Create 'strong' if smallest delimiter has even char count. **a***
                const text = raw.slice(2, -2);
                return {
                    type: 'strong',
                    raw,
                    text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(/\n/g, ' ');
            const hasNonSpaceChars = /[^ ]/.test(text);
            const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
                text = text.substring(1, text.length - 1);
            }
            text = escape$1(text, true);
            return {
                type: 'codespan',
                raw: cap[0],
                text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) {
            return {
                type: 'br',
                raw: cap[0]
            };
        }
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) {
            return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === '@') {
                text = escape$1(cap[1]);
                href = 'mailto:' + text;
            }
            else {
                text = escape$1(cap[1]);
                href = text;
            }
            return {
                type: 'link',
                raw: cap[0],
                text,
                href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === '@') {
                text = escape$1(cap[0]);
                href = 'mailto:' + text;
            }
            else {
                // do extended autolink path validation
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                } while (prevCapZero !== cap[0]);
                text = escape$1(cap[0]);
                if (cap[1] === 'www.') {
                    href = 'http://' + cap[0];
                }
                else {
                    href = cap[0];
                }
            }
            return {
                type: 'link',
                raw: cap[0],
                text,
                href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            let text;
            if (this.lexer.state.inRawBlock) {
                text = cap[0];
            }
            else {
                text = escape$1(cap[0]);
            }
            return {
                type: 'text',
                raw: cap[0],
                text
            };
        }
    }
}

/**
 * Block-Level Grammar
 */
const newline = /^(?: *(?:\n|$))+/;
const blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
const bullet = /(?:[*+-]|\d{1,9}[.)])/;
const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/)
    .replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, / {4}/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .getRegex();
const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
const blockText = /^[^\n]+/;
const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
const def = edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/)
    .replace('label', _blockLabel)
    .replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/)
    .getRegex();
const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/)
    .replace(/bull/g, bullet)
    .getRegex();
const _tag = 'address|article|aside|base|basefont|blockquote|body|caption'
    + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
    + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
    + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
    + '|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title'
    + '|tr|track|ul';
const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
const html = edit('^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')', 'i')
    .replace('comment', _comment)
    .replace('tag', _tag)
    .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
    .getRegex();
const paragraph = edit(_paragraph)
    .replace('hr', hr)
    .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
    .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
    .replace('|table', '')
    .replace('blockquote', ' {0,3}>')
    .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
    .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
    .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/)
    .replace('paragraph', paragraph)
    .getRegex();
/**
 * Normal Block Grammar
 */
const blockNormal = {
    blockquote,
    code: blockCode,
    def,
    fences,
    heading,
    hr,
    html,
    lheading,
    list,
    newline,
    paragraph,
    table: noopTest,
    text: blockText
};
/**
 * GFM Block Grammar
 */
const gfmTable = edit('^ *([^\\n ].*)\\n' // Header
    + ' {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)') // Cells
    .replace('hr', hr)
    .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
    .replace('blockquote', ' {0,3}>')
    .replace('code', ' {4}[^\\n]')
    .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
    .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
    .replace('tag', _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
const blockGfm = {
    ...blockNormal,
    table: gfmTable,
    paragraph: edit(_paragraph)
        .replace('hr', hr)
        .replace('heading', ' {0,3}#{1,6}(?:\\s|$)')
        .replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
        .replace('table', gfmTable) // interrupt paragraphs with table
        .replace('blockquote', ' {0,3}>')
        .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
        .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
        .replace('tag', _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
};
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */
const blockPedantic = {
    ...blockNormal,
    html: edit('^ *(?:comment *(?:\\n|\\s*$)'
        + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
        + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
        .replace('comment', _comment)
        .replace(/tag/g, '(?!(?:'
        + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
        + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
        + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
        .getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest, // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(_paragraph)
        .replace('hr', hr)
        .replace('heading', ' *#{1,6} *[^\n]')
        .replace('lheading', lheading)
        .replace('|table', '')
        .replace('blockquote', ' {0,3}>')
        .replace('|fences', '')
        .replace('|list', '')
        .replace('|html', '')
        .replace('|tag', '')
        .getRegex()
};
/**
 * Inline-Level Grammar
 */
const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
const br = /^( {2,}|\\)\n(?!\s*$)/;
const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
// list of unicode punctuation marks, plus any missing characters from CommonMark spec
const _punctuation = '\\p{P}\\p{S}';
const punctuation = edit(/^((?![*_])[\spunctuation])/, 'u')
    .replace(/punctuation/g, _punctuation).getRegex();
// sequences em should skip over [title](link), `code`, <html>
const blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, 'u')
    .replace(/punct/g, _punctuation)
    .getRegex();
const emStrongRDelimAst = edit('^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)' // Skip orphan inside strong
    + '|[^*]+(?=[^*])' // Consume to delim
    + '|(?!\\*)[punct](\\*+)(?=[\\s]|$)' // (1) #*** can only be a Right Delimiter
    + '|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)' // (2) a***#, a*** can only be a Right Delimiter
    + '|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])' // (3) #***a, ***a can only be Left Delimiter
    + '|[\\s](\\*+)(?!\\*)(?=[punct])' // (4) ***# can only be Left Delimiter
    + '|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])' // (5) #***# can be either Left or Right Delimiter
    + '|[^punct\\s](\\*+)(?=[^punct\\s])', 'gu') // (6) a***a can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation)
    .getRegex();
// (6) Not allowed for _
const emStrongRDelimUnd = edit('^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)' // Skip orphan inside strong
    + '|[^_]+(?=[^_])' // Consume to delim
    + '|(?!_)[punct](_+)(?=[\\s]|$)' // (1) #___ can only be a Right Delimiter
    + '|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)' // (2) a___#, a___ can only be a Right Delimiter
    + '|(?!_)[punct\\s](_+)(?=[^punct\\s])' // (3) #___a, ___a can only be Left Delimiter
    + '|[\\s](_+)(?!_)(?=[punct])' // (4) ___# can only be Left Delimiter
    + '|(?!_)[punct](_+)(?!_)(?=[punct])', 'gu') // (5) #___# can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation)
    .getRegex();
const anyPunctuation = edit(/\\([punct])/, 'gu')
    .replace(/punct/g, _punctuation)
    .getRegex();
const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/)
    .replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/)
    .replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/)
    .getRegex();
const _inlineComment = edit(_comment).replace('(?:-->|$)', '-->').getRegex();
const tag = edit('^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>') // CDATA section
    .replace('comment', _inlineComment)
    .replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/)
    .getRegex();
const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/)
    .replace('label', _inlineLabel)
    .replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/)
    .replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/)
    .getRegex();
const reflink = edit(/^!?\[(label)\]\[(ref)\]/)
    .replace('label', _inlineLabel)
    .replace('ref', _blockLabel)
    .getRegex();
const nolink = edit(/^!?\[(ref)\](?:\[\])?/)
    .replace('ref', _blockLabel)
    .getRegex();
const reflinkSearch = edit('reflink|nolink(?!\\()', 'g')
    .replace('reflink', reflink)
    .replace('nolink', nolink)
    .getRegex();
/**
 * Normal Inline Grammar
 */
const inlineNormal = {
    _backpedal: noopTest, // only used for GFM url
    anyPunctuation,
    autolink,
    blockSkip,
    br,
    code: inlineCode,
    del: noopTest,
    emStrongLDelim,
    emStrongRDelimAst,
    emStrongRDelimUnd,
    escape,
    link,
    nolink,
    punctuation,
    reflink,
    reflinkSearch,
    tag,
    text: inlineText,
    url: noopTest
};
/**
 * Pedantic Inline Grammar
 */
const inlinePedantic = {
    ...inlineNormal,
    link: edit(/^!?\[(label)\]\((.*?)\)/)
        .replace('label', _inlineLabel)
        .getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
        .replace('label', _inlineLabel)
        .getRegex()
};
/**
 * GFM Inline Grammar
 */
const inlineGfm = {
    ...inlineNormal,
    escape: edit(escape).replace('])', '~|])').getRegex(),
    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i')
        .replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/)
        .getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
/**
 * GFM + Line Breaks Inline Grammar
 */
const inlineBreaks = {
    ...inlineGfm,
    br: edit(br).replace('{2,}', '*').getRegex(),
    text: edit(inlineGfm.text)
        .replace('\\b_', '\\b_| {2,}\\n')
        .replace(/\{2,\}/g, '*')
        .getRegex()
};
/**
 * exports
 */
const block = {
    normal: blockNormal,
    gfm: blockGfm,
    pedantic: blockPedantic
};
const inline = {
    normal: inlineNormal,
    gfm: inlineGfm,
    breaks: inlineBreaks,
    pedantic: inlinePedantic
};

/**
 * Block Lexer
 */
class _Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options) {
        // TokenList cannot be created in one go
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options || _defaults;
        this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            block: block.normal,
            inline: inline.normal
        };
        if (this.options.pedantic) {
            rules.block = block.pedantic;
            rules.inline = inline.pedantic;
        }
        else if (this.options.gfm) {
            rules.block = block.gfm;
            if (this.options.breaks) {
                rules.inline = inline.breaks;
            }
            else {
                rules.inline = inline.gfm;
            }
        }
        this.tokenizer.rules = rules;
    }
    /**
     * Expose Rules
     */
    static get rules() {
        return {
            block,
            inline
        };
    }
    /**
     * Static Lex Method
     */
    static lex(src, options) {
        const lexer = new _Lexer(options);
        return lexer.lex(src);
    }
    /**
     * Static Lex Inline Method
     */
    static lexInline(src, options) {
        const lexer = new _Lexer(options);
        return lexer.inlineTokens(src);
    }
    /**
     * Preprocessing
     */
    lex(src) {
        src = src
            .replace(/\r\n|\r/g, '\n');
        this.blockTokens(src, this.tokens);
        for (let i = 0; i < this.inlineQueue.length; i++) {
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) {
            src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
        }
        else {
            src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs) => {
                return leading + '    '.repeat(tabs.length);
            });
        }
        let token;
        let lastToken;
        let cutSrc;
        while (src) {
            if (this.options.extensions
                && this.options.extensions.block
                && this.options.extensions.block.some((extTokenizer) => {
                    if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) {
                continue;
            }
            // newline
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                if (token.raw.length === 1 && tokens.length > 0) {
                    // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    tokens[tokens.length - 1].raw += '\n';
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            // code
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                // An indented code block cannot interrupt a paragraph.
                if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            // fences
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // heading
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // hr
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // blockquote
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // list
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // html
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // def
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.raw;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                }
                else if (!this.tokens.links[token.tag]) {
                    this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                }
                continue;
            }
            // table (gfm)
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // lheading
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // top-level paragraph
            // prevent paragraph consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex) => {
                    tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) {
                        startIndex = Math.min(startIndex, tempStart);
                    }
                });
                if (startIndex < Infinity && startIndex >= 0) {
                    cutSrc = src.substring(0, startIndex + 1);
                }
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                lastToken = tokens[tokens.length - 1];
                if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                }
                else {
                    tokens.push(token);
                }
                lastParagraphClipped = (cutSrc.length !== src.length);
                src = src.substring(token.raw.length);
                continue;
            }
            // text
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === 'text') {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                }
                else {
                    throw new Error(errMsg);
                }
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({ src, tokens });
        return tokens;
    }
    /**
     * Lexing/Compiling
     */
    inlineTokens(src, tokens = []) {
        let token, lastToken, cutSrc;
        // String with links masked to avoid interference with em and strong
        let maskedSrc = src;
        let match;
        let keepPrevChar, prevChar;
        // Mask out reflinks
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
                    if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
                        maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                    }
                }
            }
        }
        // Mask out other blocks
        while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
            maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        }
        // Mask out escaped characters
        while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
            maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        }
        while (src) {
            if (!keepPrevChar) {
                prevChar = '';
            }
            keepPrevChar = false;
            // extensions
            if (this.options.extensions
                && this.options.extensions.inline
                && this.options.extensions.inline.some((extTokenizer) => {
                    if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) {
                continue;
            }
            // escape
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // tag
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            // link
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // reflink, nolink
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            // em & strong
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // br
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // del (gfm)
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // autolink
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // url (gfm)
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // text
            // prevent inlineText consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex) => {
                    tempStart = getStartIndex.call({ lexer: this }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) {
                        startIndex = Math.min(startIndex, tempStart);
                    }
                });
                if (startIndex < Infinity && startIndex >= 0) {
                    cutSrc = src.substring(0, startIndex + 1);
                }
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                }
                keepPrevChar = true;
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                }
                else {
                    tokens.push(token);
                }
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                }
                else {
                    throw new Error(errMsg);
                }
            }
        }
        return tokens;
    }
}

/**
 * Renderer
 */
class _Renderer {
    options;
    parser; // set by the parser
    constructor(options) {
        this.options = options || _defaults;
    }
    space(token) {
        return '';
    }
    code({ text, lang, escaped }) {
        const langString = (lang || '').match(/^\S*/)?.[0];
        const code = text.replace(/\n$/, '') + '\n';
        if (!langString) {
            return '<pre><code>'
                + (escaped ? code : escape$1(code, true))
                + '</code></pre>\n';
        }
        return '<pre><code class="language-'
            + escape$1(langString)
            + '">'
            + (escaped ? code : escape$1(code, true))
            + '</code></pre>\n';
    }
    blockquote({ tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>\n${body}</blockquote>\n`;
    }
    html({ text }) {
        return text;
    }
    heading({ tokens, depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
    }
    hr(token) {
        return '<hr>\n';
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = '';
        for (let j = 0; j < token.items.length; j++) {
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? 'ol' : 'ul';
        const startAttr = (ordered && start !== 1) ? (' start="' + start + '"') : '';
        return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
    }
    listitem(item) {
        let itemBody = '';
        if (item.task) {
            const checkbox = this.checkbox({ checked: !!item.checked });
            if (item.loose) {
                if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                    item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                    }
                }
                else {
                    item.tokens.unshift({
                        type: 'text',
                        raw: checkbox + ' ',
                        text: checkbox + ' '
                    });
                }
            }
            else {
                itemBody += checkbox + ' ';
            }
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>\n`;
    }
    checkbox({ checked }) {
        return '<input '
            + (checked ? 'checked="" ' : '')
            + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>\n`;
    }
    table(token) {
        let header = '';
        // header
        let cell = '';
        for (let j = 0; j < token.header.length; j++) {
            cell += this.tablecell(token.header[j]);
        }
        header += this.tablerow({ text: cell });
        let body = '';
        for (let j = 0; j < token.rows.length; j++) {
            const row = token.rows[j];
            cell = '';
            for (let k = 0; k < row.length; k++) {
                cell += this.tablecell(row[k]);
            }
            body += this.tablerow({ text: cell });
        }
        if (body)
            body = `<tbody>${body}</tbody>`;
        return '<table>\n'
            + '<thead>\n'
            + header
            + '</thead>\n'
            + body
            + '</table>\n';
    }
    tablerow({ text }) {
        return `<tr>\n${text}</tr>\n`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? 'th' : 'td';
        const tag = token.align
            ? `<${type} align="${token.align}">`
            : `<${type}>`;
        return tag + content + `</${type}>\n`;
    }
    /**
     * span level renderer
     */
    strong({ tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text }) {
        return `<code>${text}</code>`;
    }
    br(token) {
        return '<br>';
    }
    del({ tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href, title, tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = cleanUrl(href);
        if (cleanHref === null) {
            return text;
        }
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) {
            out += ' title="' + title + '"';
        }
        out += '>' + text + '</a>';
        return out;
    }
    image({ href, title, text }) {
        const cleanHref = cleanUrl(href);
        if (cleanHref === null) {
            return text;
        }
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) {
            out += ` title="${title}"`;
        }
        out += '>';
        return out;
    }
    text(token) {
        return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : token.text;
    }
}

/**
 * TextRenderer
 * returns only the textual part of the token
 */
class _TextRenderer {
    // no need for block level renderers
    strong({ text }) {
        return text;
    }
    em({ text }) {
        return text;
    }
    codespan({ text }) {
        return text;
    }
    del({ text }) {
        return text;
    }
    html({ text }) {
        return text;
    }
    text({ text }) {
        return text;
    }
    link({ text }) {
        return '' + text;
    }
    image({ text }) {
        return '' + text;
    }
    br() {
        return '';
    }
}

/**
 * Parsing & Compiling
 */
class _Parser {
    options;
    renderer;
    textRenderer;
    constructor(options) {
        this.options = options || _defaults;
        this.options.renderer = this.options.renderer || new _Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new _TextRenderer();
    }
    /**
     * Static Parse Method
     */
    static parse(tokens, options) {
        const parser = new _Parser(options);
        return parser.parse(tokens);
    }
    /**
     * Static Parse Inline Method
     */
    static parseInline(tokens, options) {
        const parser = new _Parser(options);
        return parser.parseInline(tokens);
    }
    /**
     * Parse Loop
     */
    parse(tokens, top = true) {
        let out = '';
        for (let i = 0; i < tokens.length; i++) {
            const anyToken = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
                if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(genericToken.type)) {
                    out += ret || '';
                    continue;
                }
            }
            const token = anyToken;
            switch (token.type) {
                case 'space': {
                    out += this.renderer.space(token);
                    continue;
                }
                case 'hr': {
                    out += this.renderer.hr(token);
                    continue;
                }
                case 'heading': {
                    out += this.renderer.heading(token);
                    continue;
                }
                case 'code': {
                    out += this.renderer.code(token);
                    continue;
                }
                case 'table': {
                    out += this.renderer.table(token);
                    continue;
                }
                case 'blockquote': {
                    out += this.renderer.blockquote(token);
                    continue;
                }
                case 'list': {
                    out += this.renderer.list(token);
                    continue;
                }
                case 'html': {
                    out += this.renderer.html(token);
                    continue;
                }
                case 'paragraph': {
                    out += this.renderer.paragraph(token);
                    continue;
                }
                case 'text': {
                    let textToken = token;
                    let body = this.renderer.text(textToken);
                    while (i + 1 < tokens.length && tokens[i + 1].type === 'text') {
                        textToken = tokens[++i];
                        body += '\n' + this.renderer.text(textToken);
                    }
                    if (top) {
                        out += this.renderer.paragraph({
                            type: 'paragraph',
                            raw: body,
                            text: body,
                            tokens: [{ type: 'text', raw: body, text: body }]
                        });
                    }
                    else {
                        out += body;
                    }
                    continue;
                }
                default: {
                    const errMsg = 'Token with "' + token.type + '" type was not found.';
                    if (this.options.silent) {
                        console.error(errMsg);
                        return '';
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
        }
        return out;
    }
    /**
     * Parse Inline Tokens
     */
    parseInline(tokens, renderer) {
        renderer = renderer || this.renderer;
        let out = '';
        for (let i = 0; i < tokens.length; i++) {
            const anyToken = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
                if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(anyToken.type)) {
                    out += ret || '';
                    continue;
                }
            }
            const token = anyToken;
            switch (token.type) {
                case 'escape': {
                    out += renderer.text(token);
                    break;
                }
                case 'html': {
                    out += renderer.html(token);
                    break;
                }
                case 'link': {
                    out += renderer.link(token);
                    break;
                }
                case 'image': {
                    out += renderer.image(token);
                    break;
                }
                case 'strong': {
                    out += renderer.strong(token);
                    break;
                }
                case 'em': {
                    out += renderer.em(token);
                    break;
                }
                case 'codespan': {
                    out += renderer.codespan(token);
                    break;
                }
                case 'br': {
                    out += renderer.br(token);
                    break;
                }
                case 'del': {
                    out += renderer.del(token);
                    break;
                }
                case 'text': {
                    out += renderer.text(token);
                    break;
                }
                default: {
                    const errMsg = 'Token with "' + token.type + '" type was not found.';
                    if (this.options.silent) {
                        console.error(errMsg);
                        return '';
                    }
                    else {
                        throw new Error(errMsg);
                    }
                }
            }
        }
        return out;
    }
}

class _Hooks {
    options;
    constructor(options) {
        this.options = options || _defaults;
    }
    static passThroughHooks = new Set([
        'preprocess',
        'postprocess',
        'processAllTokens'
    ]);
    /**
     * Process markdown before marked
     */
    preprocess(markdown) {
        return markdown;
    }
    /**
     * Process HTML after marked is finished
     */
    postprocess(html) {
        return html;
    }
    /**
     * Process all tokens before walk tokens
     */
    processAllTokens(tokens) {
        return tokens;
    }
}

class Marked {
    defaults = _getDefaults();
    options = this.setOptions;
    parse = this.#parseMarkdown(_Lexer.lex, _Parser.parse);
    parseInline = this.#parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
    Parser = _Parser;
    Renderer = _Renderer;
    TextRenderer = _TextRenderer;
    Lexer = _Lexer;
    Tokenizer = _Tokenizer;
    Hooks = _Hooks;
    constructor(...args) {
        this.use(...args);
    }
    /**
     * Run callback for every token
     */
    walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens) {
            values = values.concat(callback.call(this, token));
            switch (token.type) {
                case 'table': {
                    const tableToken = token;
                    for (const cell of tableToken.header) {
                        values = values.concat(this.walkTokens(cell.tokens, callback));
                    }
                    for (const row of tableToken.rows) {
                        for (const cell of row) {
                            values = values.concat(this.walkTokens(cell.tokens, callback));
                        }
                    }
                    break;
                }
                case 'list': {
                    const listToken = token;
                    values = values.concat(this.walkTokens(listToken.items, callback));
                    break;
                }
                default: {
                    const genericToken = token;
                    if (this.defaults.extensions?.childTokens?.[genericToken.type]) {
                        this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
                            const tokens = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens, callback));
                        });
                    }
                    else if (genericToken.tokens) {
                        values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
                }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || { renderers: {}, childTokens: {} };
        args.forEach((pack) => {
            // copy options to new object
            const opts = { ...pack };
            // set async to true if it was set to true before
            opts.async = this.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach((ext) => {
                    if (!ext.name) {
                        throw new Error('extension name required');
                    }
                    if ('renderer' in ext) { // Renderer extensions
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) {
                            // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function (...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) {
                                    ret = prevRenderer.apply(this, args);
                                }
                                return ret;
                            };
                        }
                        else {
                            extensions.renderers[ext.name] = ext.renderer;
                        }
                    }
                    if ('tokenizer' in ext) { // Tokenizer Extensions
                        if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
                            throw new Error("extension level must be 'block' or 'inline'");
                        }
                        const extLevel = extensions[ext.level];
                        if (extLevel) {
                            extLevel.unshift(ext.tokenizer);
                        }
                        else {
                            extensions[ext.level] = [ext.tokenizer];
                        }
                        if (ext.start) { // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) {
                                    extensions.startBlock.push(ext.start);
                                }
                                else {
                                    extensions.startBlock = [ext.start];
                                }
                            }
                            else if (ext.level === 'inline') {
                                if (extensions.startInline) {
                                    extensions.startInline.push(ext.start);
                                }
                                else {
                                    extensions.startInline = [ext.start];
                                }
                            }
                        }
                    }
                    if ('childTokens' in ext && ext.childTokens) { // Child tokens to be visited by walkTokens
                        extensions.childTokens[ext.name] = ext.childTokens;
                    }
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                for (const prop in pack.renderer) {
                    if (!(prop in renderer)) {
                        throw new Error(`renderer '${prop}' does not exist`);
                    }
                    if (['options', 'parser'].includes(prop)) {
                        // ignore options property
                        continue;
                    }
                    const rendererProp = prop;
                    let rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[rendererProp] = (...args) => {
                        if (!pack.useNewRenderer) {
                            // TODO: Remove this in next major version
                            rendererFunc = this.#convertRendererFunction(rendererFunc, rendererProp, renderer);
                        }
                        let ret = rendererFunc.apply(renderer, args);
                        if (ret === false) {
                            ret = prevRenderer.apply(renderer, args);
                        }
                        return ret || '';
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                for (const prop in pack.tokenizer) {
                    if (!(prop in tokenizer)) {
                        throw new Error(`tokenizer '${prop}' does not exist`);
                    }
                    if (['options', 'rules', 'lexer'].includes(prop)) {
                        // ignore options, rules, and lexer properties
                        continue;
                    }
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    // Replace tokenizer with func to run extension, but fall back if false
                    // @ts-expect-error cannot type tokenizer function dynamically
                    tokenizer[tokenizerProp] = (...args) => {
                        let ret = tokenizerFunc.apply(tokenizer, args);
                        if (ret === false) {
                            ret = prevTokenizer.apply(tokenizer, args);
                        }
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new _Hooks();
                for (const prop in pack.hooks) {
                    if (!(prop in hooks)) {
                        throw new Error(`hook '${prop}' does not exist`);
                    }
                    if (prop === 'options') {
                        // ignore options property
                        continue;
                    }
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if (_Hooks.passThroughHooks.has(prop)) {
                        // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg) => {
                            if (this.defaults.async) {
                                return Promise.resolve(hooksFunc.call(hooks, arg)).then(ret => {
                                    return prevHook.call(hooks, ret);
                                });
                            }
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                    }
                    else {
                        // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args) => {
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) {
                                ret = prevHook.apply(hooks, args);
                            }
                            return ret;
                        };
                    }
                }
                opts.hooks = hooks;
            }
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                const walkTokens = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function (token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens) {
                        values = values.concat(walkTokens.call(this, token));
                    }
                    return values;
                };
            }
            this.defaults = { ...this.defaults, ...opts };
        });
        return this;
    }
    // TODO: Remove this in next major release
    #convertRendererFunction(func, prop, renderer) {
        switch (prop) {
            case 'heading':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, renderer.parser.parseInline(token.tokens), token.depth, unescape(renderer.parser.parseInline(token.tokens, renderer.parser.textRenderer)));
                };
            case 'code':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.text, token.lang, !!token.escaped);
                };
            case 'table':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    let header = '';
                    // header
                    let cell = '';
                    for (let j = 0; j < token.header.length; j++) {
                        cell += this.tablecell({
                            text: token.header[j].text,
                            tokens: token.header[j].tokens,
                            header: true,
                            align: token.align[j]
                        });
                    }
                    header += this.tablerow({ text: cell });
                    let body = '';
                    for (let j = 0; j < token.rows.length; j++) {
                        const row = token.rows[j];
                        cell = '';
                        for (let k = 0; k < row.length; k++) {
                            cell += this.tablecell({
                                text: row[k].text,
                                tokens: row[k].tokens,
                                header: false,
                                align: token.align[k]
                            });
                        }
                        body += this.tablerow({ text: cell });
                    }
                    return func.call(this, header, body);
                };
            case 'blockquote':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    const body = this.parser.parse(token.tokens);
                    return func.call(this, body);
                };
            case 'list':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    const ordered = token.ordered;
                    const start = token.start;
                    const loose = token.loose;
                    let body = '';
                    for (let j = 0; j < token.items.length; j++) {
                        const item = token.items[j];
                        const checked = item.checked;
                        const task = item.task;
                        let itemBody = '';
                        if (item.task) {
                            const checkbox = this.checkbox({ checked: !!checked });
                            if (loose) {
                                if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                                    item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    }
                                }
                                else {
                                    item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox + ' '
                                    });
                                }
                            }
                            else {
                                itemBody += checkbox + ' ';
                            }
                        }
                        itemBody += this.parser.parse(item.tokens, loose);
                        body += this.listitem({
                            type: 'list_item',
                            raw: itemBody,
                            text: itemBody,
                            task,
                            checked: !!checked,
                            loose,
                            tokens: item.tokens
                        });
                    }
                    return func.call(this, body, ordered, start);
                };
            case 'html':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.text, token.block);
                };
            case 'paragraph':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, this.parser.parseInline(token.tokens));
                };
            case 'escape':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.text);
                };
            case 'link':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.href, token.title, this.parser.parseInline(token.tokens));
                };
            case 'image':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.href, token.title, token.text);
                };
            case 'strong':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, this.parser.parseInline(token.tokens));
                };
            case 'em':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, this.parser.parseInline(token.tokens));
                };
            case 'codespan':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.text);
                };
            case 'del':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, this.parser.parseInline(token.tokens));
                };
            case 'text':
                return function (token) {
                    if (!token.type || token.type !== prop) {
                        // @ts-ignore
                        // eslint-disable-next-line prefer-rest-params
                        return func.apply(this, arguments);
                    }
                    return func.call(this, token.text);
                };
            // do nothing
        }
        return func;
    }
    setOptions(opt) {
        this.defaults = { ...this.defaults, ...opt };
        return this;
    }
    lexer(src, options) {
        return _Lexer.lex(src, options ?? this.defaults);
    }
    parser(tokens, options) {
        return _Parser.parse(tokens, options ?? this.defaults);
    }
    #parseMarkdown(lexer, parser) {
        return (src, options) => {
            const origOpt = { ...options };
            const opt = { ...this.defaults, ...origOpt };
            // Show warning if an extension set async to true but the parse was called with async: false
            if (this.defaults.async === true && origOpt.async === false) {
                if (!opt.silent) {
                    console.warn('marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.');
                }
                opt.async = true;
            }
            const throwError = this.#onError(!!opt.silent, !!opt.async);
            // throw error in case of non string input
            if (typeof src === 'undefined' || src === null) {
                return throwError(new Error('marked(): input parameter is undefined or null'));
            }
            if (typeof src !== 'string') {
                return throwError(new Error('marked(): input parameter is of type '
                    + Object.prototype.toString.call(src) + ', string expected'));
            }
            if (opt.hooks) {
                opt.hooks.options = opt;
            }
            if (opt.async) {
                return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src)
                    .then(src => lexer(src, opt))
                    .then(tokens => opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens)
                    .then(tokens => opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens)
                    .then(tokens => parser(tokens, opt))
                    .then(html => opt.hooks ? opt.hooks.postprocess(html) : html)
                    .catch(throwError);
            }
            try {
                if (opt.hooks) {
                    src = opt.hooks.preprocess(src);
                }
                let tokens = lexer(src, opt);
                if (opt.hooks) {
                    tokens = opt.hooks.processAllTokens(tokens);
                }
                if (opt.walkTokens) {
                    this.walkTokens(tokens, opt.walkTokens);
                }
                let html = parser(tokens, opt);
                if (opt.hooks) {
                    html = opt.hooks.postprocess(html);
                }
                return html;
            }
            catch (e) {
                return throwError(e);
            }
        };
    }
    #onError(silent, async) {
        return (e) => {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (silent) {
                const msg = '<p>An error occurred:</p><pre>'
                    + escape$1(e.message + '', true)
                    + '</pre>';
                if (async) {
                    return Promise.resolve(msg);
                }
                return msg;
            }
            if (async) {
                return Promise.reject(e);
            }
            throw e;
        };
    }
}

const markedInstance = new Marked();
function marked(src, opt) {
    return markedInstance.parse(src, opt);
}
/**
 * Sets the default options.
 *
 * @param options Hash of options
 */
marked.options =
    marked.setOptions = function (options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
/**
 * Gets the original marked default options.
 */
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
/**
 * Use Extension
 */
marked.use = function (...args) {
    markedInstance.use(...args);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
/**
 * Run callback for every token
 */
marked.walkTokens = function (tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
};
/**
 * Compiles markdown to HTML without enclosing `p` tag.
 *
 * @param src String of markdown source to be compiled
 * @param options Hash of options
 * @return String of compiled HTML
 */
marked.parseInline = markedInstance.parseInline;
/**
 * Expose
 */
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
marked.options;
marked.setOptions;
marked.use;
marked.walkTokens;
marked.parseInline;
_Parser.parse;
_Lexer.lex;

function OptionMarkdownText({ markdownText }) {
    // NOTE - marked.parse returns "string | Promise<string>". It will only ever
    // return a promise if you're using "async: true" and a custom "walkTokens" processor.
    // So... this is a safe cast to "string"
    // https://marked.js.org/using_pro#async
    const markdownHtml = marked.parse(markdownText ?? "", { async: false });
    return (React__default.createElement(React__default.Fragment, null, markdownText && (React__default.createElement(UncustomizableMarkup, { className: "product-options-markdown" },
        React__default.createElement("div", { dangerouslySetInnerHTML: { __html: markdownHtml } })))));
}

const SelectionSetTileDescription = ({ descriptionMarkdown }) => {
    return (React__default.createElement(React__default.Fragment, null, descriptionMarkdown && (React__default.createElement(SelectionSetTileDescription$1, null,
        React__default.createElement(OptionMarkdownText, { markdownText: descriptionMarkdown })))));
};

const ImageTileThumbnail = ({ choice }) => {
    if (!choice.image) {
        return null;
    }
    return (React__default.createElement(SelectionSetTileImageContainer, { style: { height: "unset" } },
        React__default.createElement(FluidImage, { alt: "", src: choice.image })));
};

const StandardButtonSkin = ({ option, locale, currency, fractionDigits, priceDisplayMode = "differential-unit", showIncompatibleChoices, hideImages, hideDescriptions, tenant, onChanged, }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const titleId = useId();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", skin: "tiles-mini", selectedValue: option.selectedKey, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId, "aria-required": option.isRequired }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice) => (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible },
            React__default.createElement(SelectionSetLabel, null,
                !hideImages && React__default.createElement(SelectionSetTileCallouts, { callouts: choice.callouts }),
                !hideImages && React__default.createElement(ImageTileThumbnail, { choice: choice }),
                React__default.createElement(SelectionSetTileContents, null,
                    React__default.createElement(SelectionSetTileName, null, choice.name),
                    priceDisplayMode === "none" || choice.key === option.selectedKey ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(SelectionSetTilePrice, null,
                        React__default.createElement(OptionPriceDisplay, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true, tenant: tenant }))),
                    !hideDescriptions && (React__default.createElement(SelectionSetTileDescription, { descriptionMarkdown: choice.description }))))))))));
};

const ProductOptionsFeaturesContext = React__default.createContext(undefined);
function useProductOptionsFeaturesContext() {
    return React__default.useContext(ProductOptionsFeaturesContext) ?? { disableSwanSnowflakes: false };
}

const tokenEngine = new TokenEngine();
const MAX_OPTIONS = 3;
function buildUnwindingMessageHtml(i18n, templateBase, violations, optionCausingUnselect) {
    const unwindingOptionCount = violations.length;
    const unwindingTemplateSuffix = unwindingOptionCount > Math.min(MAX_OPTIONS, violations.length)
        ? "more"
        : unwindingOptionCount.toString();
    const unwindingTemplateId = `${templateBase}_${unwindingTemplateSuffix}`;
    const unwindingOptionTokens = {
        ATTRIBUTE_COUNT: MAX_OPTIONS.toString(),
    };
    if (optionCausingUnselect) {
        (unwindingOptionTokens.ATTRIBUTE = getStyledText(optionCausingUnselect.attributeName, "normal")),
            (unwindingOptionTokens.OPTION = getStyledText(optionCausingUnselect.optionName, "bold"));
    }
    violations.forEach((v, index) => {
        const optionToken = `ATTRIBUTE${index + 1}`;
        const valueToken = `OPTION${index + 1}`;
        unwindingOptionTokens[optionToken] = getStyledText(v.attributeName, "normal");
        unwindingOptionTokens[valueToken] = getStyledText(v.optionName, "bold");
    });
    // This cast is necessary since we're building up the name of the template programmatically.
    // Likewise, the ?? coalesce below should remain
    const unwindingTemplate = i18n(unwindingTemplateId);
    return tokenEngine.replace(unwindingTemplate ?? "", unwindingOptionTokens);
}
function getStyledText(text, style = "normal") {
    switch (style) {
        case "bold":
            return `<span class="swan-font-weight-bold">${text}</span>`;
        case "normal":
            return `<span class="swan-font-weight-normal">${text}</span>`;
        case "none":
            return `${text}`;
    }
}

const TightButtons = dt.div `
.swan-selection-set.swan-selection-set-skin-tiles-horizontal, 
.swan-selection-set.swan-selection-set-skin-tiles-mini,
.swan-selection-set.swan-selection-set-skin-tiles-vertical {
    --grid-gap: var(--swan-sem-space-4);
    gap: var(--grid-gap);
    container-type: inline-size;
    container-name: productOption;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button .swan-selection-set-label {
    margin: 0 !important;
    min-width: unset !important;
    max-width: unset !important;
    width: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button .swan-selection-set-label {
  height: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
  --grid-columns: 1;
  --column-gaps: 0px;
  flex: 0 1 calc((100% - var(--column-gaps)) / var(--grid-columns));
}

@container productOption (min-width: 260px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 2;
    --column-gaps: var(--grid-gap);
  }
}

@container productOption (min-width: 425px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 3;
    --column-gaps: calc(var(--grid-gap) * 2);
  }
}

@container productOption (min-width: 600px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 4;
    --column-gaps: calc(var(--grid-gap) * 3);
    max-width: 170px
  }
}

.incompatible-option {
  border-width: 2px !important;
  background-color: var(--swan-color-grey-100) !important;
  border-style: dashed;
  border-color:  var(--swan-color-grey-500) !important;
}
`;
const SnowflakeLayout$1 = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return React__default.createElement(TightButtons, null, children);
};
const TightButtonSkin = ({ option, locale, currency, fractionDigits, priceDisplayMode = "differential-unit", showIncompatibleChoices, hideImages, tenant, onChanged, }) => {
    const translations = useProductOptionsTranslations();
    /**
     * Converts the 'onChange' of a multi-select listbox to an onChange of a radioGroup
     * @param selectedValues the object of key:boolean pairs of selected options
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValues, event) => {
        if (option.selectedKey) {
            delete selectedValues[option.selectedKey];
        }
        for (const [key, value] of Object.entries(selectedValues)) {
            if (value && key !== option.selectedKey) {
                // Only emit an choiceKey if there's a value picked,
                // otherwise do nothing. A user can't unselect an option
                onChanged({ choiceKey: key });
                break;
            }
        }
    };
    const titleId = useId();
    const selectedValues = {};
    for (const choice of option.choices) {
        selectedValues[choice.key] = choice.key === option.selectedKey;
    }
    return (React__default.createElement(SnowflakeLayout$1, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "multi-select", skin: "tiles-vertical", selectedValues: selectedValues, onSelectedValuesChange: onChangeHandler, "aria-labelledby": titleId, role: "radiogroup", "aria-required": option.isRequired ? "true" : undefined }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice) => (React__default.createElement("div", { className: "tight-button", key: `choice_${choice.key}` },
            React__default.createElement(SelectionSetInput, { value: choice.key, disabled: !choice.isCompatible && !choice.violations?.length },
                React__default.createElement(SelectionSetLabel, { className: !choice.violations?.length ? "compatible-option" : "incompatible-option", style: {
                        minHeight: hideImages ? "unset" : "inherit",
                    } },
                    !hideImages && React__default.createElement(ImageTileThumbnail, { choice: choice }),
                    !hideImages && React__default.createElement(SelectionSetTileCallouts, { callouts: choice.callouts }),
                    React__default.createElement(SelectionSetTileContents, null,
                        React__default.createElement(SelectionSetTileName, null, choice.name),
                        choice.violations?.length ? (React__default.createElement(Typography, { as: "span", fontWeight: "normal", dangerouslySetInnerHTML: {
                                __html: getUnwindingMessageHtml(choice.violations, translations),
                            } })) : priceDisplayMode === "none" || choice.key === option.selectedKey ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(SelectionSetTilePrice, null,
                            React__default.createElement(OptionPriceDisplay, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true, tenant: tenant }))))))))))));
};
function getUnwindingMessageHtml(violations, { i18n }) {
    return buildUnwindingMessageHtml(i18n, "unwindingMessage", violations);
}

const WideButtons = dt.div `
  .swan-selection-set {
    flex-wrap: wrap;
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-callout {
    position: relative;
    top: unset;
    left: unset;
    margin-bottom: var(--swan-spacing-standard-1);
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-selection-set-label {
    word-break: initial;
    align-items: start;
  }

  .swan-selection-set.swan-selection-set-skin-tiles-horizontal .swan-selection-set-tile-contents {
    width: 100%;
  }
`;
const WideButtonSkin = ({ option, locale, currency, fractionDigits, onChanged, priceDisplayMode = "differential-unit", showIncompatibleChoices, hideImages, tenant, hideDescriptions, }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const titleId = useId();
    const optionChoicesToShow = option.choices.filter((choice) => showIncompatibleChoices || choice.isCompatible);
    return (React__default.createElement(WideButtons, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { variant: "single-select", skin: "tiles-horizontal", selectedValue: option.selectedKey, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId, "aria-required": option.isRequired }, optionChoicesToShow.map((choice, index) => (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible, id: option.key + choice.key },
            React__default.createElement(SelectionSetLabel, { mb: index === optionChoicesToShow.length - 1 ? 0 : undefined },
                !hideImages && React__default.createElement(ImageTileThumbnail, { choice: choice }),
                React__default.createElement(SelectionSetTileContents, { ml: { xs: 0, sm: 0, md: "5", lg: "5", xl: "5" } },
                    choice.callouts && choice.callouts.length > 0 && (React__default.createElement(Box, { mb: choice.experimental?.auto_upsell_1 && choice.experimental?.auto_upsell_2
                            ? "1"
                            : "3" },
                        React__default.createElement(SelectionSetTileCallouts, { callouts: choice.callouts }))),
                    !hideImages &&
                        choice.experimental?.auto_upsell_1 &&
                        choice.experimental?.auto_upsell_2 && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Typography, { fontSkin: "body-small" }, choice.experimental?.auto_upsell_1),
                        React__default.createElement(Typography, { fontSkin: "footnote", textColor: "subtle", mb: 3 }, choice.experimental?.auto_upsell_2))),
                    React__default.createElement(FlexBox, { justifyContent: "space-between", fontSize: "standard" },
                        React__default.createElement(SelectionSetTileName, null, choice.name),
                        priceDisplayMode === "none" || choice.key === option.selectedKey ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(SelectionSetTilePrice, { pl: "3" },
                            React__default.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true })))),
                    !hideDescriptions && (React__default.createElement(SelectionSetTileDescription, { descriptionMarkdown: choice.description }))))))))));
};

function getButtonComponentBySkin(skin) {
    switch (skin) {
        case "minimal":
            return MinimalButtonSkin;
        case "standard":
            return StandardButtonSkin;
        case "tight":
            return TightButtonSkin;
        case "wide":
            return WideButtonSkin;
        default:
            return WideButtonSkin;
    }
}

const ButtonOptions = (props) => {
    const onChangeHandler = (event) => {
        props.onChanged(event);
    };
    const ButtonComponent = getButtonComponentBySkin(props.skin ?? "wide");
    const buttonProps = { ...props, onChanged: onChangeHandler };
    return React__default.createElement(ButtonComponent, { ...buttonProps });
};

const DropdownCallout = ({ callouts }) => {
    // Only render one callout in dropdown
    // Take the first callout as the highest priority one.
    const callout = callouts?.[0];
    if (!callout) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return (React__default.createElement(Callout, { key: callout.key, skin: callout.style ?? "info", emphasis: "low", ml: "3" }, callout.text));
};

const incompatibleMessage = (i18n) => {
    return [
        React__default.createElement(ListboxSection, null,
            React__default.createElement(ListboxOption, { textValue: "dummy-message", key: "dropdown-option-incompatible-option-msg", disabled: true },
                React__default.createElement(Typography, { fontWeight: "bold" },
                    " ",
                    i18n("incompatibilityMessage"),
                    " "))),
    ];
};

const encodeKey = (key) => {
    if (!key) {
        return null;
    }
    return key.replaceAll('"', "&quote;");
};

const decodeKey = (encodedKey) => {
    if (!encodedKey) {
        return null;
    }
    return encodedKey.replaceAll("&quote;", '"');
};

const ListboxPlaceholder = () => {
    const { i18n } = useProductOptionsTranslations();
    return (React__default.createElement(Box, null,
        React__default.createElement(Typography, { fontWeight: "bold" }, i18n("select"))));
};

function selectedKeyToSet(selectedKey) {
    const encodedKey = encodeKey(selectedKey);
    return new Set(encodedKey != null ? [encodedKey] : []);
}
function useListboxSelectionHelper(selectedKey, onChanged) {
    const [selectedKeys, setSelectedKeys] = React__default.useState(selectedKeyToSet(selectedKey));
    React__default.useEffect(() => {
        setSelectedKeys(selectedKeyToSet(selectedKey));
    }, [selectedKey]);
    const handleOnSelectionChange = React__default.useCallback((keys) => {
        if (keys === "all") {
            throw new Error("the 'all' should not be selected");
        }
        const values = Array.from(keys.values());
        if (values.length > 0) {
            // we do not want to allow deselecting an option by clicking on the
            // currently selected item. When that happens, the listbox will return
            // an empty Set of keys. If we ignore that event, the listbox will not
            // update and we get the desired behavior.
            // otherwise use the first selection (we currently only support single selection mode)
            onChanged({
                choiceKey: decodeKey(values[0]),
            });
            setSelectedKeys(new Set(values));
        }
    }, [onChanged]);
    return {
        selectedKeys,
        handleOnSelectionChange,
    };
}

const MinimalDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "none", tenant, } = props;
    const { i18n } = useProductOptionsTranslations();
    const titleId = useId();
    const compatibleChoices = option.choices.filter((choice) => choice.isCompatible);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    let incompatibleChoices = [];
    if (showIncompatibleChoices) {
        incompatibleChoices = option.choices.filter((choice) => !choice.isCompatible);
    }
    const renderChoice = (choice, showCallout) => {
        const label = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography, null, choice.name),
            React__default.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, fractionDigits: fractionDigits, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, hideZeroPrice: true })));
        return (React__default.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, disabled: choice.isOutOfStock, label: React__default.createElement(FlexBox, { flexDirection: "row", gap: "3", fontWeight: "bold" }, label) },
            React__default.createElement(FlexBox, { gap: "3", alignItems: "baseline" },
                label,
                showCallout && React__default.createElement(DropdownCallout, { callouts: choice.callouts }))));
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange, size: "standard", "aria-required": option.isRequired },
            React__default.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React__default.createElement(ListboxPlaceholder, null) }),
            React__default.createElement(ListboxPopover, null,
                React__default.createElement(ListboxList, null,
                    React__default.createElement(ListboxSection, null, compatibleChoices.map((choice) => renderChoice(choice, true))),
                    showIncompatibleChoices && incompatibleChoices.length > 0
                        ? incompatibleMessage(i18n)
                        : [],
                    incompatibleChoices.map((choice) => renderChoice(choice, false)))))));
};

const ListboxSwanFixes = dt.div `
.swan-listbox-button-with-label span>* {
  margin-left: unset;
}

.swan-listbox-button-with-label span {
  display: unset;
  align-items: unset;
}
`;
const Layout = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return React__default.createElement(ListboxSwanFixes, null, children);
};
const StandardDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "none", hideImages, tenant, } = props;
    const titleId = useId();
    const hasImages = !hideImages && option.choices.some((c) => !!c.image);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    return (React__default.createElement(Layout, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange },
            React__default.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React__default.createElement(ListboxPlaceholder, null) }),
            React__default.createElement(ListboxPopover, null,
                React__default.createElement(ListboxList, null, option.choices
                    .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                    .map((choice) => {
                    return (React__default.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, label: React__default.createElement(FlexBox, { flexDirection: "row", gap: "3", fontWeight: "bold" },
                            React__default.createElement(OptionLabel, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, fractionDigits: fractionDigits, currency: currency })), withThumbnail: hasImages, disabled: choice.isOutOfStock },
                        hasImages && (React__default.createElement(ListboxOptionThumbnailContainer, null,
                            React__default.createElement(FluidImage, { src: choice.image }))),
                        React__default.createElement(FlexBox, { flexDirection: hasImages ? "column" : "row", alignItems: "center" },
                            React__default.createElement(OptionLabel, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, fractionDigits: fractionDigits, currency: currency }),
                            !!choice.callouts &&
                                choice.callouts.length > 0 &&
                                choice.callouts.map((callout) => (React__default.createElement(Callout, { emphasis: "low", ml: "3", key: callout.key, skin: callout.style ?? "info" }, callout.text))))));
                }))))));
};
const OptionLabel = ({ tenant, choice, priceDisplayMode, locale, fractionDigits, currency, vatInc = false, hideVatMessage = true, }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, null,
            React__default.createElement(ListboxOptionTextContainer, null, choice.name)),
        priceDisplayMode !== "none" && (React__default.createElement(Box, { ml: "2" },
            React__default.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, vatInc: vatInc, hideVatMessage: hideVatMessage, showPriceWithParentheses: true })))));
};

const WideDropdownStyle = dt.span `
.swan-listbox-full-width .swan-listbox-button {
  align-items: stretch;
  flex-direction: column;
  justify-content: center;
}
`;
const WideListBoxPopoverStyle = dt.span `  
.swan-listbox-option {
  padding-right: calc(var(--swan-spacing-standard-4) + 2 * 16px);
}
`;
const WideDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "differential-unit", hideImages, hideDescriptions, tenant, } = props;
    const hasImages = !hideImages && option.choices.some((c) => !!c.image);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    const titleId = useId();
    return (React__default.createElement(WideDropdownStyle, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange, mb: "6" },
            React__default.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React__default.createElement(ListboxPlaceholder, null) }),
            React__default.createElement(ListboxPopover, null,
                React__default.createElement(WideListBoxPopoverStyle, null,
                    React__default.createElement(ListboxList, null, option.choices
                        .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                        .map((choice) => (React__default.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, withThumbnail: true, disabled: choice.isOutOfStock },
                        React__default.createElement(GridContainer, null,
                            React__default.createElement(Row, null,
                                hasImages && (React__default.createElement(Column, { span: 3 },
                                    React__default.createElement(FluidImage, { src: choice.image }))),
                                React__default.createElement(Column, { span: hasImages ? 9 : 12 },
                                    React__default.createElement(FlexBox, { justifyContent: "space-between" },
                                        React__default.createElement(Typography, { fontWeight: "bold" }, choice.name),
                                        React__default.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, fractionDigits: fractionDigits, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, hideZeroPrice: true })),
                                    !hideDescriptions && (React__default.createElement(OptionMarkdownText, { markdownText: choice.description }))))))))))))));
};

const getDropdownComponentBySkin = (skin) => {
    switch (skin) {
        case "wide":
            return WideDropdownSkin;
        case "minimal":
            return MinimalDropdownSkin;
        case "standard":
        default:
            return StandardDropdownSkin;
    }
};

function getQuantityItemFlags(savingsFormat, hasSampleQuantity, index) {
    // The sample quantity doesn't display "sale". Otherwise, we show the sale text.
    const isSampleQuantity = hasSampleQuantity && index === 0;
    const quantitySavingsIsVisible = savingsFormat !== "hidden" && !isSampleQuantity;
    return {
        quantitySavingsIsVisible,
        isSampleQuantity,
    };
}

const InfoTextStyle$1 = dt.div `
  color: var(--swan-sem-color-text-info);
`;
const WideQuantityListPrice = ({ choice, locale, fractionDigits, currency, }) => {
    return (React__default.createElement(FlexBox, { alignItems: "baseline" },
        React__default.createElement(Box, { paddingRight: "3" }, Boolean(choice.totalListPrice &&
            choice.totalDiscountedPrice &&
            choice.totalListPrice > 0 &&
            choice.totalDiscountedPrice > 0) && (React__default.createElement(RawPrice, { pricingInfo: {
                listPrice: choice.totalListPrice,
                discountPrice: choice.totalDiscountedPrice,
                culture: locale,
                currency,
                minimumFractionDigits: fractionDigits,
                vatInc: true,
                hideVatMessage: true,
                hideShippingMessageInVatMessage: true,
            }, placeHolderText: "", tenant: "vistaprint" }))),
        React__default.createElement(Typography, { fontSize: "xsmall" },
            React__default.createElement(InfoTextStyle$1, null,
                React__default.createElement(PricePerUnit, { pricingInfo: {
                        unitListPrice: choice.unitDiscountedPrice ?? 0, // We do not want to show cross out unit pricing
                        unitDiscountPrice: choice.unitDiscountedPrice ?? 0,
                        culture: locale,
                        currency,
                        minimumFractionDigits: fractionDigits,
                        vatInc: true,
                        hideVatMessage: true,
                        hideShippingMessageInVatMessage: true,
                    }, placeHolderText: "", tenant: "vistaprint" })))));
};

const InfoTextStyle = dt.div `
  .swan-discount-price {
      color: var(--swan-sem-color-text-info);
  }
`;
const PromoTextStyle = dt.div `
  color: var(--swan-sem-color-text-promo);
  font-size: var(--swan-sem-font-size-small);
`;
const Savings$1 = ({ culture, currency, minimumFractionDigits, savingsFormat, savingsPercent = 0, savingsTotal = 0, onSale = false, }) => {
    const { i18n } = useProductOptionsTranslations();
    const saleText = savingsPercent > 0 ? "+ " + i18n("sale") : i18n("sale");
    if (savingsFormat === "percent") {
        const percentSavingsText = i18n("percentSavings");
        return (React__default.createElement(React__default.Fragment, null,
            savingsPercent > 0 && (React__default.createElement(InfoTextStyle, null,
                React__default.createElement(DiscountPrice, { fontSize: "small" },
                    React__default.createElement(TokenReplace, { tokenizedText: percentSavingsText, contextVariables: { PERCENT: `${savingsPercent}` } })))),
            onSale && React__default.createElement(PromoTextStyle, null,
                "\u00A0",
                saleText)));
    }
    else if (savingsFormat === "difference") {
        // TO DO - whoever owns VpTokenizedFragment would probably token engine replace savings experience
        return (React__default.createElement(React__default.Fragment, null,
            savingsTotal > 0 && (React__default.createElement(InfoTextStyle, null,
                React__default.createElement(DiscountPrice, { fontSize: "small" },
                    React__default.createElement(RawPrice, { placeHolderText: "...", pricingInfo: {
                            listPrice: savingsTotal,
                            discountPrice: savingsTotal,
                            minimumFractionDigits,
                            vatInc: true,
                            hideVatMessage: true,
                            hideShippingMessageInVatMessage: true,
                            culture,
                            currency,
                        } }),
                    " ",
                    "discount / unit"))),
            onSale && React__default.createElement(PromoTextStyle, null,
                "\u00A0",
                saleText)));
    }
    else {
        return React__default.createElement(React__default.Fragment, null);
    }
};

const QuantityItemContainer = dt.div `
margin-bottom: var(--swan-spacing-standard-4);

container-type: inline-size;

.quantity-container {
    flex-direction: column;
}
  
.quantity-number-callouts {
    width: 200px;
    margin-bottom: var(--swan-sem-space-3);
}

.quantity-prices {
    flex-direction: column;
    flex-grow: 1;
  }

@container (width > 400px) {
  .quantity-container {
    flex-direction: row;
  }

  .quantity-number-callouts {
    width: 150px;
  }

  .quantity-prices {
    flex-direction: column;
    align-items: end;
  }
}

@container (width > 600px) {
  .quantity-container {
    flex-direction: row;
  }

  .quantity-number-callouts {
    width: 200px;
    margin-bottom: 0;
  }

  .quantity-prices {
    flex-direction: row;
    flex-grow: 1;
    align-items: unset;
  }
}

`;
const QuantityItem = ({ choice, priceDisplayMode, locale, currency, fractionDigits, isSampleQuantity, quantitySavingsIsVisible, onSale, savingsFormat, }) => {
    const { i18n } = useProductOptionsTranslations();
    return (React__default.createElement(QuantityItemContainer, null,
        React__default.createElement(Box, null,
            React__default.createElement(FlexBox, { className: "quantity-container", justifyContent: "space-between" },
                React__default.createElement(FlexBox, { className: "quantity-number-callouts", alignItems: "center" },
                    React__default.createElement(Typography, { paddingRight: "3", fontSkin: "body-standard" }, choice.name),
                    React__default.createElement(FlexBox, null, choice.callouts?.map((callout) => {
                        return (React__default.createElement(Callout, { emphasis: "low", key: callout.key, skin: callout.style ?? "accent" }, callout.text));
                    }))),
                React__default.createElement(FlexBox, { className: "quantity-prices", justifyContent: "space-between" },
                    priceDisplayMode !== "none" && (React__default.createElement(WideQuantityListPrice, { choice: choice, locale: locale, fractionDigits: fractionDigits, currency: currency })),
                    isSampleQuantity && (React__default.createElement(FlexBox, { alignItems: "center" },
                        React__default.createElement(Callout, { border: "none", emphasis: "low" }, i18n("sample")))),
                    quantitySavingsIsVisible && (React__default.createElement(FlexBox, { alignItems: "baseline" },
                        React__default.createElement(Savings$1, { culture: locale, currency: currency, minimumFractionDigits: fractionDigits, savingsFormat: savingsFormat ?? "percent", savingsTotal: choice.savingsTotal, savingsPercent: choice.savingsPercent, onSale: onSale }))))))));
};

/**
 * This is a fix for the listbox not being able to handle complex
 * children in the label prop.
 *
 * The Listbox button is a flex container, but it doesn't stretch
 * its children to fill the width.
 */
const TightQuantityListboxFix = dt.div `
  .swan-listbox-full-width {
    > button {
      flex-direction: column;
      align-items: stretch;

      > span {
        display: flex;
        flex-direction: column;
        align-items: stretch;
      }
    }
  }
`;
const SnowflakeLayout = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return React__default.createElement(TightQuantityListboxFix, null, children);
};
const QuantityDropdown = ({ option, locale, currency, fractionDigits, onChanged, showIncompatibleChoices, savingsFormat = "percent", priceDisplayMode, hasSampleQuantity = false, tenant, }) => {
    const titleId = useId();
    const [selectedChoiceKey, setSelectedChoiceKey] = useState(option.selectedKey);
    useEffect(() => {
        // By storing the selection in state and updating it whe the prop changes, we
        // fix an a11y issue that prevents the radiogroup from being navigable with arrow
        // keys, but also keeps the current selection in perfect sync with the keyboard focus.
        setSelectedChoiceKey(option.selectedKey);
    }, [option.selectedKey]);
    const handleOnChange = useCallback((value) => {
        const decodedValue = decodeKey(value);
        if (!decodedValue) {
            return; // prevent unselecting a quantity
        }
        onChanged({ choiceKey: decodedValue });
    }, []);
    return (React__default.createElement(SnowflakeLayout, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(Listbox, { selectionMode: "single", fullWidth: true, mt: "4", value: encodeKey(selectedChoiceKey) ?? "", onChange: handleOnChange, "aria-labelledby": titleId },
            React__default.createElement(ListboxButton, { placeholder: React__default.createElement(ListboxPlaceholder, null) }),
            React__default.createElement(ListboxPopover, null,
                React__default.createElement(ListboxList, null, option.choices
                    .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                    .map((choice, index) => {
                    const { quantitySavingsIsVisible, isSampleQuantity } = getQuantityItemFlags(savingsFormat, hasSampleQuantity, index);
                    const onSale = (choice.totalDiscountedPrice ?? 0) < (choice.totalListPrice ?? 0);
                    const Label = () => (React__default.createElement(QuantityItem, { choice: choice, priceDisplayMode: priceDisplayMode ?? "none", locale: locale, fractionDigits: fractionDigits, currency: currency, isSampleQuantity: isSampleQuantity ?? false, quantitySavingsIsVisible: quantitySavingsIsVisible, savingsFormat: savingsFormat, onSale: onSale }));
                    return (React__default.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, label: React__default.createElement(Label, null) },
                        React__default.createElement(Label, null)));
                }))))));
};

const DropdownOptions = (props) => {
    const { onChanged, skin, option } = props;
    const { uiDensityQuantityUpdate } = useProductOptionContext();
    const onChangeHandler = (event) => {
        if (onChanged) {
            onChanged({ choiceKey: event.choiceKey });
        }
    };
    const dropdownProps = {
        ...props,
        onChanged: onChangeHandler,
    };
    if (uiDensityQuantityUpdate && option.key === "Quantity") {
        return React__default.createElement(QuantityDropdown, { ...dropdownProps });
    }
    const DropdownComponent = getDropdownComponentBySkin(skin ?? "standard");
    return React__default.createElement(DropdownComponent, { ...dropdownProps });
};

const StandardColorSwatchButtonSkin = (props) => {
    return React__default.createElement(ColorSwatchButtonSkin, { ...props, size: "standard" });
};
const WideColorSwatchButtonSkin = (props) => {
    return React__default.createElement(ColorSwatchButtonSkin, { ...props, size: "super" });
};
const ColorSwatchButtonSkin = ({ option, size, showIncompatibleChoices, onChanged }) => {
    const [selectedKey, setSelectedKey] = React__default.useState(option.selectedKey ?? null);
    useMemo(() => {
        const choice = option.choices.find((choice) => choice.key === option.selectedKey);
        const choiceDisplayed = choice?.isOutOfStock || choice?.isCompatible || showIncompatibleChoices;
        const choiceDisabled = choice?.isOutOfStock ?? false;
        if (choiceDisplayed && !choiceDisabled) {
            setSelectedKey(option.selectedKey ?? null);
        }
    }, [option, showIncompatibleChoices]);
    const onChangeHandler = (selectedValue) => {
        setSelectedKey(selectedValue);
        onChanged?.({ choiceKey: selectedValue });
    };
    const titleId = useId();
    return (React__default.createElement(Box, null,
        React__default.createElement(SimpleTitle, { titleId: titleId, showSelectedOptionText: true }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", selectedValue: selectedKey, onSelectedValueChange: onChangeHandler, "aria-required": option.isRequired, "aria-labelledby": titleId },
            React__default.createElement(ColorSwatches, { className: "color-swatches-base", size: size }, option.choices.map((choice, i) => {
                const primaryAndSecondary = choice.key?.split("/");
                const primaryColor = primaryAndSecondary?.[0];
                const secondaryColor = primaryAndSecondary?.[1] ?? primaryColor;
                const selectorDisplayed = choice.isOutOfStock || choice.isCompatible || showIncompatibleChoices;
                const selectorDisabled = choice.isOutOfStock ?? false;
                return (selectorDisplayed && (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: selectorDisabled },
                    React__default.createElement(SelectionSetLabel, null,
                        React__default.createElement(ColorSwatch, { component: "span", primaryColor: primaryColor, secondaryColor: secondaryColor, accessibleText: choice.name })))));
            })))));
};

function getColorSwatchComponentBySkin(skin) {
    switch (skin) {
        case "standard":
        case "minimal":
        case "tight":
            return StandardColorSwatchButtonSkin;
        case "wide":
            return WideColorSwatchButtonSkin;
        default:
            return StandardColorSwatchButtonSkin;
    }
}

const ColorSwatchOptions = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (event) => {
        props?.onChanged?.(event);
    };
    const ColorSwatchComponent = getColorSwatchComponentBySkin(props.skin ?? "standard");
    const buttonProps = { ...props, onChanged: onChangeHandler };
    return React__default.createElement(ColorSwatchComponent, { ...buttonProps });
};

const Savings = (props) => {
    const { i18n } = useProductOptionsTranslations();
    const { savingsPercent, onSale } = props;
    const percentSavingsText = i18n("percentSavings");
    const saleText = savingsPercent > 0 ? "+ " + i18n("sale") : i18n("sale");
    return (React__default.createElement(FlexBox, null,
        savingsPercent > 0 && (React__default.createElement(DiscountPrice, { fontSize: "small", textColor: "subtle", fontWeight: "normal" },
            React__default.createElement(TokenReplace, { tokenizedText: percentSavingsText, contextVariables: { PERCENT: `${savingsPercent}` } }))),
        onSale && (React__default.createElement(Typography, { textColor: "promo", fontSize: "small", fontWeight: "normal" },
            "\u00A0",
            saleText))));
};

const calculateQuantityPricing = (choice, minimumNonSampleQuantityUnitPrice) => {
    const { key, unitDiscountedPrice, totalDiscountedPrice, totalListPrice } = choice;
    const quantity = parseInt(key);
    const showPrice = Boolean(totalListPrice && totalDiscountedPrice && totalListPrice > 0 && totalDiscountedPrice > 0);
    const onSale = Boolean(totalListPrice &&
        totalDiscountedPrice &&
        totalDiscountedPrice &&
        totalListPrice > totalDiscountedPrice);
    const currentQuantityTotalPrice = (unitDiscountedPrice ?? 0) * quantity;
    const currentQuantityTotalPriceWithoutDiscount = minimumNonSampleQuantityUnitPrice * quantity;
    const totalPriceSavings = currentQuantityTotalPriceWithoutDiscount - currentQuantityTotalPrice;
    const savingsPercent = Math.floor((totalPriceSavings / currentQuantityTotalPriceWithoutDiscount) * 100);
    return {
        savingsPercent,
        showPrice,
        onSale,
    };
};

const QuantityListItem = (props) => {
    const { choice, minimumNonSampleQuantityUnitPrice, locale, currency, fractionDigits } = props;
    const { name, callouts, unitDiscountedPrice, totalDiscountedPrice, totalListPrice } = choice;
    const { savingsPercent, showPrice, onSale } = calculateQuantityPricing(choice, minimumNonSampleQuantityUnitPrice);
    return (React__default.createElement(FlexBox, { flexDirection: "column", style: { width: "100%" } },
        React__default.createElement(FlexBox, { justifyContent: "space-between" },
            React__default.createElement(FlexBox, null,
                React__default.createElement(Typography, null, name),
                !!callouts &&
                    callouts.length > 0 &&
                    callouts.map((callout) => (React__default.createElement(Callout, { emphasis: "low", ml: "3", key: callout.key, skin: callout.style ?? "info" }, callout.text)))),
            showPrice && (React__default.createElement(RawPrice, { pricingInfo: {
                    listPrice: totalListPrice ?? 0,
                    discountPrice: totalDiscountedPrice ?? 0,
                    culture: locale,
                    currency,
                    minimumFractionDigits: fractionDigits,
                    vatInc: true, // We are hiding VAT message, so it does not matter what vatInc is set to
                    hideVatMessage: true,
                    hideShippingMessageInVatMessage: true,
                }, placeHolderText: "", tenant: "vistaprint" }))),
        React__default.createElement(FlexBox, { justifyContent: "space-between" },
            showPrice && (React__default.createElement(Box, { textColor: "subtle", fontSize: "small" },
                React__default.createElement(PricePerUnit, { pricingInfo: {
                        unitListPrice: unitDiscountedPrice ?? 0, // We do not want to show cross out unit pricing
                        unitDiscountPrice: unitDiscountedPrice ?? 0,
                        culture: locale,
                        currency,
                        minimumFractionDigits: fractionDigits,
                        vatInc: true,
                        hideVatMessage: true,
                        hideShippingMessageInVatMessage: true,
                    }, placeHolderText: "", tenant: "vistaprint" }))),
            showPrice && React__default.createElement(Savings, { savingsPercent: savingsPercent, onSale: onSale }))));
};

const executeWithTracking = (fn) => {
    try {
        const tracking = getTracking();
        fn(tracking);
    }
    catch (exception) {
        console.warn("Failed to send tracking event", exception);
    }
};
const sendTrackingEvent = (eventName, data, counter = 0) => {
    executeWithTracking((tracking) => {
        if (tracking) {
            tracking.track(eventName, data);
        }
        else if (counter > 10) {
            console.warn("Analytics tracking not loaded");
        }
        else {
            setTimeout(() => sendTrackingEvent(eventName, data, ++counter), 1000);
        }
    });
};

const ComparePanel = (props) => {
    const { option, currency, fractionDigits, minimumNonSampleQuantityUnitPrice, locale, onChanged } = props;
    const { choices, selectedKey } = option;
    const selectedQuantity = parseInt(selectedKey ?? "");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedQuantityChoice, setSelectedQuantityChoice] = useState(selectedQuantity);
    const titleId = useId();
    const { i18n, i18nUnsafe } = useProductOptionsTranslations();
    useEffect(() => {
        setSelectedQuantityChoice(selectedQuantity);
    }, [selectedQuantity]);
    const closeModal = useCallback(() => {
        setSelectedQuantityChoice(selectedQuantity);
        setIsModalOpen(false);
        sendTrackingEvent("Fly-Out Closed", {
            category: "Fly-Out",
            label: "Qty Edit Fly-out",
        });
    }, [selectedQuantity]);
    const openModal = useCallback(() => {
        setIsModalOpen(true);
        sendTrackingEvent("Fly-Out Viewed", {
            category: "Fly-Out",
            label: "Qty Edit Fly-out",
        });
    }, []);
    const selectQuantity = useCallback(() => {
        if (selectedQuantityChoice !== selectedQuantity) {
            onChanged({
                choiceKey: `${selectedQuantityChoice}`,
                isValid: true,
                eventTarget: "fly-out",
            });
        }
        setIsModalOpen(false);
    }, [selectedQuantityChoice]);
    const onSelectedValueChange = useCallback((selectedValue) => {
        if (selectedValue && selectedValue !== `${selectedQuantityChoice}`) {
            setSelectedQuantityChoice(parseInt(selectedValue));
        }
    }, [selectedQuantityChoice]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Link, { render: (p) => (React__default.createElement(Button, { skin: "link", className: p.className, onClick: openModal }, p.children)) }, i18nUnsafe("quantityComboboxShowPricingGuide")),
        React__default.createElement(ModalDialog, { isOpen: isModalOpen, onRequestDismiss: () => {
                closeModal();
            }, variant: "panel-right" },
            React__default.createElement(ModalDialogContent, null,
                React__default.createElement(ModalDialogNav, null,
                    React__default.createElement(ModalDialogCloseButton, { accessibleText: i18n("closeButton") })),
                React__default.createElement(ModalDialogHeader, { pl: 1 },
                    React__default.createElement(ModalDialogTitle, { id: titleId }, i18nUnsafe("quantityComboboxPricingGuide"))),
                React__default.createElement(ModalDialogBody, { pl: 1 },
                    React__default.createElement(SelectionSet, { variant: "single-select", skin: "buttons", selectedValue: `${selectedQuantityChoice}`, onSelectedValueChange: onSelectedValueChange, "aria-labelledby": titleId }, choices.map((choice) => (React__default.createElement(SelectionSetInput, { key: choice.key, value: choice.key },
                        React__default.createElement(SelectionSetLabel, { style: { width: "100%", minWidth: "auto" }, mr: 0 },
                            React__default.createElement(QuantityListItem, { choice: choice, minimumNonSampleQuantityUnitPrice: minimumNonSampleQuantityUnitPrice, locale: locale, currency: currency, fractionDigits: fractionDigits }))))))),
                React__default.createElement(ModalDialogFooter, { pinned: true },
                    React__default.createElement(ModalDialogButtons, null,
                        React__default.createElement(Button, { skin: "secondary", onClick: () => {
                                closeModal();
                            } }, i18nUnsafe("quantityComboboxFlyoutCancel")),
                        React__default.createElement(Button, { skin: "primary", onClick: selectQuantity }, i18nUnsafe("quantityComboboxFlyoutConfirmation"))))))));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(lodash_debounce);

const useDebouncedFilterOptions = (compatibleQuantities, fieldState) => {
    const [filteredOptions, setFilteredOptions] = useState(compatibleQuantities);
    const debouncedFilterOptions = useCallback(debounce$1((inputValue, quantities, hasInputValueChangedAfterSelection) => {
        // If after a selection, the user opens the popover again, we do not want to filter the options
        if (!hasInputValueChangedAfterSelection) {
            setFilteredOptions([...quantities]);
            return;
        }
        // As users make changes to the input value, we want to filter the options
        let newItems = [...quantities];
        if (inputValue) {
            const filterTextAsNumber = parseInt(inputValue);
            if (filterTextAsNumber) {
                const lessThanFilterText = quantities
                    .filter((item) => item < filterTextAsNumber)
                    .sort((a, b) => a - b);
                const greaterThanFilterText = quantities
                    .filter((item) => item > filterTextAsNumber)
                    .sort((a, b) => a - b);
                const containsNumber = quantities.includes(filterTextAsNumber);
                // If input is in the quantity list, show itself + the next upsell.
                // If there is no upsell, show itself + the cloest downsell quantity
                // If input is not in the quantity list, show the closest upsell + the closest downsell
                // If input is below lowest qty or above highest qty, show the closest 2 upsell or downsell
                if (containsNumber) {
                    if (greaterThanFilterText.length > 0) {
                        newItems = [filterTextAsNumber, greaterThanFilterText[0]];
                    }
                    else if (lessThanFilterText.length > 0) {
                        newItems = [lessThanFilterText[lessThanFilterText.length - 1], filterTextAsNumber];
                    }
                    else {
                        newItems = [filterTextAsNumber];
                    }
                }
                else {
                    if (greaterThanFilterText.length > 0 && lessThanFilterText.length > 0) {
                        newItems = [
                            lessThanFilterText[lessThanFilterText.length - 1],
                            greaterThanFilterText[0],
                        ];
                    }
                    else if (lessThanFilterText.length > 1) {
                        newItems = [
                            lessThanFilterText[lessThanFilterText.length - 2],
                            lessThanFilterText[lessThanFilterText.length - 1],
                        ];
                    }
                    else if (greaterThanFilterText.length > 1) {
                        newItems = [greaterThanFilterText[0], greaterThanFilterText[1]];
                    }
                    else {
                        // This should cover the case where there is only one quantity available
                        newItems = [...quantities];
                    }
                }
                newItems = [...new Set(newItems)];
            }
        }
        setFilteredOptions(newItems);
    }, 600), [setFilteredOptions]);
    useEffect(() => {
        debouncedFilterOptions(fieldState.inputValue, compatibleQuantities, fieldState.inputValueHasChangedAfterSelection);
        // Clean up the debounced function on unmount
        return () => {
            debouncedFilterOptions.cancel();
        };
    }, [
        fieldState.inputValue,
        compatibleQuantities,
        debouncedFilterOptions,
        fieldState.inputValueHasChangedAfterSelection,
    ]);
    return { filteredOptions };
};

const getLowestNonSampleQuantityPrice = (compatibleQuantities, choices, hasSampleQuantity) => {
    const lowestNonSampleQuantity = hasSampleQuantity && compatibleQuantities.length > 1
        ? compatibleQuantities[1]
        : compatibleQuantities[0];
    const minimumNonSampleQuantityUnitPrice = choices.find((choice) => choice.key === lowestNonSampleQuantity.toString())
        ?.unitDiscountedPrice ?? 0;
    return minimumNonSampleQuantityUnitPrice;
};

const StandardQuantityComboboxSkin = (props) => {
    const { locale, option, hasSampleQuantity, currency, fractionDigits, onChanged } = props;
    const { name: optionName, selectedKey, choices } = option;
    const compatibleQuantities = React__default.useMemo(() => {
        return choices.map((choice) => parseInt(choice.key)).filter((qty) => !isNaN(qty));
    }, [choices]);
    const inputId = useId();
    const titleId = useId();
    const infoId = useId();
    const errorId = useId();
    const { i18nUnsafe } = useProductOptionsTranslations();
    const [fieldState, setFieldState] = useState({
        selectedKey: "",
        inputValue: "",
        inputValueHasChangedAfterSelection: false,
    });
    useEffect(() => {
        setFieldState({
            selectedKey: selectedKey ?? "",
            inputValue: selectedKey ?? "",
            inputValueHasChangedAfterSelection: false,
        });
    }, [selectedKey]);
    const { filteredOptions } = useDebouncedFilterOptions(compatibleQuantities, fieldState);
    const onSelectionChange = useCallback((key) => {
        const selectedItem = compatibleQuantities.find((qty) => `${qty}` === `${key}`);
        setFieldState({
            inputValue: selectedItem ? selectedItem.toString() : "",
            selectedKey: key ? key.toString() : "",
            inputValueHasChangedAfterSelection: false,
        });
        if (selectedItem !== parseInt(selectedKey ?? "")) {
            onChanged({
                choiceKey: selectedItem ? `${selectedItem}` : "",
                isValid: !!selectedItem,
                eventTarget: "dropdown",
            });
        }
    }, [selectedKey, compatibleQuantities, onChanged]);
    const onInputChange = useCallback((value) => {
        setFieldState((prevState) => ({
            inputValue: value,
            selectedKey: prevState.selectedKey,
            inputValueHasChangedAfterSelection: true,
        }));
    }, []);
    const message = React__default.useMemo(() => {
        if (compatibleQuantities.length > 0) {
            const localizationWithToken = i18nUnsafe("quantityComboboxHelperText");
            return {
                type: "info",
                text: (React__default.createElement(TokenReplace, { tokenizedText: localizationWithToken ?? "", contextVariables: { MINIMUM: `${compatibleQuantities[0]}` } })),
            };
        }
        return undefined;
    }, [compatibleQuantities]);
    const minimumNonSampleQuantityUnitPrice = React__default.useMemo(() => {
        return getLowestNonSampleQuantityPrice(compatibleQuantities, choices, hasSampleQuantity ?? false);
    }, [compatibleQuantities, choices, hasSampleQuantity]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FlexBox, { mb: "2", justifyContent: "space-between" },
            React__default.createElement(Typography, { id: titleId, fontSkin: "body-standard-bold", as: "label" }, optionName),
            React__default.createElement(ComparePanel, { option: option, currency: currency, fractionDigits: fractionDigits, minimumNonSampleQuantityUnitPrice: minimumNonSampleQuantityUnitPrice, locale: locale, onChanged: onChanged })),
        React__default.createElement(Combobox, { items: filteredOptions, inputValue: fieldState.inputValue, onInputChange: (val) => onInputChange(val || ""), onSelectionChange: onSelectionChange, menuTrigger: "focus", "aria-labelledby": titleId, selectedKey: fieldState.selectedKey || undefined, disableAutoFilter: true },
            React__default.createElement(ComboboxInput, { id: `quantity-input-${inputId}`, "aria-describedby": infoId, "aria-invalid": message?.type === "error", "aria-errormessage": message?.type === "error" ? errorId : undefined, placeholder: i18nUnsafe("quantityComboboxPlaceholderText"), onBlur: () => {
                    setFieldState((prevState) => ({
                        ...prevState,
                        inputValueHasChangedAfterSelection: false,
                    }));
                } }),
            React__default.createElement(ComboboxPopover, null,
                React__default.createElement(ComboboxList, null, filteredOptions.map((quantity) => {
                    const choice = choices.find((c) => c.key === quantity.toString());
                    if (!choice)
                        return null;
                    return (React__default.createElement(ComboboxOption, { key: quantity.toString(), textValue: quantity.toString() },
                        React__default.createElement(QuantityListItem, { choice: choice, minimumNonSampleQuantityUnitPrice: minimumNonSampleQuantityUnitPrice, locale: locale, currency: currency, fractionDigits: fractionDigits })));
                })))),
        message && message.type === "info" && (React__default.createElement(Typography, { id: infoId, mt: "2", fontSkin: "body-small", textColor: "subtle" }, message.text)),
        message && message.type === "error" && (React__default.createElement(Typography, { id: errorId, textColor: "error", fontSkin: "body-small", role: "status", "aria-live": "polite", mt: "2" }, message.text))));
};

const getQuantityComboboxComponentBySkin = (skin) => {
    switch (skin) {
        case "standard":
        default:
            return StandardQuantityComboboxSkin;
    }
};

const QuantityComboboxOptions = (props) => {
    const { onChanged, skin } = props;
    const onChangeHandler = (event) => {
        if (onChanged) {
            onChanged(event);
        }
    };
    const QuantityComboboxComponent = getQuantityComboboxComponentBySkin(skin ?? "standard");
    return React__default.createElement(QuantityComboboxComponent, { ...props, onChanged: onChangeHandler });
};

const DebugContainer = dt.div `
  width: 100%;
  height: 10em;
  overflow: scroll;
  background-color: #111111;
  color: white;
  
  > pre { 
    margin: 0;
    padding: 0.2em 0;
    border-bottom: 1px solid #888888;
  }
`;
const ProductOptionDebug = () => {
    const { decoratorMutations, validationMessages } = useProductOptionContext();
    return (React__default.createElement(Collapsible, { style: {
            borderStyle: "dashed",
            borderWidth: "1px",
            borderColor: "black",
            borderRadius: "0.5em",
            backgroundImage: "linear-gradient(45deg, #e0e0e0 25%, #e8e8e8 25%, #e8e8e8 50%, #e0e0e0 50%, #e0e0e0 75%, #e8e8e8 75%, #e8e8e8 100%)",
            backgroundSize: "56.57px 56.57px",
        } },
        React__default.createElement(CollapsibleSummary, { m: 0, p: "2", pr: "4", style: { borderStyle: "none", borderWidth: 0, borderColor: "transparent" } },
            React__default.createElement(CollapsibleSummaryButton, { m: "2", p: "2" },
                React__default.createElement("pre", { style: { margin: "0" } }, "Debug Info"))),
        React__default.createElement(CollapsibleContent, { px: "4", p: "2", style: { position: "relative" } },
            React__default.createElement(DebugContainer, null,
                React__default.createElement("pre", null, "Validations:"),
                React__default.createElement("pre", null, JSON.stringify(validationMessages, null, 2)),
                React__default.createElement("pre", null, "Mutations:"),
                React__default.createElement("pre", null, JSON.stringify(decoratorMutations, null, 2))))));
};

const OptionNotification = forwardRef(({ notificationOptions }, ref) => {
    const { optionCausingUnselect, optionsUnselected } = notificationOptions;
    if (!optionCausingUnselect || !optionsUnselected) {
        return React__default.createElement(React__default.Fragment, null);
    }
    const { i18n } = useProductOptionsTranslations();
    const notificationHtml = buildUnwindingMessageHtml(i18n, "unwindingAlertMessage", optionsUnselected, optionCausingUnselect);
    return (React__default.createElement(AlertBox, { ref: ref, skin: "warning", marginTop: 6, marginBottom: "6" },
        React__default.createElement(Span, { fontWeight: "normal", dangerouslySetInnerHTML: { __html: notificationHtml } }),
        React__default.createElement(AlertBoxDismissButton, { accessibleText: i18n("dismissAlert") })));
});

const StandardTextboxSkin = (props) => {
    const { option, onChanged, isDisabled, message } = props;
    const [inputText, setInputText] = useState(option.selectedKey ?? "");
    const titleId = useId();
    const infoId = useId();
    const errorId = useId();
    const handleInputChange = useCallback(debounce$1((value) => {
        onChanged({ choiceKey: value });
    }, 250), [onChanged]);
    useEffect(() => {
        if (option.selectedKey) {
            handleInputChange(option.selectedKey);
        }
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(TextInput, { disabled: isDisabled, skin: "standard", value: inputText, onChange: (event) => {
                setInputText(event.target.value);
                handleInputChange(event.target.value);
            }, "aria-required": option.isRequired, "aria-labelledby": titleId, "aria-describedby": infoId, "aria-invalid": message?.type === "error", "aria-errormessage": message?.type === "error" ? errorId : undefined }),
        message && message.type === "info" && (React__default.createElement(Typography, { id: infoId, mt: "2", fontSkin: "body-small", textColor: "subtle" }, message.text)),
        message && message.type === "error" && (React__default.createElement(Typography, { id: errorId, textColor: "error", fontSkin: "body-small", role: "status", "aria-live": "polite", mt: "2" }, message.text))));
};

const getTextboxComponentBySkin = (skin) => {
    switch (skin) {
        case "standard":
        default:
            return StandardTextboxSkin;
    }
};

var RangedAttributeValidationCode;
(function (RangedAttributeValidationCode) {
    RangedAttributeValidationCode["EMPTY_INPUT"] = "emptyInput";
    RangedAttributeValidationCode["NOT_A_NUMBER"] = "notANumber";
    RangedAttributeValidationCode["NOT_IN_RANGE"] = "notInRange";
    RangedAttributeValidationCode["UNSUPPORTED_PRECISION"] = "unsupportedPrecision";
    RangedAttributeValidationCode["UNKNOWN_ERROR"] = "unknownError";
    RangedAttributeValidationCode["SUCCESS"] = "success";
})(RangedAttributeValidationCode || (RangedAttributeValidationCode = {}));

var numericRanges = {exports: {}};

(function (module, exports) {
	!function(e,n){module.exports=n();}("undefined"!=typeof self?self:commonjsGlobal,(function(){return function(e){var n={};function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}return t.m=e,t.c=n,t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:i});},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(t.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)t.d(i,r,function(n){return e[n]}.bind(null,r));return i},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=6)}([function(e,n,t){var i=this&&this.__extends||function(){var e=function(n,t){return (e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,n){e.__proto__=n;}||function(e,n){for(var t in n)n.hasOwnProperty(t)&&(e[t]=n[t]);})(n,t)};return function(n,t){function i(){this.constructor=n;}e(n,t),n.prototype=null===t?Object.create(t):(i.prototype=t.prototype,new i);}}();Object.defineProperty(n,"__esModule",{value:!0});var r=function(e){function n(t){var i=e.call(this,t)||this;return i.ERROR_CODE="PRECISION_TOO_LONG",Object.setPrototypeOf(i,n.prototype),i}return i(n,e),n}(Error);n.default=r;},function(e,n,t){var i=this&&this.__extends||function(){var e=function(n,t){return (e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,n){e.__proto__=n;}||function(e,n){for(var t in n)n.hasOwnProperty(t)&&(e[t]=n[t]);})(n,t)};return function(n,t){function i(){this.constructor=n;}e(n,t),n.prototype=null===t?Object.create(t):(i.prototype=t.prototype,new i);}}();Object.defineProperty(n,"__esModule",{value:!0});var r=function(e){function n(t){var i=e.call(this,t)||this;return i.ERROR_CODE="INVALID_INPUT",Object.setPrototypeOf(i,n.prototype),i}return i(n,e),n}(Error);n.default=r;},function(e,n,t){var i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.exceedsMaximumPrecision=n.EXCEEDED_PRECISION_MESSAGE=void 0;var r=i(t(3)),o=i(t(4)),s=i(t(0)),u=i(t(1));function a(e){var n=new o.default(e);return !n.toDecimalPlaces(8).add(0).equals(n)}n.EXCEEDED_PRECISION_MESSAGE="maximum number of decimal places supported is 8",n.exceedsMaximumPrecision=a;var c=function(){function e(e,t,i){this.minimum=function(e){if(e instanceof o.default&&!e.isFinite())throw new r.default("The range minimum must be a finite value");try{return new o.default(e)}catch(n){throw new r.default('The range minimum "'+e+'" is not a valid value.')}}(e),this.maximum=function(e,n,t){if(n instanceof o.default&&n.isNaN())throw new r.default("The range maximum cannot be NaN");if(null==n)return new o.default(1/0);try{return new o.default(n)}catch(e){throw new r.default('The range maximum "'+n+'" is not a valid value.')}}(this.minimum,t),this.increment=function(e,n,t){if(t instanceof o.default&&!t.isFinite())throw new r.default("The range increment must be a finite value");try{return null==t||0===t.valueOf()||e.equals(n)?void 0:new o.default(t)}catch(e){throw new r.default('The range increment "'+t+'" is not a valid value.')}}(this.minimum,this.maximum,i),function(e,t,i){if(void 0===e)throw new r.default("minimum is required");if(void 0!==t&&e.greaterThan(t))throw new r.default("minimum must be less than or equal to maximum");if(i&&i.lessThan(0))throw new r.default("increment must be positive");if(a(e))throw new s.default(n.EXCEEDED_PRECISION_MESSAGE);if(void 0!==t&&t.isFinite()&&a(t))throw new s.default(n.EXCEEDED_PRECISION_MESSAGE);if(void 0!==i&&a(i))throw new s.default(n.EXCEEDED_PRECISION_MESSAGE)}(this.minimum,this.maximum,this.increment);}return e.prototype.getMinimum=function(){return this.minimum},e.prototype.getMaximum=function(){return this.maximum},e.prototype.getIncrement=function(){return this.increment},e.prototype.contains=function(e){var t,i;try{i=new o.default(e);}catch(n){throw new u.default('The value "'+e+'" is not a valid input')}if(void 0===i)throw new u.default("A valid value is required to check if the range contains it");if(a(i))throw new s.default(n.EXCEEDED_PRECISION_MESSAGE);if(t=this.minimum.lessThanOrEqualTo(i)&&this.maximum.greaterThanOrEqualTo(i),void 0!==this.increment){var r=void 0;r=o.default.sub(i,this.minimum),t=t&&r.greaterThanOrEqualTo(0)&&r.mod(this.increment).isZero()&&r.mod(this.increment).isZero();}return t},e.prototype.calculateNearestValues=function(e){var n,t={};try{n=new o.default(e);}catch(e){throw new u.default("The input value is invalid")}if(this.increment)if(n.greaterThanOrEqualTo(this.minimum)){var i=n;n.greaterThanOrEqualTo(this.maximum)&&(i=this.maximum,t.upperAdjValue=void 0);var r=i.sub(this.minimum).dividedToIntegerBy(this.increment);if(t.lowerAdjValue=r.mul(this.increment).add(this.minimum),t.lowerAdjValue.equals(n))throw new u.default("The value is already present in the range");if(n.lessThan(this.maximum)){var s=r.add(1).mul(this.increment).add(this.minimum);s.greaterThan(this.maximum)&&(s=void 0),t.upperAdjValue=s;}}else t.lowerAdjValue=void 0,t.upperAdjValue=this.minimum;else if(n.greaterThan(this.maximum))t.lowerAdjValue=this.maximum,t.upperAdjValue=void 0;else {if(!n.lessThan(this.minimum))throw new u.default("The value is already present in the range");t.lowerAdjValue=void 0,t.upperAdjValue=this.minimum;}return t},e.prototype.toString=function(){return this.minimum===this.maximum?""+this.minimum:this.minimum+"-"+this.maximum+"#"+this.increment},e}();n.default=c;},function(e,n,t){var i=this&&this.__extends||function(){var e=function(n,t){return (e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,n){e.__proto__=n;}||function(e,n){for(var t in n)n.hasOwnProperty(t)&&(e[t]=n[t]);})(n,t)};return function(n,t){function i(){this.constructor=n;}e(n,t),n.prototype=null===t?Object.create(t):(i.prototype=t.prototype,new i);}}();Object.defineProperty(n,"__esModule",{value:!0});var r=function(e){function n(t){var i=e.call(this,t)||this;return i.ERROR_CODE="MALFORMED_RANGE",Object.setPrototypeOf(i,n.prototype),i}return i(n,e),n}(Error);n.default=r;},function(e,n,t){var i;!function(r){var o,s,u,a=9e15,c=1e9,f="0123456789abcdef",l="2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",d="3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",h={precision:20,rounding:4,modulo:1,toExpNeg:-7,toExpPos:21,minE:-a,maxE:a,crypto:!1},m=!0,p="[DecimalError] ",g=p+"Invalid argument: ",w=p+"Precision limit exceeded",v=p+"crypto unavailable",N="[object Decimal]",E=Math.floor,y=Math.pow,_=/^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,b=/^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,x=/^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,O=/^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,M=1e7,A=l.length-1,P=d.length-1,j={toStringTag:N};function T(e){var n,t,i,r=e.length-1,o="",s=e[0];if(r>0){for(o+=s,n=1;n<r;n++)(t=7-(i=e[n]+"").length)&&(o+=k(t)),o+=i;(t=7-(i=(s=e[n])+"").length)&&(o+=k(t));}else if(0===s)return "0";for(;s%10==0;)s/=10;return o+s}function R(e,n,t){if(e!==~~e||e<n||e>t)throw Error(g+e)}function D(e,n,t,i){var r,o,s,u;for(o=e[0];o>=10;o/=10)--n;return --n<0?(n+=7,r=0):(r=Math.ceil((n+1)/7),n%=7),o=y(10,7-n),u=e[r]%o|0,null==i?n<3?(0==n?u=u/100|0:1==n&&(u=u/10|0),s=t<4&&99999==u||t>3&&49999==u||5e4==u||0==u):s=(t<4&&u+1==o||t>3&&u+1==o/2)&&(e[r+1]/o/100|0)==y(10,n-2)-1||(u==o/2||0==u)&&0==(e[r+1]/o/100|0):n<4?(0==n?u=u/1e3|0:1==n?u=u/100|0:2==n&&(u=u/10|0),s=(i||t<4)&&9999==u||!i&&t>3&&4999==u):s=((i||t<4)&&u+1==o||!i&&t>3&&u+1==o/2)&&(e[r+1]/o/1e3|0)==y(10,n-3)-1,s}function S(e,n,t){for(var i,r,o=[0],s=0,u=e.length;s<u;){for(r=o.length;r--;)o[r]*=n;for(o[0]+=f.indexOf(e.charAt(s++)),i=0;i<o.length;i++)o[i]>t-1&&(void 0===o[i+1]&&(o[i+1]=0),o[i+1]+=o[i]/t|0,o[i]%=t);}return o.reverse()}j.absoluteValue=j.abs=function(){var e=new this.constructor(this);return e.s<0&&(e.s=1),I(e)},j.ceil=function(){return I(new this.constructor(this),this.e+1,2)},j.clampedTo=j.clamp=function(e,n){var t=this,i=t.constructor;if(e=new i(e),n=new i(n),!e.s||!n.s)return new i(NaN);if(e.gt(n))throw Error(g+n);return t.cmp(e)<0?e:t.cmp(n)>0?n:new i(t)},j.comparedTo=j.cmp=function(e){var n,t,i,r,o=this,s=o.d,u=(e=new o.constructor(e)).d,a=o.s,c=e.s;if(!s||!u)return a&&c?a!==c?a:s===u?0:!s^a<0?1:-1:NaN;if(!s[0]||!u[0])return s[0]?a:u[0]?-c:0;if(a!==c)return a;if(o.e!==e.e)return o.e>e.e^a<0?1:-1;for(n=0,t=(i=s.length)<(r=u.length)?i:r;n<t;++n)if(s[n]!==u[n])return s[n]>u[n]^a<0?1:-1;return i===r?0:i>r^a<0?1:-1},j.cosine=j.cos=function(){var e,n,t=this,i=t.constructor;return t.d?t.d[0]?(e=i.precision,n=i.rounding,i.precision=e+Math.max(t.e,t.sd())+7,i.rounding=1,t=function(e,n){var t,i,r;if(n.isZero())return n;(i=n.d.length)<32?r=(1/K(4,t=Math.ceil(i/3))).toString():(t=16,r="2.3283064365386962890625e-10"),e.precision+=t,n=z(e,1,n.times(r),new e(1));for(var o=t;o--;){var s=n.times(n);n=s.times(s).minus(s).times(8).plus(1);}return e.precision-=t,n}(i,Q(i,t)),i.precision=e,i.rounding=n,I(2==u||3==u?t.neg():t,e,n,!0)):new i(1):new i(NaN)},j.cubeRoot=j.cbrt=function(){var e,n,t,i,r,o,s,u,a,c,f=this,l=f.constructor;if(!f.isFinite()||f.isZero())return new l(f);for(m=!1,(o=f.s*y(f.s*f,1/3))&&Math.abs(o)!=1/0?i=new l(o.toString()):(t=T(f.d),(o=((e=f.e)-t.length+1)%3)&&(t+=1==o||-2==o?"0":"00"),o=y(t,1/3),e=E((e+1)/3)-(e%3==(e<0?-1:2)),(i=new l(t=o==1/0?"5e"+e:(t=o.toExponential()).slice(0,t.indexOf("e")+1)+e)).s=f.s),s=(e=l.precision)+3;;)if(c=(a=(u=i).times(u).times(u)).plus(f),i=q(c.plus(f).times(u),c.plus(a),s+2,1),T(u.d).slice(0,s)===(t=T(i.d)).slice(0,s)){if("9999"!=(t=t.slice(s-3,s+1))&&(r||"4999"!=t)){+t&&(+t.slice(1)||"5"!=t.charAt(0))||(I(i,e+1,1),n=!i.times(i).times(i).eq(f));break}if(!r&&(I(u,e+1,0),u.times(u).times(u).eq(f))){i=u;break}s+=4,r=1;}return m=!0,I(i,e,l.rounding,n)},j.decimalPlaces=j.dp=function(){var e,n=this.d,t=NaN;if(n){if(t=7*((e=n.length-1)-E(this.e/7)),e=n[e])for(;e%10==0;e/=10)t--;t<0&&(t=0);}return t},j.dividedBy=j.div=function(e){return q(this,new this.constructor(e))},j.dividedToIntegerBy=j.divToInt=function(e){var n=this.constructor;return I(q(this,new n(e),0,1,1),n.precision,n.rounding)},j.equals=j.eq=function(e){return 0===this.cmp(e)},j.floor=function(){return I(new this.constructor(this),this.e+1,3)},j.greaterThan=j.gt=function(e){return this.cmp(e)>0},j.greaterThanOrEqualTo=j.gte=function(e){var n=this.cmp(e);return 1==n||0===n},j.hyperbolicCosine=j.cosh=function(){var e,n,t,i,r,o=this,s=o.constructor,u=new s(1);if(!o.isFinite())return new s(o.s?1/0:NaN);if(o.isZero())return u;t=s.precision,i=s.rounding,s.precision=t+Math.max(o.e,o.sd())+4,s.rounding=1,(r=o.d.length)<32?n=(1/K(4,e=Math.ceil(r/3))).toString():(e=16,n="2.3283064365386962890625e-10"),o=z(s,1,o.times(n),new s(1),!0);for(var a,c=e,f=new s(8);c--;)a=o.times(o),o=u.minus(a.times(f.minus(a.times(f))));return I(o,s.precision=t,s.rounding=i,!0)},j.hyperbolicSine=j.sinh=function(){var e,n,t,i,r=this,o=r.constructor;if(!r.isFinite()||r.isZero())return new o(r);if(n=o.precision,t=o.rounding,o.precision=n+Math.max(r.e,r.sd())+4,o.rounding=1,(i=r.d.length)<3)r=z(o,2,r,r,!0);else {e=(e=1.4*Math.sqrt(i))>16?16:0|e,r=z(o,2,r=r.times(1/K(5,e)),r,!0);for(var s,u=new o(5),a=new o(16),c=new o(20);e--;)s=r.times(r),r=r.times(u.plus(s.times(a.times(s).plus(c))));}return o.precision=n,o.rounding=t,I(r,n,t,!0)},j.hyperbolicTangent=j.tanh=function(){var e,n,t=this,i=t.constructor;return t.isFinite()?t.isZero()?new i(t):(e=i.precision,n=i.rounding,i.precision=e+7,i.rounding=1,q(t.sinh(),t.cosh(),i.precision=e,i.rounding=n)):new i(t.s)},j.inverseCosine=j.acos=function(){var e,n=this,t=n.constructor,i=n.abs().cmp(1),r=t.precision,o=t.rounding;return -1!==i?0===i?n.isNeg()?Z(t,r,o):new t(0):new t(NaN):n.isZero()?Z(t,r+4,o).times(.5):(t.precision=r+6,t.rounding=1,n=n.asin(),e=Z(t,r+4,o).times(.5),t.precision=r,t.rounding=o,e.minus(n))},j.inverseHyperbolicCosine=j.acosh=function(){var e,n,t=this,i=t.constructor;return t.lte(1)?new i(t.eq(1)?0:NaN):t.isFinite()?(e=i.precision,n=i.rounding,i.precision=e+Math.max(Math.abs(t.e),t.sd())+4,i.rounding=1,m=!1,t=t.times(t).minus(1).sqrt().plus(t),m=!0,i.precision=e,i.rounding=n,t.ln()):new i(t)},j.inverseHyperbolicSine=j.asinh=function(){var e,n,t=this,i=t.constructor;return !t.isFinite()||t.isZero()?new i(t):(e=i.precision,n=i.rounding,i.precision=e+2*Math.max(Math.abs(t.e),t.sd())+6,i.rounding=1,m=!1,t=t.times(t).plus(1).sqrt().plus(t),m=!0,i.precision=e,i.rounding=n,t.ln())},j.inverseHyperbolicTangent=j.atanh=function(){var e,n,t,i,r=this,o=r.constructor;return r.isFinite()?r.e>=0?new o(r.abs().eq(1)?r.s/0:r.isZero()?r:NaN):(e=o.precision,n=o.rounding,i=r.sd(),Math.max(i,e)<2*-r.e-1?I(new o(r),e,n,!0):(o.precision=t=i-r.e,r=q(r.plus(1),new o(1).minus(r),t+e,1),o.precision=e+4,o.rounding=1,r=r.ln(),o.precision=e,o.rounding=n,r.times(.5))):new o(NaN)},j.inverseSine=j.asin=function(){var e,n,t,i,r=this,o=r.constructor;return r.isZero()?new o(r):(n=r.abs().cmp(1),t=o.precision,i=o.rounding,-1!==n?0===n?((e=Z(o,t+4,i).times(.5)).s=r.s,e):new o(NaN):(o.precision=t+6,o.rounding=1,r=r.div(new o(1).minus(r.times(r)).sqrt().plus(1)).atan(),o.precision=t,o.rounding=i,r.times(2)))},j.inverseTangent=j.atan=function(){var e,n,t,i,r,o,s,u,a,c=this,f=c.constructor,l=f.precision,d=f.rounding;if(c.isFinite()){if(c.isZero())return new f(c);if(c.abs().eq(1)&&l+4<=P)return (s=Z(f,l+4,d).times(.25)).s=c.s,s}else {if(!c.s)return new f(NaN);if(l+4<=P)return (s=Z(f,l+4,d).times(.5)).s=c.s,s}for(f.precision=u=l+10,f.rounding=1,e=t=Math.min(28,u/7+2|0);e;--e)c=c.div(c.times(c).plus(1).sqrt().plus(1));for(m=!1,n=Math.ceil(u/7),i=1,a=c.times(c),s=new f(c),r=c;-1!==e;)if(r=r.times(a),o=s.minus(r.div(i+=2)),r=r.times(a),void 0!==(s=o.plus(r.div(i+=2))).d[n])for(e=n;s.d[e]===o.d[e]&&e--;);return t&&(s=s.times(2<<t-1)),m=!0,I(s,f.precision=l,f.rounding=d,!0)},j.isFinite=function(){return !!this.d},j.isInteger=j.isInt=function(){return !!this.d&&E(this.e/7)>this.d.length-2},j.isNaN=function(){return !this.s},j.isNegative=j.isNeg=function(){return this.s<0},j.isPositive=j.isPos=function(){return this.s>0},j.isZero=function(){return !!this.d&&0===this.d[0]},j.lessThan=j.lt=function(e){return this.cmp(e)<0},j.lessThanOrEqualTo=j.lte=function(e){return this.cmp(e)<1},j.logarithm=j.log=function(e){var n,t,i,r,o,s,u,a,c=this.constructor,f=c.precision,l=c.rounding;if(null==e)e=new c(10),n=!0;else {if(t=(e=new c(e)).d,e.s<0||!t||!t[0]||e.eq(1))return new c(NaN);n=e.eq(10);}if(t=this.d,this.s<0||!t||!t[0]||this.eq(1))return new c(t&&!t[0]?-1/0:1!=this.s?NaN:t?0:1/0);if(n)if(t.length>1)o=!0;else {for(r=t[0];r%10==0;)r/=10;o=1!==r;}if(m=!1,s=X(this,u=f+5),i=n?F(c,u+10):X(e,u),D((a=q(s,i,u,1)).d,r=f,l))do{if(s=X(this,u+=10),i=n?F(c,u+10):X(e,u),a=q(s,i,u,1),!o){+T(a.d).slice(r+1,r+15)+1==1e14&&(a=I(a,f+1,0));break}}while(D(a.d,r+=10,l));return m=!0,I(a,f,l)},j.minus=j.sub=function(e){var n,t,i,r,o,s,u,a,c,f,l,d,h=this,p=h.constructor;if(e=new p(e),!h.d||!e.d)return h.s&&e.s?h.d?e.s=-e.s:e=new p(e.d||h.s!==e.s?h:NaN):e=new p(NaN),e;if(h.s!=e.s)return e.s=-e.s,h.plus(e);if(c=h.d,d=e.d,u=p.precision,a=p.rounding,!c[0]||!d[0]){if(d[0])e.s=-e.s;else {if(!c[0])return new p(3===a?-0:0);e=new p(h);}return m?I(e,u,a):e}if(t=E(e.e/7),f=E(h.e/7),c=c.slice(),o=f-t){for((l=o<0)?(n=c,o=-o,s=d.length):(n=d,t=f,s=c.length),o>(i=Math.max(Math.ceil(u/7),s)+2)&&(o=i,n.length=1),n.reverse(),i=o;i--;)n.push(0);n.reverse();}else {for((l=(i=c.length)<(s=d.length))&&(s=i),i=0;i<s;i++)if(c[i]!=d[i]){l=c[i]<d[i];break}o=0;}for(l&&(n=c,c=d,d=n,e.s=-e.s),s=c.length,i=d.length-s;i>0;--i)c[s++]=0;for(i=d.length;i>o;){if(c[--i]<d[i]){for(r=i;r&&0===c[--r];)c[r]=M-1;--c[r],c[i]+=M;}c[i]-=d[i];}for(;0===c[--s];)c.pop();for(;0===c[0];c.shift())--t;return c[0]?(e.d=c,e.e=C(c,t),m?I(e,u,a):e):new p(3===a?-0:0)},j.modulo=j.mod=function(e){var n,t=this,i=t.constructor;return e=new i(e),!t.d||!e.s||e.d&&!e.d[0]?new i(NaN):!e.d||t.d&&!t.d[0]?I(new i(t),i.precision,i.rounding):(m=!1,9==i.modulo?(n=q(t,e.abs(),0,3,1)).s*=e.s:n=q(t,e,0,i.modulo,1),n=n.times(e),m=!0,t.minus(n))},j.naturalExponential=j.exp=function(){return B(this)},j.naturalLogarithm=j.ln=function(){return X(this)},j.negated=j.neg=function(){var e=new this.constructor(this);return e.s=-e.s,I(e)},j.plus=j.add=function(e){var n,t,i,r,o,s,u,a,c,f,l=this,d=l.constructor;if(e=new d(e),!l.d||!e.d)return l.s&&e.s?l.d||(e=new d(e.d||l.s===e.s?l:NaN)):e=new d(NaN),e;if(l.s!=e.s)return e.s=-e.s,l.minus(e);if(c=l.d,f=e.d,u=d.precision,a=d.rounding,!c[0]||!f[0])return f[0]||(e=new d(l)),m?I(e,u,a):e;if(o=E(l.e/7),i=E(e.e/7),c=c.slice(),r=o-i){for(r<0?(t=c,r=-r,s=f.length):(t=f,i=o,s=c.length),r>(s=(o=Math.ceil(u/7))>s?o+1:s+1)&&(r=s,t.length=1),t.reverse();r--;)t.push(0);t.reverse();}for((s=c.length)-(r=f.length)<0&&(r=s,t=f,f=c,c=t),n=0;r;)n=(c[--r]=c[r]+f[r]+n)/M|0,c[r]%=M;for(n&&(c.unshift(n),++i),s=c.length;0==c[--s];)c.pop();return e.d=c,e.e=C(c,i),m?I(e,u,a):e},j.precision=j.sd=function(e){var n,t=this;if(void 0!==e&&e!==!!e&&1!==e&&0!==e)throw Error(g+e);return t.d?(n=L(t.d),e&&t.e+1>n&&(n=t.e+1)):n=NaN,n},j.round=function(){var e=this,n=e.constructor;return I(new n(e),e.e+1,n.rounding)},j.sine=j.sin=function(){var e,n,t=this,i=t.constructor;return t.isFinite()?t.isZero()?new i(t):(e=i.precision,n=i.rounding,i.precision=e+Math.max(t.e,t.sd())+7,i.rounding=1,t=function(e,n){var t,i=n.d.length;if(i<3)return n.isZero()?n:z(e,2,n,n);t=(t=1.4*Math.sqrt(i))>16?16:0|t,n=z(e,2,n=n.times(1/K(5,t)),n);for(var r,o=new e(5),s=new e(16),u=new e(20);t--;)r=n.times(n),n=n.times(o.plus(r.times(s.times(r).minus(u))));return n}(i,Q(i,t)),i.precision=e,i.rounding=n,I(u>2?t.neg():t,e,n,!0)):new i(NaN)},j.squareRoot=j.sqrt=function(){var e,n,t,i,r,o,s=this,u=s.d,a=s.e,c=s.s,f=s.constructor;if(1!==c||!u||!u[0])return new f(!c||c<0&&(!u||u[0])?NaN:u?s:1/0);for(m=!1,0==(c=Math.sqrt(+s))||c==1/0?(((n=T(u)).length+a)%2==0&&(n+="0"),c=Math.sqrt(n),a=E((a+1)/2)-(a<0||a%2),i=new f(n=c==1/0?"5e"+a:(n=c.toExponential()).slice(0,n.indexOf("e")+1)+a)):i=new f(c.toString()),t=(a=f.precision)+3;;)if(i=(o=i).plus(q(s,o,t+2,1)).times(.5),T(o.d).slice(0,t)===(n=T(i.d)).slice(0,t)){if("9999"!=(n=n.slice(t-3,t+1))&&(r||"4999"!=n)){+n&&(+n.slice(1)||"5"!=n.charAt(0))||(I(i,a+1,1),e=!i.times(i).eq(s));break}if(!r&&(I(o,a+1,0),o.times(o).eq(s))){i=o;break}t+=4,r=1;}return m=!0,I(i,a,f.rounding,e)},j.tangent=j.tan=function(){var e,n,t=this,i=t.constructor;return t.isFinite()?t.isZero()?new i(t):(e=i.precision,n=i.rounding,i.precision=e+10,i.rounding=1,(t=t.sin()).s=1,t=q(t,new i(1).minus(t.times(t)).sqrt(),e+10,0),i.precision=e,i.rounding=n,I(2==u||4==u?t.neg():t,e,n,!0)):new i(NaN)},j.times=j.mul=function(e){var n,t,i,r,o,s,u,a,c,f=this,l=f.constructor,d=f.d,h=(e=new l(e)).d;if(e.s*=f.s,!(d&&d[0]&&h&&h[0]))return new l(!e.s||d&&!d[0]&&!h||h&&!h[0]&&!d?NaN:d&&h?0*e.s:e.s/0);for(t=E(f.e/7)+E(e.e/7),(a=d.length)<(c=h.length)&&(o=d,d=h,h=o,s=a,a=c,c=s),o=[],i=s=a+c;i--;)o.push(0);for(i=c;--i>=0;){for(n=0,r=a+i;r>i;)u=o[r]+h[i]*d[r-i-1]+n,o[r--]=u%M|0,n=u/M|0;o[r]=(o[r]+n)%M|0;}for(;!o[--s];)o.pop();return n?++t:o.shift(),e.d=o,e.e=C(o,t),m?I(e,l.precision,l.rounding):e},j.toBinary=function(e,n){return Y(this,2,e,n)},j.toDecimalPlaces=j.toDP=function(e,n){var t=this,i=t.constructor;return t=new i(t),void 0===e?t:(R(e,0,c),void 0===n?n=i.rounding:R(n,0,8),I(t,e+t.e+1,n))},j.toExponential=function(e,n){var t,i=this,r=i.constructor;return void 0===e?t=V(i,!0):(R(e,0,c),void 0===n?n=r.rounding:R(n,0,8),t=V(i=I(new r(i),e+1,n),!0,e+1)),i.isNeg()&&!i.isZero()?"-"+t:t},j.toFixed=function(e,n){var t,i,r=this,o=r.constructor;return void 0===e?t=V(r):(R(e,0,c),void 0===n?n=o.rounding:R(n,0,8),t=V(i=I(new o(r),e+r.e+1,n),!1,e+i.e+1)),r.isNeg()&&!r.isZero()?"-"+t:t},j.toFraction=function(e){var n,t,i,r,o,s,u,a,c,f,l,d,h=this,p=h.d,w=h.constructor;if(!p)return new w(h);if(c=t=new w(1),s=(o=(n=new w(i=a=new w(0))).e=L(p)-h.e-1)%7,n.d[0]=y(10,s<0?7+s:s),null==e)e=o>0?n:c;else {if(!(u=new w(e)).isInt()||u.lt(c))throw Error(g+u);e=u.gt(n)?o>0?n:c:u;}for(m=!1,u=new w(T(p)),f=w.precision,w.precision=o=7*p.length*2;l=q(u,n,0,1,1),1!=(r=t.plus(l.times(i))).cmp(e);)t=i,i=r,r=c,c=a.plus(l.times(r)),a=r,r=n,n=u.minus(l.times(r)),u=r;return r=q(e.minus(t),i,0,1,1),a=a.plus(r.times(c)),t=t.plus(r.times(i)),a.s=c.s=h.s,d=q(c,i,o,1).minus(h).abs().cmp(q(a,t,o,1).minus(h).abs())<1?[c,i]:[a,t],w.precision=f,m=!0,d},j.toHexadecimal=j.toHex=function(e,n){return Y(this,16,e,n)},j.toNearest=function(e,n){var t=this,i=t.constructor;if(t=new i(t),null==e){if(!t.d)return t;e=new i(1),n=i.rounding;}else {if(e=new i(e),void 0===n?n=i.rounding:R(n,0,8),!t.d)return e.s?t:e;if(!e.d)return e.s&&(e.s=t.s),e}return e.d[0]?(m=!1,t=q(t,e,0,n,1).times(e),m=!0,I(t)):(e.s=t.s,t=e),t},j.toNumber=function(){return +this},j.toOctal=function(e,n){return Y(this,8,e,n)},j.toPower=j.pow=function(e){var n,t,i,r,o,s,u=this,a=u.constructor,c=+(e=new a(e));if(!(u.d&&e.d&&u.d[0]&&e.d[0]))return new a(y(+u,c));if((u=new a(u)).eq(1))return u;if(i=a.precision,o=a.rounding,e.eq(1))return I(u,i,o);if((n=E(e.e/7))>=e.d.length-1&&(t=c<0?-c:c)<=9007199254740991)return r=U(a,u,t,i),e.s<0?new a(1).div(r):I(r,i,o);if((s=u.s)<0){if(n<e.d.length-1)return new a(NaN);if(0==(1&e.d[n])&&(s=1),0==u.e&&1==u.d[0]&&1==u.d.length)return u.s=s,u}return (n=0!=(t=y(+u,c))&&isFinite(t)?new a(t+"").e:E(c*(Math.log("0."+T(u.d))/Math.LN10+u.e+1)))>a.maxE+1||n<a.minE-1?new a(n>0?s/0:0):(m=!1,a.rounding=u.s=1,t=Math.min(12,(n+"").length),(r=B(e.times(X(u,i+t)),i)).d&&D((r=I(r,i+5,1)).d,i,o)&&(n=i+10,+T((r=I(B(e.times(X(u,n+t)),n),n+5,1)).d).slice(i+1,i+15)+1==1e14&&(r=I(r,i+1,0))),r.s=s,m=!0,a.rounding=o,I(r,i,o))},j.toPrecision=function(e,n){var t,i=this,r=i.constructor;return void 0===e?t=V(i,i.e<=r.toExpNeg||i.e>=r.toExpPos):(R(e,1,c),void 0===n?n=r.rounding:R(n,0,8),t=V(i=I(new r(i),e,n),e<=i.e||i.e<=r.toExpNeg,e)),i.isNeg()&&!i.isZero()?"-"+t:t},j.toSignificantDigits=j.toSD=function(e,n){var t=this.constructor;return void 0===e?(e=t.precision,n=t.rounding):(R(e,1,c),void 0===n?n=t.rounding:R(n,0,8)),I(new t(this),e,n)},j.toString=function(){var e=this,n=e.constructor,t=V(e,e.e<=n.toExpNeg||e.e>=n.toExpPos);return e.isNeg()&&!e.isZero()?"-"+t:t},j.truncated=j.trunc=function(){return I(new this.constructor(this),this.e+1,1)},j.valueOf=j.toJSON=function(){var e=this,n=e.constructor,t=V(e,e.e<=n.toExpNeg||e.e>=n.toExpPos);return e.isNeg()?"-"+t:t};var q=function(){function e(e,n,t){var i,r=0,o=e.length;for(e=e.slice();o--;)i=e[o]*n+r,e[o]=i%t|0,r=i/t|0;return r&&e.unshift(r),e}function n(e,n,t,i){var r,o;if(t!=i)o=t>i?1:-1;else for(r=o=0;r<t;r++)if(e[r]!=n[r]){o=e[r]>n[r]?1:-1;break}return o}function t(e,n,t,i){for(var r=0;t--;)e[t]-=r,r=e[t]<n[t]?1:0,e[t]=r*i+e[t]-n[t];for(;!e[0]&&e.length>1;)e.shift();}return function(i,r,o,u,a,c){var f,l,d,h,m,p,g,w,v,N,y,_,b,x,O,A,P,j,T,R,D=i.constructor,S=i.s==r.s?1:-1,q=i.d,V=r.d;if(!(q&&q[0]&&V&&V[0]))return new D(i.s&&r.s&&(q?!V||q[0]!=V[0]:V)?q&&0==q[0]||!V?0*S:S/0:NaN);for(c?(m=1,l=i.e-r.e):(c=M,m=7,l=E(i.e/m)-E(r.e/m)),T=V.length,P=q.length,N=(v=new D(S)).d=[],d=0;V[d]==(q[d]||0);d++);if(V[d]>(q[d]||0)&&l--,null==o?(x=o=D.precision,u=D.rounding):x=a?o+(i.e-r.e)+1:o,x<0)N.push(1),p=!0;else {if(x=x/m+2|0,d=0,1==T){for(h=0,V=V[0],x++;(d<P||h)&&x--;d++)O=h*c+(q[d]||0),N[d]=O/V|0,h=O%V|0;p=h||d<P;}else {for((h=c/(V[0]+1)|0)>1&&(V=e(V,h,c),q=e(q,h,c),T=V.length,P=q.length),A=T,_=(y=q.slice(0,T)).length;_<T;)y[_++]=0;(R=V.slice()).unshift(0),j=V[0],V[1]>=c/2&&++j;do{h=0,(f=n(V,y,T,_))<0?(b=y[0],T!=_&&(b=b*c+(y[1]||0)),(h=b/j|0)>1?(h>=c&&(h=c-1),1==(f=n(g=e(V,h,c),y,w=g.length,_=y.length))&&(h--,t(g,T<w?R:V,w,c))):(0==h&&(f=h=1),g=V.slice()),(w=g.length)<_&&g.unshift(0),t(y,g,_,c),-1==f&&(f=n(V,y,T,_=y.length))<1&&(h++,t(y,T<_?R:V,_,c)),_=y.length):0===f&&(h++,y=[0]),N[d++]=h,f&&y[0]?y[_++]=q[A]||0:(y=[q[A]],_=1);}while((A++<P||void 0!==y[0])&&x--);p=void 0!==y[0];}N[0]||N.shift();}if(1==m)v.e=l,s=p;else {for(d=1,h=N[0];h>=10;h/=10)d++;v.e=d+l*m-1,I(v,a?o+v.e+1:o,u,p);}return v}}();function I(e,n,t,i){var r,o,s,u,a,c,f,l,d,h=e.constructor;e:if(null!=n){if(!(l=e.d))return e;for(r=1,u=l[0];u>=10;u/=10)r++;if((o=n-r)<0)o+=7,s=n,a=(f=l[d=0])/y(10,r-s-1)%10|0;else if((d=Math.ceil((o+1)/7))>=(u=l.length)){if(!i)break e;for(;u++<=d;)l.push(0);f=a=0,r=1,s=(o%=7)-7+1;}else {for(f=u=l[d],r=1;u>=10;u/=10)r++;a=(s=(o%=7)-7+r)<0?0:f/y(10,r-s-1)%10|0;}if(i=i||n<0||void 0!==l[d+1]||(s<0?f:f%y(10,r-s-1)),c=t<4?(a||i)&&(0==t||t==(e.s<0?3:2)):a>5||5==a&&(4==t||i||6==t&&(o>0?s>0?f/y(10,r-s):0:l[d-1])%10&1||t==(e.s<0?8:7)),n<1||!l[0])return l.length=0,c?(n-=e.e+1,l[0]=y(10,(7-n%7)%7),e.e=-n||0):l[0]=e.e=0,e;if(0==o?(l.length=d,u=1,d--):(l.length=d+1,u=y(10,7-o),l[d]=s>0?(f/y(10,r-s)%y(10,s)|0)*u:0),c)for(;;){if(0==d){for(o=1,s=l[0];s>=10;s/=10)o++;for(s=l[0]+=u,u=1;s>=10;s/=10)u++;o!=u&&(e.e++,l[0]==M&&(l[0]=1));break}if(l[d]+=u,l[d]!=M)break;l[d--]=0,u=1;}for(o=l.length;0===l[--o];)l.pop();}return m&&(e.e>h.maxE?(e.d=null,e.e=NaN):e.e<h.minE&&(e.e=0,e.d=[0])),e}function V(e,n,t){if(!e.isFinite())return $(e);var i,r=e.e,o=T(e.d),s=o.length;return n?(t&&(i=t-s)>0?o=o.charAt(0)+"."+o.slice(1)+k(i):s>1&&(o=o.charAt(0)+"."+o.slice(1)),o=o+(e.e<0?"e":"e+")+e.e):r<0?(o="0."+k(-r-1)+o,t&&(i=t-s)>0&&(o+=k(i))):r>=s?(o+=k(r+1-s),t&&(i=t-r-1)>0&&(o=o+"."+k(i))):((i=r+1)<s&&(o=o.slice(0,i)+"."+o.slice(i)),t&&(i=t-s)>0&&(r+1===s&&(o+="."),o+=k(i))),o}function C(e,n){var t=e[0];for(n*=7;t>=10;t/=10)n++;return n}function F(e,n,t){if(n>A)throw m=!0,t&&(e.precision=t),Error(w);return I(new e(l),n,1,!0)}function Z(e,n,t){if(n>P)throw Error(w);return I(new e(d),n,t,!0)}function L(e){var n=e.length-1,t=7*n+1;if(n=e[n]){for(;n%10==0;n/=10)t--;for(n=e[0];n>=10;n/=10)t++;}return t}function k(e){for(var n="";e--;)n+="0";return n}function U(e,n,t,i){var r,o=new e(1),s=Math.ceil(i/7+4);for(m=!1;;){if(t%2&&ee((o=o.times(n)).d,s)&&(r=!0),0===(t=E(t/2))){t=o.d.length-1,r&&0===o.d[t]&&++o.d[t];break}ee((n=n.times(n)).d,s);}return m=!0,o}function H(e){return 1&e.d[e.d.length-1]}function G(e,n,t){for(var i,r=new e(n[0]),o=0;++o<n.length;){if(!(i=new e(n[o])).s){r=i;break}r[t](i)&&(r=i);}return r}function B(e,n){var t,i,r,o,s,u,a,c=0,f=0,l=0,d=e.constructor,h=d.rounding,p=d.precision;if(!e.d||!e.d[0]||e.e>17)return new d(e.d?e.d[0]?e.s<0?0:1/0:1:e.s?e.s<0?0:e:NaN);for(null==n?(m=!1,a=p):a=n,u=new d(.03125);e.e>-2;)e=e.times(u),l+=5;for(a+=i=Math.log(y(2,l))/Math.LN10*2+5|0,t=o=s=new d(1),d.precision=a;;){if(o=I(o.times(e),a,1),t=t.times(++f),T((u=s.plus(q(o,t,a,1))).d).slice(0,a)===T(s.d).slice(0,a)){for(r=l;r--;)s=I(s.times(s),a,1);if(null!=n)return d.precision=p,s;if(!(c<3&&D(s.d,a-i,h,c)))return I(s,d.precision=p,h,m=!0);d.precision=a+=10,t=o=u=new d(1),f=0,c++;}s=u;}}function X(e,n){var t,i,r,o,s,u,a,c,f,l,d,h=1,p=e,g=p.d,w=p.constructor,v=w.rounding,N=w.precision;if(p.s<0||!g||!g[0]||!p.e&&1==g[0]&&1==g.length)return new w(g&&!g[0]?-1/0:1!=p.s?NaN:g?0:p);if(null==n?(m=!1,f=N):f=n,w.precision=f+=10,i=(t=T(g)).charAt(0),!(Math.abs(o=p.e)<15e14))return c=F(w,f+2,N).times(o+""),p=X(new w(i+"."+t.slice(1)),f-10).plus(c),w.precision=N,null==n?I(p,N,v,m=!0):p;for(;i<7&&1!=i||1==i&&t.charAt(1)>3;)i=(t=T((p=p.times(e)).d)).charAt(0),h++;for(o=p.e,i>1?(p=new w("0."+t),o++):p=new w(i+"."+t.slice(1)),l=p,a=s=p=q(p.minus(1),p.plus(1),f,1),d=I(p.times(p),f,1),r=3;;){if(s=I(s.times(d),f,1),T((c=a.plus(q(s,new w(r),f,1))).d).slice(0,f)===T(a.d).slice(0,f)){if(a=a.times(2),0!==o&&(a=a.plus(F(w,f+2,N).times(o+""))),a=q(a,new w(h),f,1),null!=n)return w.precision=N,a;if(!D(a.d,f-10,v,u))return I(a,w.precision=N,v,m=!0);w.precision=f+=10,c=s=p=q(l.minus(1),l.plus(1),f,1),d=I(p.times(p),f,1),r=u=1;}a=c,r+=2;}}function $(e){return String(e.s*e.s/0)}function W(e,n){var t,i,r;for((t=n.indexOf("."))>-1&&(n=n.replace(".","")),(i=n.search(/e/i))>0?(t<0&&(t=i),t+=+n.slice(i+1),n=n.substring(0,i)):t<0&&(t=n.length),i=0;48===n.charCodeAt(i);i++);for(r=n.length;48===n.charCodeAt(r-1);--r);if(n=n.slice(i,r)){if(r-=i,e.e=t=t-i-1,e.d=[],i=(t+1)%7,t<0&&(i+=7),i<r){for(i&&e.d.push(+n.slice(0,i)),r-=7;i<r;)e.d.push(+n.slice(i,i+=7));i=7-(n=n.slice(i)).length;}else i-=r;for(;i--;)n+="0";e.d.push(+n),m&&(e.e>e.constructor.maxE?(e.d=null,e.e=NaN):e.e<e.constructor.minE&&(e.e=0,e.d=[0]));}else e.e=0,e.d=[0];return e}function J(e,n){var t,i,r,s,u,a,c,f,l;if(n.indexOf("_")>-1){if(n=n.replace(/(\d)_(?=\d)/g,"$1"),O.test(n))return W(e,n)}else if("Infinity"===n||"NaN"===n)return +n||(e.s=NaN),e.e=NaN,e.d=null,e;if(b.test(n))t=16,n=n.toLowerCase();else if(_.test(n))t=2;else {if(!x.test(n))throw Error(g+n);t=8;}for((s=n.search(/p/i))>0?(c=+n.slice(s+1),n=n.substring(2,s)):n=n.slice(2),u=(s=n.indexOf("."))>=0,i=e.constructor,u&&(s=(a=(n=n.replace(".","")).length)-s,r=U(i,new i(t),s,2*s)),s=l=(f=S(n,t,M)).length-1;0===f[s];--s)f.pop();return s<0?new i(0*e.s):(e.e=C(f,l),e.d=f,m=!1,u&&(e=q(e,r,4*a)),c&&(e=e.times(Math.abs(c)<54?y(2,c):o.pow(2,c))),m=!0,e)}function z(e,n,t,i,r){var o,s,u,a,c=e.precision,f=Math.ceil(c/7);for(m=!1,a=t.times(t),u=new e(i);;){if(s=q(u.times(a),new e(n++*n++),c,1),u=r?i.plus(s):i.minus(s),i=q(s.times(a),new e(n++*n++),c,1),void 0!==(s=u.plus(i)).d[f]){for(o=f;s.d[o]===u.d[o]&&o--;);if(-1==o)break}o=u,u=i,i=s,s=o;}return m=!0,s.d.length=f+1,s}function K(e,n){for(var t=e;--n;)t*=e;return t}function Q(e,n){var t,i=n.s<0,r=Z(e,e.precision,1),o=r.times(.5);if((n=n.abs()).lte(o))return u=i?4:1,n;if((t=n.divToInt(r)).isZero())u=i?3:2;else {if((n=n.minus(t.times(r))).lte(o))return u=H(t)?i?2:3:i?4:1,n;u=H(t)?i?1:4:i?3:2;}return n.minus(r).abs()}function Y(e,n,t,i){var r,o,u,a,l,d,h,m,p,g=e.constructor,w=void 0!==t;if(w?(R(t,1,c),void 0===i?i=g.rounding:R(i,0,8)):(t=g.precision,i=g.rounding),e.isFinite()){for(w?(r=2,16==n?t=4*t-3:8==n&&(t=3*t-2)):r=n,(u=(h=V(e)).indexOf("."))>=0&&(h=h.replace(".",""),(p=new g(1)).e=h.length-u,p.d=S(V(p),10,r),p.e=p.d.length),o=l=(m=S(h,10,r)).length;0==m[--l];)m.pop();if(m[0]){if(u<0?o--:((e=new g(e)).d=m,e.e=o,m=(e=q(e,p,t,i,0,r)).d,o=e.e,d=s),u=m[t],a=r/2,d=d||void 0!==m[t+1],d=i<4?(void 0!==u||d)&&(0===i||i===(e.s<0?3:2)):u>a||u===a&&(4===i||d||6===i&&1&m[t-1]||i===(e.s<0?8:7)),m.length=t,d)for(;++m[--t]>r-1;)m[t]=0,t||(++o,m.unshift(1));for(l=m.length;!m[l-1];--l);for(u=0,h="";u<l;u++)h+=f.charAt(m[u]);if(w){if(l>1)if(16==n||8==n){for(u=16==n?4:3,--l;l%u;l++)h+="0";for(l=(m=S(h,r,n)).length;!m[l-1];--l);for(u=1,h="1.";u<l;u++)h+=f.charAt(m[u]);}else h=h.charAt(0)+"."+h.slice(1);h=h+(o<0?"p":"p+")+o;}else if(o<0){for(;++o;)h="0"+h;h="0."+h;}else if(++o>l)for(o-=l;o--;)h+="0";else o<l&&(h=h.slice(0,o)+"."+h.slice(o));}else h=w?"0p+0":"0";h=(16==n?"0x":2==n?"0b":8==n?"0o":"")+h;}else h=$(e);return e.s<0?"-"+h:h}function ee(e,n){if(e.length>n)return e.length=n,!0}function ne(e){return new this(e).abs()}function te(e){return new this(e).acos()}function ie(e){return new this(e).acosh()}function re(e,n){return new this(e).plus(n)}function oe(e){return new this(e).asin()}function se(e){return new this(e).asinh()}function ue(e){return new this(e).atan()}function ae(e){return new this(e).atanh()}function ce(e,n){e=new this(e),n=new this(n);var t,i=this.precision,r=this.rounding,o=i+4;return e.s&&n.s?e.d||n.d?!n.d||e.isZero()?(t=n.s<0?Z(this,i,r):new this(0)).s=e.s:!e.d||n.isZero()?(t=Z(this,o,1).times(.5)).s=e.s:n.s<0?(this.precision=o,this.rounding=1,t=this.atan(q(e,n,o,1)),n=Z(this,o,1),this.precision=i,this.rounding=r,t=e.s<0?t.minus(n):t.plus(n)):t=this.atan(q(e,n,o,1)):(t=Z(this,o,1).times(n.s>0?.25:.75)).s=e.s:t=new this(NaN),t}function fe(e){return new this(e).cbrt()}function le(e){return I(e=new this(e),e.e+1,2)}function de(e,n,t){return new this(e).clamp(n,t)}function he(e){if(!e||"object"!=typeof e)throw Error(p+"Object expected");var n,t,i,r=!0===e.defaults,o=["precision",1,c,"rounding",0,8,"toExpNeg",-a,0,"toExpPos",0,a,"maxE",0,a,"minE",-a,0,"modulo",0,9];for(n=0;n<o.length;n+=3)if(t=o[n],r&&(this[t]=h[t]),void 0!==(i=e[t])){if(!(E(i)===i&&i>=o[n+1]&&i<=o[n+2]))throw Error(g+t+": "+i);this[t]=i;}if(t="crypto",r&&(this[t]=h[t]),void 0!==(i=e[t])){if(!0!==i&&!1!==i&&0!==i&&1!==i)throw Error(g+t+": "+i);if(i){if("undefined"==typeof crypto||!crypto||!crypto.getRandomValues&&!crypto.randomBytes)throw Error(v);this[t]=!0;}else this[t]=!1;}return this}function me(e){return new this(e).cos()}function pe(e){return new this(e).cosh()}function ge(e,n){return new this(e).div(n)}function we(e){return new this(e).exp()}function ve(e){return I(e=new this(e),e.e+1,3)}function Ne(){var e,n,t=new this(0);for(m=!1,e=0;e<arguments.length;)if((n=new this(arguments[e++])).d)t.d&&(t=t.plus(n.times(n)));else {if(n.s)return m=!0,new this(1/0);t=n;}return m=!0,t.sqrt()}function Ee(e){return e instanceof o||e&&e.toStringTag===N||!1}function ye(e){return new this(e).ln()}function _e(e,n){return new this(e).log(n)}function be(e){return new this(e).log(2)}function xe(e){return new this(e).log(10)}function Oe(){return G(this,arguments,"lt")}function Me(){return G(this,arguments,"gt")}function Ae(e,n){return new this(e).mod(n)}function Pe(e,n){return new this(e).mul(n)}function je(e,n){return new this(e).pow(n)}function Te(e){var n,t,i,r,o=0,s=new this(1),u=[];if(void 0===e?e=this.precision:R(e,1,c),i=Math.ceil(e/7),this.crypto)if(crypto.getRandomValues)for(n=crypto.getRandomValues(new Uint32Array(i));o<i;)(r=n[o])>=429e7?n[o]=crypto.getRandomValues(new Uint32Array(1))[0]:u[o++]=r%1e7;else {if(!crypto.randomBytes)throw Error(v);for(n=crypto.randomBytes(i*=4);o<i;)(r=n[o]+(n[o+1]<<8)+(n[o+2]<<16)+((127&n[o+3])<<24))>=214e7?crypto.randomBytes(4).copy(n,o):(u.push(r%1e7),o+=4);o=i/4;}else for(;o<i;)u[o++]=1e7*Math.random()|0;for(e%=7,(i=u[--o])&&e&&(r=y(10,7-e),u[o]=(i/r|0)*r);0===u[o];o--)u.pop();if(o<0)t=0,u=[0];else {for(t=-1;0===u[0];t-=7)u.shift();for(i=1,r=u[0];r>=10;r/=10)i++;i<7&&(t-=7-i);}return s.e=t,s.d=u,s}function Re(e){return I(e=new this(e),e.e+1,this.rounding)}function De(e){return (e=new this(e)).d?e.d[0]?e.s:0*e.s:e.s||NaN}function Se(e){return new this(e).sin()}function qe(e){return new this(e).sinh()}function Ie(e){return new this(e).sqrt()}function Ve(e,n){return new this(e).sub(n)}function Ce(){var e=0,n=arguments,t=new this(n[e]);for(m=!1;t.s&&++e<n.length;)t=t.plus(n[e]);return m=!0,I(t,this.precision,this.rounding)}function Fe(e){return new this(e).tan()}function Ze(e){return new this(e).tanh()}function Le(e){return I(e=new this(e),e.e+1,1)}(o=function e(n){var t,i,r;function o(e){var n,t,i,r=this;if(!(r instanceof o))return new o(e);if(r.constructor=o,Ee(e))return r.s=e.s,void(m?!e.d||e.e>o.maxE?(r.e=NaN,r.d=null):e.e<o.minE?(r.e=0,r.d=[0]):(r.e=e.e,r.d=e.d.slice()):(r.e=e.e,r.d=e.d?e.d.slice():e.d));if("number"==(i=typeof e)){if(0===e)return r.s=1/e<0?-1:1,r.e=0,void(r.d=[0]);if(e<0?(e=-e,r.s=-1):r.s=1,e===~~e&&e<1e7){for(n=0,t=e;t>=10;t/=10)n++;return void(m?n>o.maxE?(r.e=NaN,r.d=null):n<o.minE?(r.e=0,r.d=[0]):(r.e=n,r.d=[e]):(r.e=n,r.d=[e]))}return 0*e!=0?(e||(r.s=NaN),r.e=NaN,void(r.d=null)):W(r,e.toString())}if("string"!==i)throw Error(g+e);return 45===(t=e.charCodeAt(0))?(e=e.slice(1),r.s=-1):(43===t&&(e=e.slice(1)),r.s=1),O.test(e)?W(r,e):J(r,e)}if(o.prototype=j,o.ROUND_UP=0,o.ROUND_DOWN=1,o.ROUND_CEIL=2,o.ROUND_FLOOR=3,o.ROUND_HALF_UP=4,o.ROUND_HALF_DOWN=5,o.ROUND_HALF_EVEN=6,o.ROUND_HALF_CEIL=7,o.ROUND_HALF_FLOOR=8,o.EUCLID=9,o.config=o.set=he,o.clone=e,o.isDecimal=Ee,o.abs=ne,o.acos=te,o.acosh=ie,o.add=re,o.asin=oe,o.asinh=se,o.atan=ue,o.atanh=ae,o.atan2=ce,o.cbrt=fe,o.ceil=le,o.clamp=de,o.cos=me,o.cosh=pe,o.div=ge,o.exp=we,o.floor=ve,o.hypot=Ne,o.ln=ye,o.log=_e,o.log10=xe,o.log2=be,o.max=Oe,o.min=Me,o.mod=Ae,o.mul=Pe,o.pow=je,o.random=Te,o.round=Re,o.sign=De,o.sin=Se,o.sinh=qe,o.sqrt=Ie,o.sub=Ve,o.sum=Ce,o.tan=Fe,o.tanh=Ze,o.trunc=Le,void 0===n&&(n={}),n&&!0!==n.defaults)for(r=["precision","rounding","toExpNeg","toExpPos","maxE","minE","modulo","crypto"],t=0;t<r.length;)n.hasOwnProperty(i=r[t++])||(n[i]=this[i]);return o.config(n),o}(h)).prototype.constructor=o,o.default=o.Decimal=o,l=new o(l),d=new o(d),void 0===(i=function(){return o}.call(n,t,n,e))||(e.exports=i);}();},function(e,n,t){var i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0});var r=t(2),o=i(t(4)),s=i(t(1)),u=i(t(0)),a=function(){function e(e){if(void 0===e||0===e.length)throw new s.default("There collection of ranges should have at least one range defined");this.ranges=e;}return e.prototype.getRanges=function(){return this.ranges},e.prototype.contains=function(e){var n,t=!1;try{n=new o.default(e);}catch(n){throw new s.default('The value "'+e+'" is not a valid input')}if(void 0===n)throw new s.default("A valid value is required to check if the range contains it");if(r.exceedsMaximumPrecision(n))throw new u.default(r.EXCEEDED_PRECISION_MESSAGE);for(var i=0;i<this.ranges.length;i++)if(this.ranges[i].contains(n)){t=!0;break}var a={contains:t};return t||(a.adjacentValues=this.calculateNearestValues(n)),a},e.prototype.calculateNearestValues=function(e){for(var n={},t=0,i=this.ranges;t<i.length;t++){var r=i[t].calculateNearestValues(e);r.lowerAdjValue&&(n.lowerAdjValue&&!r.lowerAdjValue.greaterThan(n.lowerAdjValue)||(n.lowerAdjValue=r.lowerAdjValue)),r.upperAdjValue&&(n.upperAdjValue&&!r.upperAdjValue.lessThan(n.upperAdjValue)||(n.upperAdjValue=r.upperAdjValue));}return n},e.prototype.toString=function(){return this.ranges.toString()},e}();n.default=a;},function(e,n,t){var i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.InvalidInputError=n.DecimalPrecisionError=n.MalformedRangeError=n.RangeConverter=n.Ranges=n.Range=void 0;var r=i(t(2));n.Range=r.default;var o=i(t(5));n.Ranges=o.default;var s=i(t(7));n.RangeConverter=s.default;var u=i(t(0));n.DecimalPrecisionError=u.default;var a=i(t(3));n.MalformedRangeError=a.default;var c=i(t(1));n.InvalidInputError=c.default;},function(e,n,t){var i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0});var r=i(t(5)),o=i(t(2)),s=i(t(0)),u=i(t(1)),a=i(t(3)),c=function(){function e(){}return e.toRanges=function(n){var t=[];try{n.forEach((function(n){t.push(e.toRange(n));}));}catch(e){if(e instanceof u.default||e instanceof s.default||e instanceof a.default)throw e;throw new u.default("The input cannot be converted to Ranges")}return new r.default(t)},e.toRange=function(e){return new o.default(e.minimum,e.maximum,e.increment)},e}();n.default=c;}])}));
	
} (numericRanges));

var numericRangesExports = numericRanges.exports;

const validateRangeInput = (valueToBeValidated, option, showFormErrors) => {
    if (!valueToBeValidated) {
        if (option.isRequired && showFormErrors) {
            return {
                code: RangedAttributeValidationCode.EMPTY_INPUT,
            };
        }
        return {
            code: RangedAttributeValidationCode.SUCCESS,
        };
    }
    const rangeInformation = new numericRangesExports.Ranges(getRanges(option));
    try {
        const { contains, adjacentValues } = rangeInformation.contains(valueToBeValidated);
        if (!contains) {
            return {
                code: RangedAttributeValidationCode.NOT_IN_RANGE,
                additionalInformation: {
                    adjacentValues,
                },
            };
        }
        else {
            return {
                code: RangedAttributeValidationCode.SUCCESS,
            };
        }
    }
    catch (ex) {
        if (ex instanceof Error) {
            if (ex.message.includes("decimal")) {
                return {
                    code: RangedAttributeValidationCode.UNSUPPORTED_PRECISION,
                };
            }
            else if (ex.message.includes("not a valid input")) {
                return {
                    code: RangedAttributeValidationCode.NOT_A_NUMBER,
                };
            }
        }
        console.error(ex);
        return {
            code: RangedAttributeValidationCode.UNKNOWN_ERROR,
        };
    }
};
const getRanges = (option) => {
    const ranges = [];
    option.choices.map((choice) => {
        if (choice.minimum !== undefined) {
            const rangeChoice = choice;
            ranges.push(new numericRangesExports.Range(rangeChoice.minimum, rangeChoice.maximum, rangeChoice.increment));
        }
        else {
            const listChoice = choice;
            const key = listChoice.key;
            const keyAsNumber = parseFloat(key);
            if (isNaN(keyAsNumber)) {
                console.error(`Choice ${key} cannot be converted to range`);
                return;
            }
            // Create a range that has the same minimal and maximum to represent discrete values
            ranges.push(new numericRangesExports.Range(keyAsNumber, keyAsNumber, 1));
        }
    });
    return ranges;
};
const buildRangesType = (ranges) => {
    return numericRangesExports.RangeConverter.toRanges(ranges);
};

const getHelperText = (i18n, i18nUnsafe, rangeInformation, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    const maximum = getMaximumValue(rangeInformation);
    const minimum = getMinimumValue(rangeInformation);
    const fullHelperText = isBooklets
        ? i18nUnsafe("fullRangedHelperTextForBooklets")
        : i18n("fullRangedHelperText");
    const partialHelperText = isBooklets
        ? i18nUnsafe("rangePartialRangedHelperTextForBooklets")
        : i18n("rangePartialRangedHelperText");
    const tokenEngine = new TokenEngine();
    let helperText;
    if (fullHelperText && maximum.isFinite()) {
        helperText = tokenEngine.replace(fullHelperText, {
            MINIMUM: minimum,
            UNIT: unitOfMeasure,
            MAXIMUM: maximum,
        });
    }
    else if (partialHelperText) {
        helperText = tokenEngine.replace(partialHelperText, {
            MINIMUM: minimum,
            UNIT: unitOfMeasure,
        });
    }
    return { helperText };
};
const getValidationMessage = (props) => {
    const { isConstrained, validationCode, additionalInformation, rangeInformation, unitOfMeasure, i18n, i18nUnsafe, } = props;
    if (isConstrained) {
        const outOfStock = i18n("outOfStockCallout");
        return outOfStock;
    }
    switch (validationCode) {
        case RangedAttributeValidationCode.EMPTY_INPUT: {
            return getValidationMessageForRequiredField(i18n, i18nUnsafe, getMinimumValue(rangeInformation), getMaximumValue(rangeInformation), unitOfMeasure);
        }
        case RangedAttributeValidationCode.SUCCESS: {
            return "";
        }
        case RangedAttributeValidationCode.NOT_IN_RANGE: {
            return getValidationMessageWithNearestNumber(i18n, i18nUnsafe, additionalInformation?.adjacentValues, unitOfMeasure);
        }
        case RangedAttributeValidationCode.UNSUPPORTED_PRECISION: {
            return i18n("rangedDecimalPrecisionError");
        }
        case RangedAttributeValidationCode.NOT_A_NUMBER: {
            return i18n("rangedNotANumberError");
        }
        case RangedAttributeValidationCode.UNKNOWN_ERROR:
        default: {
            return i18n("rangedGeneralInputError");
        }
    }
};
const getValidationMessageForRequiredField = (i18n, i18nUnsafe, minimum, maximum, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    const requiredAttributeFieldError = isBooklets
        ? i18nUnsafe("requiredAttributeFieldErrorForBooklets")
        : i18n("requiredAttributeFieldError");
    const tokenEngine = new TokenEngine();
    const message = tokenEngine.replace(requiredAttributeFieldError ?? "", {
        LOWER: minimum,
        UNIT: unitOfMeasure,
        HIGHER: maximum,
    });
    return message;
};
const getValidationMessageWithNearestNumber = (i18n, i18nUnsafe, adjacentValues, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    if (!adjacentValues || (!adjacentValues.lowerAdjValue && !adjacentValues.upperAdjValue)) {
        const validationEntry = i18n("rangedGeneralInputError");
        return validationEntry;
    }
    const { lowerAdjValue, upperAdjValue } = adjacentValues;
    const tokenEngine = new TokenEngine();
    let message;
    let entry;
    if (lowerAdjValue && !upperAdjValue) {
        entry = isBooklets
            ? i18nUnsafe("rangedMaxInputValueErrorForBooklets")
            : i18n("rangedMaxInputValueError");
        message = tokenEngine.replace(entry ?? "", {
            MAXIMUM: lowerAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    else if (!lowerAdjValue && upperAdjValue) {
        entry = isBooklets
            ? i18nUnsafe("rangedMinInputValueErrorForBooklets")
            : i18n("rangedMinInputValueError");
        message = tokenEngine.replace(entry ?? "", {
            MINIMUM: upperAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    else {
        entry = isBooklets
            ? i18nUnsafe("rangedBetweenRangesErrorForBooklets")
            : i18n("rangedBetweenRangesError");
        message = tokenEngine.replace(entry ?? "", {
            LOWER: lowerAdjValue,
            HIGHER: upperAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    return message;
};
const getMaximumValue = (rangeInformation) => {
    return rangeInformation
        .getRanges()
        .reduce((currentMax, currentRange) => currentMax.getMaximum().greaterThan(currentRange.getMaximum()) ? currentMax : currentRange)
        .getMaximum();
};
const getMinimumValue = (rangeInformation) => {
    return rangeInformation
        .getRanges()
        .reduce((currentMin, currentRange) => currentMin.getMinimum().lessThan(currentRange.getMinimum()) ? currentMin : currentRange)
        .getMinimum();
};
const isBookletsUnits = (unitOfMeasure) => {
    return unitOfMeasure?.toLowerCase() === "pages";
};

const useTextboxOptions = (unitOfMeasure, isDisabled, onChanged) => {
    const { showFormErrors, productOption } = useProductOptionContext();
    const [currentInput, setCurrentInput] = useState(productOption.selectedKey ?? null);
    const [showTypeFormErrors, setShowTypeFormErrors] = useState(!!showFormErrors);
    const { i18n, i18nUnsafe } = useProductOptionsTranslations();
    const rangeInformation = buildRangesType(productOption.choices);
    const { helperText } = getHelperText(i18n, i18nUnsafe, rangeInformation, unitOfMeasure);
    const [textboxMessage, setTextBoxMessage] = useState({ message: undefined, isValid: true });
    useEffect(() => {
        const validationResult = validateRangeInput(currentInput, productOption, showTypeFormErrors);
        const newValidationMessage = getValidationMessage({
            isConstrained: isDisabled,
            validationCode: validationResult.code,
            additionalInformation: validationResult.additionalInformation,
            rangeInformation,
            unitOfMeasure,
            i18n,
            i18nUnsafe,
        });
        if (currentInput !== productOption.selectedKey && (productOption.selectedKey || currentInput)) {
            onChanged({
                choiceKey: validationResult.code === RangedAttributeValidationCode.SUCCESS ? currentInput : null,
                choiceKeyWithInvalids: currentInput ?? undefined,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
                code: validationResult.code,
                additionalInformation: validationResult.additionalInformation,
            });
        }
        if (newValidationMessage) {
            setTextBoxMessage({
                message: newValidationMessage,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
            });
        }
        else {
            setTextBoxMessage({
                message: helperText,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
            });
        }
    }, [showTypeFormErrors, currentInput]);
    const handleProductChoiceChangedEvent = useCallback((event) => {
        const { choiceKey } = event;
        setCurrentInput(choiceKey);
        setShowTypeFormErrors(true);
    }, []);
    return { handleProductChoiceChangedEvent, textboxMessage };
};

const TextboxOptions = (props) => {
    const { onChanged, skin, option, isDisabled } = props;
    const { handleProductChoiceChangedEvent, textboxMessage } = useTextboxOptions(option.unitOfMeasure ?? "", isDisabled, onChanged);
    const TextboxComponent = getTextboxComponentBySkin(skin ?? "standard");
    const textboxProps = {
        ...props,
        message: {
            type: textboxMessage?.isValid ? "info" : "error",
            text: textboxMessage?.message,
        },
        onChanged: (event) => {
            handleProductChoiceChangedEvent(event);
        },
    };
    return React__default.createElement(TextboxComponent, { ...textboxProps });
};

dt.div `
      margin-bottom: var(--swan-spacing-standard-4);
      
      .swan-selection-set {
          gap: 16px;
          container-type: inline-size;
          container-name: productOption;
      }
`;
const WideQuantityListSkin = ({ option, locale, currency, fractionDigits, onChanged, onShowAllQuantities, showIncompatibleChoices, savingsFormat, priceDisplayMode, hasSampleQuantity, }) => {
    const [showAllQuantities, setShowAllQuantities] = useState(false);
    const titleId = useId();
    const [selectedQuantity, setSelectedQuantity] = useState(option.selectedKey);
    const { i18n } = useProductOptionsTranslations();
    useEffect(() => {
        // By storing the selection in state and updating it whe the prop changes, we
        // fix an a11y issue that prevents the radiogroup from being navigable with arrow
        // keys, but also keeps the current selection in perfect sync with the keyboard focus.
        setSelectedQuantity(option.selectedKey);
    }, [option.selectedKey]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValue, event) => {
        onChanged({ choiceKey: selectedValue });
    };
    const defaultNumOptionsShown = 5;
    const allQuantitiesHaveShown = option.choices.length <= defaultNumOptionsShown;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", selectedValue: selectedQuantity, onSelectedValueChange: onChangeHandler, "aria-labelledby": titleId }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice, index) => {
            const isSampleQuantity = hasSampleQuantity && index === 0;
            const quantitySavingsIsVisible = !isSampleQuantity && savingsFormat && savingsFormat !== "hidden";
            const onSale = (choice.totalDiscountedPrice ?? 0) < (choice.totalListPrice ?? 0);
            if (showAllQuantities ||
                index <= defaultNumOptionsShown - 1 ||
                option.selectedKey === choice.key) {
                return (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: !choice.isCompatible, id: option.key + choice.key },
                    React__default.createElement(SelectionSetLabel, { style: { wordBreak: "initial" } },
                        React__default.createElement(QuantityItem, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, isSampleQuantity: isSampleQuantity, quantitySavingsIsVisible: quantitySavingsIsVisible, onSale: onSale, savingsFormat: savingsFormat }))));
            }
        })),
        !showAllQuantities && !allQuantitiesHaveShown && (React__default.createElement(FlexBox, { justifyContent: "center" },
            React__default.createElement(Link, { render: (p) => (React__default.createElement(Button, { skin: "link", className: p.className, onClick: () => {
                        if (onShowAllQuantities) {
                            onShowAllQuantities();
                        }
                        setShowAllQuantities(true);
                    } }, p.children)) }, i18n("seeMoreQuantities"))))));
};

function getQuantityListComponentBySkin(skin) {
    switch (skin) {
        case "wide":
            return WideQuantityListSkin;
        default:
            return WideQuantityListSkin;
    }
}

const QuantityListOptions = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (event) => {
        props.onChanged(event);
    };
    const { uiDensityQuantityUpdate } = useProductOptionContext();
    if (uiDensityQuantityUpdate && props.option.choices.length > 12) {
        return React__default.createElement(QuantityDropdown, { ...props });
    }
    const QuantityListComponent = getQuantityListComponentBySkin(props.skin ?? "wide");
    const quantityListProps = {
        ...props,
        onChanged: onChangeHandler,
    };
    return React__default.createElement(QuantityListComponent, { ...quantityListProps });
};

/**
 * The TileCallouts component renders a list of callouts for a selection set tile.
 * It is the same callout component that is used in the "buttons" style of option selector,
 * copied over so that those components can be more easily retired in the future.
 */
const TileCallouts = ({ callouts }) => {
    return (React__default.createElement(React__default.Fragment, null, callouts?.map((callout) => {
        return (React__default.createElement(Callout, { key: callout.key, skin: callout.style ?? "accent", emphasis: "low" }, callout.text));
    })));
};

/**
 * The TileImageThumbnail component renders an image for a selection set tile.
 * It has the same content as the image thumbnail component that is used in the "buttons" style of option selector,
 * copied over so that those components can be more easily retired in the future.
 */
const TileImageThumbnail = ({ choice }) => {
    if (!choice.image) {
        return null;
    }
    return (React__default.createElement(SelectionSetTileImageContainer, { style: { height: "unset" } },
        React__default.createElement(FluidImage, { alt: "", src: choice.image })));
};

/**
 * The MarkdownTileDescription component renders a markdown description for a selection set tile.
 * It has the same content as the description compoonent that is used in the "buttons" style of option selector,
 * copied over so that those components can be more easily retired in the future.
 */
const MarkdownTileDescription = ({ descriptionMarkdown }) => {
    return (React__default.createElement(React__default.Fragment, null, descriptionMarkdown && (React__default.createElement(SelectionSetTileDescription$1, null,
        React__default.createElement(OptionMarkdownText, { markdownText: descriptionMarkdown })))));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ConfiguratorPricesContext = createContext(undefined);
React__default.memo(function (_a) {
    var productKey = _a.productKey, productVersion = _a.productVersion, culture = _a.culture, market = _a.market, selections = _a.selections, completedSelections = _a.completedSelections, children = _a.children;
    // No client-side state, so SSR is supported by default
    // Memoize the context value to prevent unnecessary re-renders
    var value = useMemo(function () { return ({ productKey: productKey, productVersion: productVersion, culture: culture, selections: selections, market: market, completedSelections: completedSelections }); }, [
        productKey,
        productVersion,
        culture,
        market,
        // Deep compare selections and completedSelections
        JSON.stringify(selections || {}),
        JSON.stringify(completedSelections || {}),
    ]);
    return React__default.createElement(ConfiguratorPricesContext.Provider, { value: value }, children);
}, function (prevProps, nextProps) {
    // Custom comparison function for React.memo
    return (prevProps.productKey === nextProps.productKey &&
        prevProps.productVersion === nextProps.productVersion &&
        prevProps.culture === nextProps.culture &&
        prevProps.market === nextProps.market &&
        JSON.stringify(prevProps.selections || {}) === JSON.stringify(nextProps.selections || {}) &&
        JSON.stringify(prevProps.completedSelections || {}) === JSON.stringify(nextProps.completedSelections || {}));
});
var useConfiguratorPrices = function () {
    var context = useContext(ConfiguratorPricesContext);
    if (!context) {
        throw new Error('useConfiguratorPrices must be used within a ConfiguratorPricesProvider');
    }
    return context;
};

var VISTAPRINT_ACCOUNT_ID = 'ozoDdrmewShEcbUDWX8J3V';
var REQUESTOR = '@vp/configurator-prices';
var MERCHANT = 'Vistaprint';

function addObjectToSearchParams(prefix, obj, searchParams) {
    for (var _i = 0, _a = Object.entries(obj).sort(function (_a, _b) {
        var keyA = _a[0];
        var keyB = _b[0];
        return keyA.localeCompare(keyB);
    }); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value !== undefined && value !== null) {
            searchParams.append("".concat(prefix, "[").concat(key, "]"), value);
        }
    }
}

/**
 * Fetch with retry and exponential backoff strategy.
 *
 * @param url - The URL to fetch.
 * @param options - Fetch options.
 * @param retries - Number of retry attempts.
 * @param backoff - Initial backoff delay in milliseconds.
 * @returns The fetch response.
 */
var fetchWithRetry = function (url_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([url_1], args_1, true), void 0, function (url, options, retries, backoff) {
        var _loop_1, attempt, state_1;
        if (options === void 0) { options = {}; }
        if (retries === void 0) { retries = 5; }
        if (backoff === void 0) { backoff = 500; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _loop_1 = function (attempt) {
                        var response, error_1, delay_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 6]);
                                    return [4 /*yield*/, fetch(url, options)];
                                case 1:
                                    response = _b.sent();
                                    if (response.ok) {
                                        return [2 /*return*/, { value: response }];
                                    }
                                    // Don't retry on 4xx client errors
                                    if (response.status >= 400 && response.status < 500) {
                                        throw new Error("HTTP client 4XX! status: ".concat(response.status));
                                    }
                                    throw new Error("HTTP error! status: ".concat(response.status));
                                case 2:
                                    error_1 = _b.sent();
                                    // Don't retry if it's a client error (4xx)
                                    if (error_1 instanceof Error && error_1.message.includes('HTTP client 4XX')) {
                                        throw error_1;
                                    }
                                    if (!(attempt < retries)) return [3 /*break*/, 4];
                                    delay_1 = backoff * Math.pow(2, attempt);
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, delay_1); })];
                                case 3:
                                    _b.sent();
                                    return [3 /*break*/, 5];
                                case 4: throw error_1;
                                case 5: return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    };
                    attempt = 0;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= retries)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(attempt)];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    attempt++;
                    return [3 /*break*/, 1];
                case 4: throw new Error('Failed to fetch after retries');
            }
        });
    });
};

var cache = new Map();
function getCacheExpiry(headers) {
    var cacheControl = headers.get('cache-control');
    if (cacheControl) {
        var maxAgeMatch = cacheControl.match(/max-age=(\d+)/);
        if (maxAgeMatch) {
            var maxAge = parseInt(maxAgeMatch[1], 10);
            return Date.now() + maxAge * 1000;
        }
        if (/no-cache|no-store/.test(cacheControl)) {
            return null;
        }
    }
    var expires = headers.get('expires');
    if (expires) {
        var expiresAt = new Date(expires).getTime();
        if (!isNaN(expiresAt)) {
            return expiresAt;
        }
    }
    return null;
}
function cachedFetchWithRetry(input, init) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheKey, cached, response, cloned, body, headers, status, statusText, expiresAt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cacheKey = input.toString();
                    cached = cache.get(cacheKey);
                    if (cached && cached.expiresAt > Date.now()) {
                        // Return a cloned Response to avoid body stream issues
                        return [2 /*return*/, new Response(cached.value.body, cached.value)];
                    }
                    return [4 /*yield*/, fetchWithRetry(input, init)];
                case 1:
                    response = _a.sent();
                    cloned = response.clone();
                    return [4 /*yield*/, cloned.arrayBuffer()];
                case 2:
                    body = _a.sent();
                    headers = new Headers(cloned.headers);
                    status = cloned.status;
                    statusText = cloned.statusText;
                    expiresAt = getCacheExpiry(headers);
                    if (expiresAt && status === 200) {
                        cache.set(cacheKey, {
                            value: { body: body, headers: headers, status: status, statusText: statusText },
                            expiresAt: expiresAt,
                        });
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}

function fetchV7Price(req) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = buildRequestUrl(req);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, cachedFetchWithRetry(url, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Failed to fetch pricing: ".concat(url.toString()));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    return [2 /*return*/, data];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error fetching differential pricing:', error_1);
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function buildRequestUrl(req) {
    var productKey = req.productKey, productVersion = req.productVersion, completedSelections = req.selections;
    var url = new URL('https://website-pricing-service.prices.cimpress.io/v7/prices');
    url.searchParams.set('accountId', VISTAPRINT_ACCOUNT_ID);
    url.searchParams.set('productId', productKey);
    url.searchParams.set('productVersion', (productVersion === null || productVersion === void 0 ? void 0 : productVersion.toString()) || '');
    url.searchParams.set('requestor', REQUESTOR);
    addObjectToSearchParams('selections', completedSelections, url.searchParams);
    addObjectToSearchParams('context', {
        Merchant: MERCHANT,
        Country: req.country,
    }, url.searchParams);
    if (req.pivotSelections) {
        Object.entries(req.pivotSelections).forEach(function (_a) {
            var option = _a[0], values = _a[1];
            url.searchParams.set("pivotSelections[".concat(option, "]"), values.join(','));
        });
    }
    return url;
}

/**
 * Does a simple subtraction of the current price from the target price.
 * This is used to calculate the differential price between two V7ItemTotals.
 * Rounding errors are not an issue here as there is no multiplication or division involved.
 */
var calculateDifference = function (currentPrice, targetPrice) {
    return {
        total: currentPrice.total,
        unit: currentPrice.unit,
        differential: calculateDifferencePriceBreakdown(currentPrice.total, targetPrice.total),
        differentialUnit: calculateDifferencePriceBreakdown(currentPrice.unit, targetPrice.unit),
    };
};
var calculateDifferencePriceBreakdown = function (currentBreakdown, targetBreakdown) {
    return {
        listTaxed: targetBreakdown.listTaxed - currentBreakdown.listTaxed,
        listUntaxed: targetBreakdown.listUntaxed - currentBreakdown.listUntaxed,
        discountedTaxed: targetBreakdown.discountedTaxed - currentBreakdown.discountedTaxed,
        discountedUntaxed: targetBreakdown.discountedUntaxed - currentBreakdown.discountedUntaxed,
    };
};

var convertPriceBreakdownToDecimal = function (priceBreakdown, factor) {
    return {
        listTaxed: priceBreakdown.listTaxed / factor,
        listUntaxed: priceBreakdown.listUntaxed / factor,
        discountedTaxed: priceBreakdown.discountedTaxed / factor,
        discountedUntaxed: priceBreakdown.discountedUntaxed / factor,
    };
};
var convertV7ItemTotalsToDecimal = function (itemTotals, fractionDigits) {
    var factor = Math.pow(10, fractionDigits);
    return {
        total: convertPriceBreakdownToDecimal(itemTotals.total, factor),
        unit: convertPriceBreakdownToDecimal(itemTotals.unit, factor),
        differential: itemTotals.differential ? convertPriceBreakdownToDecimal(itemTotals.differential, factor) : undefined,
        differentialUnit: itemTotals.differentialUnit ? convertPriceBreakdownToDecimal(itemTotals.differentialUnit, factor) : undefined,
    };
};

/**
 * This function deserves an explanation.  Prices API offers 'pivot' so why not use it? It's actually not that simple.
 * The pivot option when you only have a few selections makes some assumptions that are not true for all configurators.
 * For example, a product with options `A, B` and option values of `A1, A2, B1, B2, B3`
 * Lets assume the number associated with the letter is the price for that specific option.
 *
 * Normal issues:
 *   If A1 is currently selected, and B1 is implicitly selected (in other words it'd be completed to by RANCH) than our starting state is A1B1 and the price is 2.
 *   So what is the Price differential for A2? Now if no restrictions exist, A2B1 is the output and the price is 3.
 *
 *   Now introduce a pasta restriction on the A2 B1 combination, that means Pricing will pivot to A2B2, which is 4.
 *   This is still valid and would work for options.
 *
 *   Now lets add another restriction, there is a document compatibility restriction selecting A2B2, which means the price should now be 5.
 *   Pricing will pivot to A2B2 as it doesn't know anything about document compatibility.
 *
 * Special Uses:
 *   Beyond the issues with using only the pivot, there are special cases where a pivot is not sufficient, specifically if the desire is to do a multi-option differential price.
 *   For example, if the current selections are A1B1 and the target is A2B2, the pivot will not work as it will only return the price for A2B1.
 *   In this case, we need to fetch both prices and calculate the differential ourselves. This is the case if we are 'unwinding' the user selection.
 *   This would be the case for a product where A1B1, A2B2, A2B3 are the only valid SKUS on the product.
 */
var fetchStartingAndEndingPricesAndCalculateDifferential = function (market, productKey, productVersion, currentCompletedSelections, targetCompletedSelections) { return __awaiter(void 0, void 0, void 0, function () {
    var currentPricePromise, targetPricePromise, _a, currentPrice, targetPrice, itemTotalsDifference, itemTotals;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                currentPricePromise = fetchV7Price({
                    country: market,
                    productKey: productKey,
                    productVersion: productVersion,
                    selections: currentCompletedSelections,
                });
                targetPricePromise = fetchV7Price({
                    country: market,
                    productKey: productKey,
                    productVersion: productVersion,
                    selections: targetCompletedSelections,
                });
                return [4 /*yield*/, Promise.all([currentPricePromise, targetPricePromise])];
            case 1:
                _a = _b.sent(), currentPrice = _a[0], targetPrice = _a[1];
                itemTotalsDifference = calculateDifference(currentPrice.prices[0].itemTotals, targetPrice.prices[0].itemTotals);
                itemTotals = convertV7ItemTotalsToDecimal(itemTotalsDifference, currentPrice.fractionDigits);
                return [2 /*return*/, {
                        itemTotals: itemTotals,
                        currency: currentPrice.currency,
                        fractionDigits: currentPrice.fractionDigits,
                    }];
        }
    });
}); };

var useDifferentialPrice = function (option, optionValue, targetCompletedSelections) {
    var _a = useConfiguratorPrices(), selections = _a.selections, market = _a.market, productKey = _a.productKey, productVersion = _a.productVersion, currentCompletedSelections = _a.completedSelections;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(), prices = _c[0], setPrices = _c[1];
    var _d = useState(), currency = _d[0], setCurrency = _d[1];
    var _e = useState(), minimumFractionDigits = _e[0], setMinimumFractionDigits = _e[1];
    useEffect(function () {
        var completedSelectionsAreIdentical = currentCompletedSelections &&
            targetCompletedSelections &&
            Object.keys(currentCompletedSelections).length === Object.keys(targetCompletedSelections).length &&
            Object.entries(currentCompletedSelections).every(function (_a) {
                var key = _a[0], value = _a[1];
                return targetCompletedSelections[key] === value;
            });
        var setEmptyPrices = function () {
            setPrices(undefined);
            setCurrency(undefined);
            setMinimumFractionDigits(undefined);
            setIsLoading(false);
        };
        var calculateDifferentialPrices = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pricesResult, result, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        setIsLoading(true);
                        if (completedSelectionsAreIdentical) {
                            // If all selections are identical then no differential price exists
                            setEmptyPrices();
                            return [2 /*return*/];
                        }
                        if (!(currentCompletedSelections &&
                            targetCompletedSelections &&
                            // Quantity is required for differential pricing by SKU
                            currentCompletedSelections['Quantity'] &&
                            targetCompletedSelections['Quantity'])) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchStartingAndEndingPricesAndCalculateDifferential(market, productKey, productVersion, currentCompletedSelections, targetCompletedSelections)];
                    case 1:
                        pricesResult = _b.sent();
                        setPrices(pricesResult.itemTotals);
                        setCurrency(pricesResult.currency);
                        setMinimumFractionDigits(pricesResult.fractionDigits);
                        setIsLoading(false);
                        return [2 /*return*/];
                    case 2:
                        if (!((selections === null || selections === void 0 ? void 0 : selections['Quantity']) || option === 'Quantity')) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetchV7Price({
                                country: market,
                                productKey: productKey,
                                productVersion: productVersion,
                                selections: selections,
                                pivotSelections: (_a = {}, _a[option] = [optionValue], _a),
                            })];
                    case 3:
                        result = _b.sent();
                        if (result.prices.length > 0 && result.prices[0].itemTotals) {
                            setPrices(convertV7ItemTotalsToDecimal(result.prices[0].itemTotals, result.fractionDigits));
                            setCurrency(result.currency);
                            setMinimumFractionDigits(result.fractionDigits);
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                    case 4:
                        // No method of determining differential pricing matched.
                        setEmptyPrices();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        // Handle error gracefully - default to not showing prices
                        console.error('Error checking if prices should be shown:', error_1);
                        setEmptyPrices();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        calculateDifferentialPrices();
    }, [selections, market, productKey, productVersion, option, optionValue]);
    return {
        isLoading: isLoading,
        prices: prices,
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
    };
};

/**
 * Taken directly from the PricePlatform component.
 * https://gitlab.com/vistaprint-org/large-assortment/chanakya/modules/price-platform/-/blob/main/src/components/PriceLoading.tsx?ref_type=heads
 * This is duplicated initialy only for flexibility to adjust the behavior as initial release iterates with UX.
 */
var PriceLoading = function () {
    return (React__default.createElement(SkeletonText, { "aria-label": "loading" },
        React__default.createElement(SkeletonTextLine, { width: "narrow" })));
};

var SecondaryPlusOrMinusFullPrices = function (_a) {
    var differentialListPrice = _a.differentialListPrice, differentialDiscountPrice = _a.differentialDiscountPrice, locale = _a.locale, currency = _a.currency, fractionDigits = _a.fractionDigits, pricePlaceholder = _a.pricePlaceholder;
    var discountedPrice = differentialDiscountPrice !== null && differentialDiscountPrice !== void 0 ? differentialDiscountPrice : differentialListPrice;
    // If we want to prevent the "Base Price" text from appearing, and the list price is zero but the discounted price is not,
    // then we can take advantage of a feature of PlusOrMinusPerUnit where it hides the "Base Price" cross out, just showing the
    // discount. But in that case it also hides the "/ea" label.
    var PricingComponent = differentialListPrice === 0 && discountedPrice !== 0 ? PlusOrMinusPerUnit : PlusOrMinus;
    return (React__default.createElement(PricingComponent, { placeHolderText: pricePlaceholder, pricingInfo: {
            currency: currency,
            minimumFractionDigits: fractionDigits,
            culture: locale,
            priceDifference: differentialListPrice !== null && differentialListPrice !== void 0 ? differentialListPrice : 0, // should this be default to 0
            priceDifferenceDiscounted: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : 0, // should this be default to 0
        } }));
};

var OptionPrice = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var option = _a.option, optionValue = _a.optionValue, completedSelections = _a.completedSelections;
    var _h = useConfiguratorPrices(), culture = _h.culture, selections = _h.selections;
    var _j = useDifferentialPrice(option, optionValue, completedSelections), isLoading = _j.isLoading, prices = _j.prices, currency = _j.currency, minimumFractionDigits = _j.minimumFractionDigits;
    var selectedOption = selections[option];
    var currentSelectionAlreadySelected = selectedOption === optionValue;
    if (isLoading) {
        return React__default.createElement(PriceLoading, null);
    }
    if (!prices || !culture || !currency || !minimumFractionDigits || (!((_b = prices.differential) === null || _b === void 0 ? void 0 : _b.listTaxed) && !((_c = prices.differential) === null || _c === void 0 ? void 0 : _c.discountedTaxed))) {
        // Rendering has failed or no prices are available
        // useOptionValuePrices logs the error, so just fallback to empty here to keep the UI clean
        return React__default.createElement("span", null, "\u00A0");
    }
    if (currentSelectionAlreadySelected) {
        // If the current selections contain the current optionValue render empty as no price exists
        return React__default.createElement("span", null, "\u00A0");
    }
    return (React__default.createElement(SecondaryPlusOrMinusFullPrices, { differentialListPrice: (_e = (_d = prices.differential) === null || _d === void 0 ? void 0 : _d.listTaxed) !== null && _e !== void 0 ? _e : 0, differentialDiscountPrice: (_g = (_f = prices.differential) === null || _f === void 0 ? void 0 : _f.discountedTaxed) !== null && _g !== void 0 ? _g : 0, locale: culture, currency: currency, fractionDigits: minimumFractionDigits, pricePlaceholder: '...' }));
};

const Tiles = dt.div `
.swan-selection-set.swan-selection-set-skin-tiles-horizontal, 
.swan-selection-set.swan-selection-set-skin-tiles-mini,
.swan-selection-set.swan-selection-set-skin-tiles-vertical {
    --grid-gap: var(--swan-sem-space-4);
    gap: var(--grid-gap);
    container-type: inline-size;
    container-name: productOption;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile .swan-selection-set-label {
    margin: 0 !important;
    min-width: unset !important;
    max-width: unset !important;
    width: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile .swan-selection-set-label {
  height: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile {
  --grid-columns: 1;
  --column-gaps: 0px;
  flex: 0 1 calc((100% - var(--column-gaps)) / var(--grid-columns));
}

@container productOption (min-width: 260px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile {
    --grid-columns: 2;
    --column-gaps: var(--grid-gap);
  }
}

@container productOption (min-width: 425px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile {
    --grid-columns: 3;
    --column-gaps: calc(var(--grid-gap) * 2);
  }
}

@container productOption (min-width: 600px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .po-tile {
    --grid-columns: 4;
    --column-gaps: calc(var(--grid-gap) * 3);
    max-width: 170px
  }
}

.po-tile-no-image {
  min-height: 90px;
  .po-tile-contents {
    display: flex;
    flex-direction: column;
    height: 100%;
    .po-tile-name {
      margin-top: auto !important;
    }
    .po-tile-price {
      margin-top: 0 !important;
    }
  }
}


.incompatible-option {
  border-width: 2px !important;
  background-color: var(--swan-sem-color-bg-strong) !important;
  border-style: dashed !important;
  border-color:  (--swan-sem-color-border-strong) !important;
}

.incompatible-option:hover {
  border-color: var(--swan-sem-color-border-strong-active) !important;
  background-color: var(--swan-sem-color-bg-strong-active) !important;
}
`;
/**
 * The StandardTileSkin component is a modified version of the tight button already existing in this library
 * Key differences:
 *  - Includes a tile state for an enabled tile that is incompatible with the current selection
 *  - Styling updates for non-image tiles
 *  - Pricing not included in this version (placeholder only)
 */
const StandardTileSkin = ({ option, showIncompatibleChoices, hideImages, onChanged, }) => {
    /**
     * Converts the 'onChange' of a multi-select listbox to an onChange of a radioGroup
     * @param selectedValues the object of key:boolean pairs of selected options
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValues, event) => {
        if (option.selectedKey) {
            delete selectedValues[option.selectedKey];
        }
        for (const [key, value] of Object.entries(selectedValues)) {
            if (value && key !== option.selectedKey) {
                // Only emit an choiceKey if there's a value picked,
                // otherwise do nothing. A user can't unselect an option
                onChanged({ choiceKey: key });
                break;
            }
        }
    };
    const titleId = useId();
    const selectedValues = {};
    for (const choice of option.choices) {
        selectedValues[choice.key] = choice.key === option.selectedKey;
    }
    return (React__default.createElement(Tiles, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "multi-select", skin: "tiles-vertical", selectedValues: selectedValues, onSelectedValuesChange: onChangeHandler, "aria-labelledby": titleId, role: "radiogroup", "aria-required": option.isRequired ? "true" : undefined }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice) => {
            const isOptionDisabled = (!choice.isCompatible && !choice.violations?.length) || choice.isOutOfStock;
            const isClickableIncompatibleOption = !choice.isCompatible && choice.violations?.length && !isOptionDisabled;
            return (React__default.createElement("div", { className: hideImages ? "po-tile po-tile-no-image" : "po-tile", key: `choice_${choice.key}` },
                React__default.createElement(SelectionSetInput, { value: choice.key, disabled: isOptionDisabled },
                    React__default.createElement(SelectionSetLabel, { style: {
                            minHeight: hideImages ? "unset" : "inherit",
                        }, className: isClickableIncompatibleOption ? "incompatible-option" : "" },
                        !hideImages && React__default.createElement(TileImageThumbnail, { choice: choice }),
                        React__default.createElement(TileCallouts, { callouts: choice.callouts }),
                        React__default.createElement(SelectionSetTileContents, { className: "po-tile-contents" },
                            React__default.createElement(SelectionSetTileName, { className: "po-tile-name", "aria-label": isClickableIncompatibleOption
                                    ? `${choice.name}. ${choice.name} is incompatible with your current selections.`
                                    : `${choice.name}` }, choice.name),
                            choice.description && (React__default.createElement(MarkdownTileDescription, { descriptionMarkdown: choice.description })),
                            React__default.createElement(SelectionSetTilePrice, { className: "po-tile-price" },
                                React__default.createElement(OptionPrice, { option: option.key, optionValue: choice.key, completedSelections: choice.selections })))))));
        }))));
};

function getTileComponentBySkin(skin) {
    switch (skin) {
        case "standard":
        default:
            return StandardTileSkin;
    }
}

const TileOptions = (props) => {
    const onChangeHandler = (event) => {
        props.onChanged(event);
    };
    const TileComponent = getTileComponentBySkin(props.skin ?? "standard");
    const tileProps = { ...props, onChanged: onChangeHandler };
    return React__default.createElement(TileComponent, { ...tileProps });
};

// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}
function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = React.useState(null);
  const callback = React.useRef(onChange);
  const [state, setState] = React.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  React.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = React.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

const ProductOptionInner = ({ tenant, currency, fractionDigits, locale, showIncompatibleChoices = false, onChanged, onShowAllQuantities, hasSampleQuantity, uiDensityQuantityUpdate, }) => {
    const { productOption: decoratedProductOption, skin, priceDisplayMode, hideImages, hideDescriptions, savingsFormat, } = useProductOptionContext();
    const onChoiceChanged = useCallback((event) => {
        // If an event is not 'explicitly' invalid than assume it has violated no UI restrictions and is valid
        onChanged?.({
            optionKey: decoratedProductOption.key,
            isValid: event.isValid ?? true,
            ...event,
        });
    }, [decoratedProductOption.key, onChanged]);
    const sharedOptionProps = {
        showIncompatibleChoices: showIncompatibleChoices,
        tenant: tenant,
        currency: currency,
        fractionDigits: fractionDigits,
        locale: locale,
        priceDisplayMode,
        hideImages,
        hideDescriptions,
        skin,
        savingsFormat,
        uiDensityQuantityUpdate,
    };
    const productOptionModelList = isProductOptionModelList(decoratedProductOption);
    return (React__default.createElement(Box, null,
        productOptionModelList && decoratedProductOption.style === "buttons" && (React__default.createElement(ButtonOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged })),
        productOptionModelList && decoratedProductOption.style === "dropdown" && (React__default.createElement(DropdownOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged })),
        productOptionModelList && decoratedProductOption.style === "color-swatch" && (React__default.createElement(ColorSwatchOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged })),
        productOptionModelList && decoratedProductOption.style === "quantity-list" && (React__default.createElement(QuantityListOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged, onShowAllQuantities: onShowAllQuantities, hasSampleQuantity: hasSampleQuantity })),
        productOptionModelList && decoratedProductOption.style === "tiles" && (React__default.createElement(TileOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged })),
        productOptionModelList && decoratedProductOption.style === "quantity-combobox" && (React__default.createElement(QuantityComboboxOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged, hasSampleQuantity: hasSampleQuantity })),
        !productOptionModelList && decoratedProductOption.style === "textbox" && (React__default.createElement(TextboxOptions, { ...sharedOptionProps, option: decoratedProductOption, onChanged: onChoiceChanged, isDisabled: false }))));
};
const ProductOption = (props) => {
    const { productOption, skin = "wide", hideImages, hideDescriptions, savingsFormat, debug, showFormErrors, priceDisplayMode, uiDensityQuantityUpdate, ...rest } = props;
    const [optionNotificationRef, optionNotificationInView] = useInView({
        threshold: 1,
        triggerOnce: true,
    });
    const optionNotificationContainer = useRef(null);
    const showOptionNotification = isProductOptionModelList(productOption) &&
        productOption.previouslyUnselectedOptions &&
        productOption.previouslyUnselectedOptions?.optionCausingUnselect?.attributeKey ===
            productOption.key &&
        productOption.previouslyUnselectedOptions?.optionsUnselected.length > 0;
    useEffect(() => {
        if (!optionNotificationInView && showOptionNotification) {
            optionNotificationContainer.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [showOptionNotification, optionNotificationInView, optionNotificationContainer]);
    return (React__default.createElement(ProductOptionProvider, { productOption: productOption, skin: skin, priceDisplayMode: priceDisplayMode, hideImages: hideImages, hideDescriptions: hideDescriptions, savingsFormat: savingsFormat, showFormErrors: showFormErrors, uiDensityQuantityUpdate: uiDensityQuantityUpdate },
        React__default.createElement("div", { ref: optionNotificationContainer }, showOptionNotification ? (React__default.createElement(OptionNotification, { key: `option-notif-${productOption.key}`, notificationOptions: productOption.previouslyUnselectedOptions, ref: optionNotificationRef })) : (React__default.createElement("div", { ref: optionNotificationRef }))),
        React__default.createElement(ProductOptionInner, { ...rest }),
        debug && React__default.createElement(ProductOptionDebug, null)));
};

const ProductOptionsSection = ({ tenant, sectionHeading, productOptions, currency, locale, fractionDigits, skin, priceDisplayMode = "differential-unit", showIncompatibleChoices = false, hideImages = false, hideDescriptions = false, debug = false, showFormErrors = false, uiDensityQuantityUpdate = false, onChangeSelections, onValidation, }) => {
    const [isValid, setIsValid] = useState(() => productOptions.every((option) => {
        return !option.isRequired || (option.isRequired && !!option.selectedKey);
    }));
    useEffect(() => {
        // calculate all options and if they are valid
        if (onValidation)
            onValidation({ isValid });
    }, [isValid]);
    const handleOptionChanged = useCallback((event) => {
        const handledSelections = productOptions.reduce((result, productOption) => {
            if (productOption.selectedKey) {
                result[productOption.key] = productOption.selectedKey;
            }
            return result;
        }, {});
        const clonedSelections = { ...handledSelections };
        const { optionKey, choiceKey } = event;
        if (optionKey && choiceKey) {
            clonedSelections[optionKey] = choiceKey;
        }
        setIsValid(productOptions.every((option) => {
            return !option.isRequired || (option.isRequired && !!clonedSelections[option.key]);
        }));
        if (onChangeSelections) {
            onChangeSelections(clonedSelections);
        }
    }, [productOptions, onChangeSelections]);
    return (React__default.createElement("section", null,
        sectionHeading && React__default.createElement(H2, null, sectionHeading),
        productOptions.map((option, index) => (React__default.createElement(Box, { key: option.key, mb: index < productOptions.length - 1 ? 5 : undefined },
            React__default.createElement(ProductOption, { showIncompatibleChoices: showIncompatibleChoices, key: option.key, productOption: option, tenant: tenant, currency: currency, locale: locale, skin: skin, priceDisplayMode: priceDisplayMode, hideImages: hideImages, hideDescriptions: hideDescriptions, fractionDigits: fractionDigits, showFormErrors: showFormErrors, onChanged: handleOptionChanged, debug: debug, uiDensityQuantityUpdate: uiDensityQuantityUpdate }))))));
};

const ConfiguratorContext = React__default.createContext(undefined);

function useConfiguratorContext() {
    const ctx = React__default.useContext(ConfiguratorContext);
    if (!ctx) {
        throw new Error("useConfiguratorContext must be used within a ConfiguratorContextProvider");
    }
    return ctx;
}

function wranglerAttributeToProductOptionModel(data, uiLabels, allOptionsRequired) {
    return [
        ...data.attributes.map((attr) => ({
            key: attr.key,
            name: attr.name,
            style: 'buttons',
            selectedKey: attr.options.filter(opt => opt.isSelected)[0]?.key,
            choices: wranglerOptionsToChoices(attr.options),
            isRequired: allOptionsRequired
        })),
        {
            key: 'Quantity',
            name: uiLabels.quantity,
            style: 'dropdown',
            selectedKey: data.quantities.selected.toString(),
            choices: data.quantities.quantities.map((q, index) => {
                // calculate the total savings for the current quantity relative to the first quantity
                const nonDiscountedPrice = (data.quantities.quantities[0].unitListPrice * q.quantity);
                const discountedPrice = (q.totalDiscountedPrice);
                const savingsTotal = nonDiscountedPrice - discountedPrice;
                const savingsPercent = Math.round((savingsTotal / nonDiscountedPrice) * 100);
                return {
                    key: q.quantity.toString(),
                    name: q.quantity.toString(),
                    isCompatible: true,
                    totalListPrice: q.totalListPrice,
                    totalDiscountedPrice: q.totalDiscountedPrice,
                    unitListPrice: q.unitListPrice,
                    unitDiscountedPrice: q.unitDiscountedPrice,
                    // this is a workaround
                    differentialListPrice: q.totalListPrice,
                    differentialDiscountPrice: q.totalDiscountedPrice,
                    differentialUnitListPrice: q.unitListPrice,
                    differentialUnitDiscountPrice: q.unitDiscountedPrice,
                    savingsPercent: index > 0 ? savingsPercent : 0,
                    savingsTotal: index > 0 ? savingsTotal : 0
                };
            }),
            isRequired: false,
        },
    ];
}
function wranglerOptionsToChoices(options) {
    return options.map((option) => ({
        key: option.key,
        name: option.name,
        description: option.description,
        image: option.images[0],
        callouts: option.badges?.map((b) => ({ key: b.id, text: b.text })),
        isCompatible: option.isCompatible,
        incompatibleReasons: option.incompatibleReasons,
        differentialListPrice: option.differentialListPrice,
        differentialDiscountPrice: option.differentialDiscountPrice,
        differentialUnitListPrice: option.differentialUnitListPrice,
        differentialUnitDiscountPrice: option.differentialUnitDiscountPrice,
    }));
}

function getUiLabels(culture, overrides) {
    const language = culture.substring(0, 2).toLowerCase();
    const result = translations[`${culture.toLowerCase()}`] ?? translations[`${language}`];
    if (!result) {
        throw new Error(`Simple Configurator: Translations not found for culture ${culture}`);
    }
    return { ...result, ...(overrides ?? {}) };
}
const EN_DEFAULT = {
    saveChanges: 'Update cart',
    revertChanges: 'Keep original',
    quantity: 'Quantity',
    selectPreview: 'Select a preview',
    front: 'Front',
    back: 'Back',
    open: 'Open',
    close: 'Close',
    previewAlt: 'Document Preview',
    loadingError: 'Sorry, our system experienced a temporary glitch. Please give us just a minute and then try again.'
};
const ES_DEFAULT = {
    saveChanges: 'Actualizar cesta',
    revertChanges: 'Mantener original',
    quantity: 'Cantidad',
    selectPreview: 'Selecciona una vista previa',
    front: 'Anverso',
    back: 'Reverso',
    open: 'Abierto',
    close: 'Cerrar',
    previewAlt: 'Vista previa del documento',
    loadingError: 'Lo sentimos, se ha producido un problema técnico temporal. Inténtalo de nuevo en unos minutos.'
};
const IT_DEFAULT = {
    saveChanges: 'Aggiorna carrello',
    revertChanges: "Mantieni l'originale",
    quantity: 'Quantità',
    selectPreview: 'Scegli un’anteprima',
    front: 'Lato anteriore',
    back: 'Indietro',
    open: 'Apri',
    close: 'Chiudi',
    previewAlt: 'Anteprima documento',
    loadingError: 'Siamo spiacenti, si è verificato un problema temporaneo nel nostro sistema. Riprova tra un minuto.'
};
const PT_DEFAULT = {
    saveChanges: 'Atualizar cesto',
    revertChanges: 'Manter original',
    quantity: 'Quantidade',
    selectPreview: 'Selecione uma pré-visualização',
    front: 'Frente',
    back: 'Verso',
    open: 'Abrir',
    close: 'Fechar',
    previewAlt: 'Pré-visualização do documento',
    loadingError: 'Pedimos desculpa. O nosso sistema apresenta uma falha temporária. Tente novamente dentro de um minuto.'
};
const DA = {
    saveChanges: 'Opdater vogn',
    revertChanges: 'Behold original',
    quantity: 'Antal',
    selectPreview: 'Vælg en forhåndsvisning',
    front: 'Forside',
    back: 'Tilbage',
    open: 'Åbn',
    close: 'Luk',
    previewAlt: 'Se dokument',
    loadingError: 'Beklager, der er sket en midlertidig fejl i vores system. Vent et øjeblik, og prøv så igen.'
};
const FI = {
    saveChanges: 'Päivitä ostoskori',
    revertChanges: 'Säilytä alkuperäinen',
    quantity: 'Määrä',
    selectPreview: 'Valitse esikatselu',
    front: 'Etupuoli',
    back: 'Kääntöpuoli',
    open: 'Avaa',
    close: 'Sulje',
    previewAlt: 'Asiakirjan esikatselu',
    loadingError: 'Valitettavasti järjestelmässämme ilmeni tilapäinen häiriö. Ole hyvä ja odota minuutti, ja yritä sitten uudestaan.'
};
const NL = {
    saveChanges: 'Winkelwagentje bijwerken',
    revertChanges: 'Origineel behouden',
    quantity: 'Aantal',
    selectPreview: 'Selecteer een voorbeeld',
    front: 'Voorkant',
    back: 'Achterkant',
    open: 'Open',
    close: 'Sluiten',
    previewAlt: 'Voorbeeld document',
    loadingError: 'Sorry, ons systeem werkt even niet mee. Probeer het over een minuutje nog een keer.'
};
const FR = {
    saveChanges: 'Actualiser le panier',
    revertChanges: "Conserver l'original",
    quantity: 'Quantité',
    selectPreview: 'Choisissez un aperçu',
    front: 'Recto',
    back: 'Retour',
    open: 'Ouvert',
    close: 'Fermer',
    previewAlt: 'Aperçu du document',
    loadingError: 'Désolé, un problème temporaire est survenu dans notre système. Veuillez attendre un instant et réessayer.'
};
const DE = {
    saveChanges: 'Warenkorb aktualisieren',
    revertChanges: 'Beim Original bleiben',
    quantity: 'Menge',
    selectPreview: 'Wählen Sie eine Vorschau',
    front: 'Vorderseite',
    back: 'Zurück',
    open: 'Geöffnet',
    close: 'Schließen',
    previewAlt: 'Dokumentvorschau',
    loadingError: 'Wir haben vorübergehende technische Probleme. Bitte entschuldigen Sie etwaige Unannehmlichkeiten. Wir arbeiten an der Behebung. Versuchen Sie es bitte später noch einmal.'
};
const NB = {
    saveChanges: 'Oppdater handlevogn',
    revertChanges: 'Behold original',
    quantity: 'Ant.',
    selectPreview: 'Velg en forhåndsvisning',
    front: 'Forside',
    back: 'Bakside',
    open: 'Åpne',
    close: 'Lukk',
    previewAlt: 'Forhåndsvisning av dokument',
    loadingError: 'Beklager, men det har oppstått en midlertidig feil i systemet. Vent et par minutter og prøv igjen.'
};
const SV = {
    saveChanges: 'Uppdatera kundvagn',
    revertChanges: 'Behåll original',
    quantity: 'Antal',
    selectPreview: 'Välj en förhandsvisning',
    front: 'Framsida',
    back: 'Baksida',
    open: 'Öppet',
    close: 'Stäng',
    previewAlt: 'Förhandsgranska dokument',
    loadingError: 'Vi beklagar, ett tillfälligt fel tycks ha uppstått i vårt system. Vi ber dig att vänta någon minut och sedan försöka igen.'
};
const translations = {
    en: EN_DEFAULT,
    es: ES_DEFAULT,
    it: IT_DEFAULT,
    pt: PT_DEFAULT,
    'en-GB': EN_DEFAULT,
    da: DA,
    de: DE,
    fi: FI,
    fr: FR,
    nb: NB,
    nl: NL,
    sv: SV,
};

function getAllOptionsAreSamePrice(attributes) {
    for (const attribute of Object.values(attributes)) {
        for (const attributeValue of Object.values(attribute.options)) {
            if (attributeValue.differentialDiscountPrice !== 0) {
                return false;
            }
        }
    }
    return true;
}

function getPriceBreakdown(wranglerData) {
    if (!wranglerData?.price?.breakdown) {
        return {};
    }
    else {
        const result = {};
        for (const breakdown of wranglerData.price.breakdown) {
            const optionObj = result[breakdown.name] ?? (result[breakdown.name] = {});
            optionObj[breakdown.value] = {
                listPrice: breakdown.listPrice,
                discountPrice: breakdown.discountPrice,
                percentageOff: breakdown.percentageOff,
                amountSaved: breakdown.amountSaved,
            };
        }
        return result;
    }
}

function getPriceInfo(wranglerContext, data) {
    const { fractionDigits, currency } = data.price;
    const { includeVat = false, culture } = wranglerContext;
    const allOptionsAreSamePrice = getAllOptionsAreSamePrice(data.attributes);
    return {
        // Duplicate all this stuff for each of the quantity values so that they'll be in the format that RawPrice and UnitPrice
        // take; this should make it a tiny bit easier to override price rendering.
        quantities: (data.quantities?.quantities ?? []).map(({ quantity, totalListPrice, totalDiscountedPrice, unitListPrice, unitDiscountedPrice, badges }) => ({
            quantity,
            culture,
            currency,
            listPrice: totalListPrice,
            discountPrice: totalDiscountedPrice,
            unitListPrice,
            unitDiscountPrice: unitDiscountedPrice,
            badges,
            vatInc: includeVat,
            minimumFractionDigits: fractionDigits,
            hideVatMessage: false,
        })),
        culture,
        currency,
        vatInc: includeVat,
        minimumFractionDigits: fractionDigits,
        priceBreakdown: getPriceBreakdown(data),
        pricesBreakdownArray: data.price.breakdown,
        allOptionsAreSamePrice,
        hideVatMessage: false,
    };
}

const ConfiguratorContextProvider = ({ children, allOptionsRequired, onPriceUpdated, uiLabelOverrides, showFormErrors, onValidation }) => {
    const { data, updating: isLoading, context: wranglerContext } = React__default.useContext(WranglerDataContext);
    const { setSelections, setSelectedQuantity } = useManagedWranglerSelectionsContext();
    const uiLabels = useMemo(() => {
        return getUiLabels(wranglerContext.culture, uiLabelOverrides);
    }, [wranglerContext.culture, uiLabelOverrides]);
    const setSelectionsHandler = useCallback((selections) => {
        if (selections["Quantity"]) {
            // for now, we want to handle quantity separately
            const quantity = parseInt(selections["Quantity"], 10);
            setSelectedQuantity(quantity);
            delete selections["Quantity"];
        }
        setSelections(selections);
    }, [setSelections]);
    const setSelectedQuantityHandler = useCallback((selectedQuantity) => {
        setSelectedQuantity(selectedQuantity);
    }, [setSelectedQuantity]);
    const [priceInfo, setPriceInfo] = useState(undefined);
    const [productOptions, setProductOptions] = useState([]);
    useEffect(() => {
        if (data && wranglerContext) {
            setProductOptions(wranglerAttributeToProductOptionModel(data, uiLabels, allOptionsRequired));
            const wranglerPriceData = isLoading
                ? undefined
                : data.price;
            if (wranglerPriceData) {
                setPriceInfo(getPriceInfo(wranglerContext, data));
            }
            else {
                setPriceInfo(undefined);
            }
        }
    }, [data, isLoading, wranglerContext, allOptionsRequired]);
    const context = useMemo(() => {
        if (data) {
            const mpvId = data.selections.mpvId;
            const productName = data.productName;
            const selections = data.selections.selectedAttributes;
            const document = data.selections.document;
            const selectedQuantity = data.selections.quantity;
            const result = {
                isLoading,
                priceInfo,
                mpvId,
                productName,
                productOptions,
                onPriceUpdated,
                selectedQuantity,
                setSelectedQuantity: setSelectedQuantityHandler,
                uiLabels,
                selections,
                setSelections: setSelectionsHandler,
                document,
                culture: wranglerContext.culture,
                merchant: wranglerContext.merchant,
                currency: data.price.currency,
                fractionDigits: data.price.fractionDigits,
                showFormErrors,
                onValidation,
            };
            return result;
        }
        else {
            return undefined;
        }
    }, [priceInfo, isLoading, data, onPriceUpdated, setSelectedQuantityHandler, productOptions, uiLabels, showFormErrors, onValidation]);
    if (productOptions.length === 0)
        return null;
    return (React__default.createElement(ConfiguratorContext.Provider, { value: context }, children));
};

const DisplayContext = React.createContext({ debugProductOptionsUi: false, debugDisabledOptions: false, debugIncompatibleOptions: false });

const DisplayContextProvider = ({ children, ...ctx }) => {
    return React__default.createElement(DisplayContext.Provider, { value: ctx }, children);
};

function useDisplayContent() {
    return useContext(DisplayContext);
}

const ProductOptions = ({ hideOptionImages, priceDisplayMode, hideOptionDescriptions, showIncompatibleChoices, }) => {
    const { debugProductOptionsUi } = useDisplayContent();
    const { productOptions, setSelections, selections, culture, merchant, currency, fractionDigits, showFormErrors, onValidation } = useConfiguratorContext();
    const changeSelectionsHandler = useCallback((inputSelections) => {
        const newSelections = Object.assign({}, selections ?? {}, inputSelections);
        setSelections(newSelections);
    }, [selections, setSelections]);
    const skin = "tight";
    return React__default.createElement(React__default.Fragment, null, !!currency && !!fractionDigits && (React__default.createElement(Box, { mb: "between-subsections" },
        React__default.createElement(ProductOptionsTranslations, { locale: culture },
            React__default.createElement(ProductOptionsSection, { debug: debugProductOptionsUi, hideImages: hideOptionImages, hideDescriptions: hideOptionDescriptions, showIncompatibleChoices: showIncompatibleChoices, skin: skin, tenant: merchant, onChangeSelections: changeSelectionsHandler, productOptions: productOptions, priceDisplayMode: priceDisplayMode, currency: currency, locale: culture, fractionDigits: fractionDigits, showFormErrors: showFormErrors, onValidation: onValidation })))));
};

const FooterPrice = () => {
    const { onPriceUpdated, selectedQuantity, priceInfo, uiLabels, isLoading } = useConfiguratorContext();
    const { data } = useWranglerDataContext();
    const [priceProps, setPriceProps] = useState(undefined);
    const [showLoadingError, setShowLoadingError] = useState(false);
    React__default.useEffect(() => {
        if (priceInfo) {
            onPriceUpdated?.(priceInfo);
            setPriceProps(priceInfo.quantities?.find((p) => p.quantity === selectedQuantity));
        }
        else {
            setPriceProps(undefined);
        }
    }, [priceInfo]);
    React__default.useEffect(() => {
        if (Object.keys(data?.price || {}).length === 0 && isLoading === false) {
            setShowLoadingError(true);
        }
        else {
            setShowLoadingError(false);
        }
    }, [data?.price, isLoading]);
    return (React__default.createElement(FlexBox, { alignItems: "center", flexDirection: "row", justifyContent: "space-between", style: { height: showLoadingError ? undefined : "50px", width: "100%" } }, showLoadingError
        ? React__default.createElement(AlertBox, { mb: "4", skin: "error" },
            uiLabels.loadingError,
            React__default.createElement(AlertBoxDismissButton, { accessibleText: uiLabels.close }))
        : React__default.createElement(Typography, null, priceProps
            ? React__default.createElement("output", null,
                React__default.createElement(QtyStartingAtPrice, { placeHolderText: "...", pricingInfo: {
                        currency: priceProps.currency ?? "USD",
                        culture: priceProps.culture ?? "en-US",
                        quantity: priceProps.quantity ?? 1,
                        listPrice: priceProps.listPrice ?? 0,
                        discountPrice: priceProps.discountPrice ?? 0,
                        vatInc: priceProps.vatInc ?? false,
                        minimumFractionDigits: priceProps.minimumFractionDigits ?? 2,
                        hideVatMessage: priceProps.hideVatMessage ?? false,
                    } }))
            : React__default.createElement(Spinner, { accessibleText: "...", layout: "horizontal" }))));
};

const StickyRowWrapper = dt.div({
    marginBottom: 0,
    marginTop: 0,
    paddingBottom: 0,
    paddingTop: 0,
    display: "block",
    position: "sticky",
    bottom: 0,
    zIndex: 10,
    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.10)",
});
const StickyRowSiblingWrapper = dt.div({
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 0,
    marginTop: 0,
    paddingLeft: 0,
    position: "relative",
    zIndex: 1,
});
const ConfiguratorLayout = ({ responseButtons: ResponseButtons, ...rest }) => {
    return (React__default.createElement(GridContainer, { gutter: "tight" },
        React__default.createElement(StickyRowSiblingWrapper, null,
            React__default.createElement(Column, { span: 12 },
                React__default.createElement(ProductOptions, { ...rest }))),
        React__default.createElement(StickyRowWrapper, null,
            React__default.createElement(Column, { span: 12, bgc: "standard", paddingTop: "3", mb: 0, pb: "3", paddingX: "4" },
                React__default.createElement(FooterPrice, null),
                React__default.createElement(ResponseButtons, null)))));
};

const NR_AGENT_CONFIG = {
    init: {
        distributed_tracing: {
            enabled: true,
            cors_use_newrelic_header: true,
            cors_use_tracecontext_headers: true,
            allowed_origins: ["https://www.vistaprint.com"],
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.nr-data.net"] },
    },
    loader_config: {
        accountID: "2429158",
        trustKey: "1106546",
        agentID: "1120320596",
        licenseKey: "NRBR-3dc2673d64039888e8b",
        applicationID: "1120320596"
    },
    info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: "NRBR-3dc2673d64039888e8b",
        applicationID: "1120320596",
        sa: 1
    },
};
async function initNewRelicAgent() {
    // The browser agent can only be used when
    if (typeof window !== "undefined") {
        const { MicroAgent } = await import('./micro-agent-8d9a9dc2.js').then(function (n) { return n.ao; });
        const agent = new MicroAgent(NR_AGENT_CONFIG);
        agent.start(undefined);
        return agent;
    }
    else {
        return null;
    }
}
// Initialize the browser agent; though this is a promise, by the time any callers actually
// try to use it, it will be defined.
let NR_AGENT;
initNewRelicAgent().then((agent) => (NR_AGENT = agent));
function getNewRelicAgent() {
    return NR_AGENT;
}

class LoggingProvider {
    static warn(message, error, additionalInfo) {
        this.addPageAction(message, "WARN", {
            ...(additionalInfo ?? {}),
            error,
        });
    }
    static info(message, additionalInfo) {
        this.addPageAction(message, "INFO", additionalInfo);
    }
    static error(message, error, additionalInfo) {
        const newRelicAgent = getNewRelicAgent();
        // So that we don't lose the detail of the error, make a copy of the error and insert the more friendly message into
        // the error. This will put both messages into the error string in New Relic
        let modifiedError = undefined;
        if (error) {
            modifiedError = structuredClone(error);
            modifiedError.message = `${message} - ${modifiedError.message}`;
        }
        if (newRelicAgent) {
            newRelicAgent?.noticeError(modifiedError ?? message, additionalInfo);
        }
        else {
            console.error(message, modifiedError, additionalInfo);
        }
    }
    static addPageAction(name, level, details) {
        const newRelicAgent = getNewRelicAgent();
        const fullDetails = {
            level,
            ...(details ?? {})
        };
        if (newRelicAgent) {
            newRelicAgent.addPageAction(name, fullDetails);
        }
        else {
            console.log(name, fullDetails);
        }
    }
}

const ContextAwareConfigurator = ({ uiLabelOverrides, hideOptionImages, priceDisplayMode = "differential-unit", hideOptionDescriptions, showIncompatibleChoices, onCancel, onSaveSelections, onPriceUpdated, onErrorClear, renderingOverrides, allOptionsRequired, showFormErrors, onValidation, loader, }) => {
    const ResponseButtonsComponent = useMemo(() => () => {
        return React__default.createElement(ResponseButtons, { onSaveSelections: onSaveSelections, onCancel: onCancel, responseButtons: renderingOverrides?.responseButtons });
    }, [renderingOverrides]);
    const Layout = useMemo(() => {
        if (renderingOverrides?.configuratorLayout) {
            return renderingOverrides.configuratorLayout;
        }
        return ConfiguratorLayout;
    }, [renderingOverrides?.configuratorLayout]);
    const wranglerData = React__default.useContext(WranglerDataContext);
    const managedWranglerSelections = React__default.useContext(ManagedWranglerSelectionsContext);
    const [errors, setErrors] = React__default.useState([]);
    if (wranglerData?.exceptionMessages?.length > 0) {
        // If we've got errors, and the set of errors is different from the last time, fire the onError handler.
        if (JSON.stringify(wranglerData.exceptionMessages) !== JSON.stringify(errors)) {
            LoggingProvider.error("Received errors from wrangler call", undefined, {
                errorMessages: wranglerData.exceptionMessages
            });
            setErrors(wranglerData.exceptionMessages);
        }
    }
    if (errors.length > 0 && wranglerData?.exceptionMessages?.length === 0) {
        // If we had errors before, but now there are none, then fire onErrorClear.
        onErrorClear?.();
        setErrors([]);
    }
    if (!wranglerData?.data || !managedWranglerSelections) {
        if (loader) {
            return loader;
        }
        return React__default.createElement(Spinner, { accessibleText: '...' }); // TODO : consider localized accessibleText !?
    }
    return (React__default.createElement(ConfiguratorContextProvider, { allOptionsRequired: allOptionsRequired, onPriceUpdated: onPriceUpdated, uiLabelOverrides: uiLabelOverrides, showFormErrors: showFormErrors, onValidation: onValidation },
        React__default.createElement(Layout, { priceDisplayMode: priceDisplayMode, responseButtons: ResponseButtonsComponent, hideOptionImages: hideOptionImages, hideOptionDescriptions: hideOptionDescriptions, showIncompatibleChoices: showIncompatibleChoices })));
};
const ResponseButtons = ({ onSaveSelections, onCancel, responseButtons }) => {
    const ResponseButtonsComponent = useMemo(() => {
        return responseButtons ?? ResponseButtons$1;
    }, [responseButtons]);
    const { priceInfo, mpvId, productName, uiLabels, selectedQuantity, isLoading, selections, document } = useConfiguratorContext();
    const currentPrice = priceInfo?.quantities?.find((q) => q.quantity === selectedQuantity);
    const saveContext = {
        mpvId: mpvId,
        productName: productName,
        price: currentPrice,
    };
    return (React__default.createElement(ResponseButtonsComponent, { onSaveSelections: () => !isLoading &&
            selections &&
            onSaveSelections(selections, selectedQuantity, document, saveContext), onCancel: onCancel, saveChangesLabel: uiLabels.saveChanges, revertChangesLabel: uiLabels.revertChanges, selectPreviewLabel: uiLabels.selectPreview }));
};

const QuantityAndPrice = () => {
    const { onPriceUpdated, selectedQuantity, setSelectedQuantity, uiLabels, priceInfo } = useConfiguratorContext();
    const [merchandisingQuantities, setMerchandisingQuantities] = useState([]);
    const [priceProps, setPriceProps] = useState(undefined);
    React__default.useEffect(() => {
        if (selectedQuantity) {
            if (!merchandisingQuantities.some((qty) => (qty === selectedQuantity))) {
                // add selectedQuantity into the list of quantities if it's not already there
                setMerchandisingQuantities([selectedQuantity, ...merchandisingQuantities]);
            }
        }
    }, [selectedQuantity]);
    React__default.useEffect(() => {
        if (priceInfo) {
            onPriceUpdated?.(priceInfo);
            setMerchandisingQuantities(priceInfo.quantities?.map((pi) => pi.quantity) ?? [selectedQuantity]);
            setPriceProps(priceInfo.quantities?.find((p) => p.quantity === selectedQuantity));
        }
        else {
            setPriceProps(undefined);
        }
    }, [priceInfo]);
    return (React__default.createElement(FlexBox, { alignItems: "center", flexDirection: "row", justifyContent: "space-between" },
        React__default.createElement(StandardForm, null,
            React__default.createElement(FormField, null,
                React__default.createElement(FormLabel, null, uiLabels.quantity),
                React__default.createElement(FormInputGroup, { marginBottom: "5" },
                    React__default.createElement(Dropdown, { className: "quantity-dropdown", value: selectedQuantity, onChange: (event) => setSelectedQuantity(parseInt(event.target.value, 10)) }, merchandisingQuantities.map((quantity) => (React__default.createElement(DropdownOption, { key: `qty-${quantity}`, value: quantity }, quantity))))))),
        React__default.createElement(Typography, { textAlign: "right", mb: "3" }, priceProps
            ? React__default.createElement("output", null,
                React__default.createElement(RawPrice, { placeHolderText: "...", pricingInfo: {
                        currency: priceProps.currency ?? "USD",
                        culture: priceProps.culture ?? "en-US",
                        listPrice: priceProps.listPrice ?? 0,
                        discountPrice: priceProps.discountPrice ?? 0,
                        vatInc: priceProps.vatInc ?? false,
                        minimumFractionDigits: priceProps.minimumFractionDigits ?? 2,
                        hideVatMessage: priceProps.hideVatMessage ?? false,
                    } }))
            : React__default.createElement(Spinner, { accessibleText: "...", layout: "horizontal" }))));
};

const EditOptions = ({ culture, tenant, merchandisingExperience, initialSelections, initialQuantity, productKey, productVersion, documentUrl, includeVat, priceStyle, couponCode, pricingContextString, uiLabelOverrides, renderingOverrides, priceDisplayMode, deselectCompletedOptions, excludeInitialSelectedAttributes, hideOptionImages, hideOptionDescriptions, showIncompatibleChoices, onChangeSelections, onChangeQuantity, onPriceUpdated, onSaveSelections, onError, onErrorClear, onCancel, allOptionsRequired, showFormErrors, onValidation, }) => {
    const configurator = (React__default.createElement(ContextAwareConfigurator, { hideOptionImages: hideOptionImages, priceDisplayMode: priceDisplayMode, hideOptionDescriptions: hideOptionDescriptions, showIncompatibleChoices: showIncompatibleChoices, uiLabelOverrides: uiLabelOverrides, onSaveSelections: onSaveSelections, onCancel: onCancel, renderingOverrides: renderingOverrides, onPriceUpdated: onPriceUpdated, onErrorClear: onErrorClear, allOptionsRequired: allOptionsRequired, showFormErrors: showFormErrors, onValidation: onValidation }));
    // If the client has already instantiated the WranglerDataProvider higher up in the tree,
    // then we don't need to create a new one.
    //
    // This way, multiple SimpleConfigurators can share the same state.
    const wranglerData = React__default.useContext(WranglerDataContext);
    if (wranglerData) {
        return React__default.createElement(React__default.Fragment, null, configurator);
    }
    else {
        return (React__default.createElement(ManagedWranglerSelectionsProvider, { merchant: tenant, culture: culture, productKey: productKey, productVersion: productVersion, documentUrl: documentUrl, includeVat: includeVat, priceStyle: priceStyle ?? "relative", selectedAttributes: initialSelections, selectedQuantity: initialQuantity, initialSelectedAttributes: initialSelections, merchandisingExperience: merchandisingExperience, couponCode: couponCode, onChangeQuantity: onChangeQuantity, onChangeSelections: onChangeSelections, pricingContextString: pricingContextString, deselectCompletedOptions: deselectCompletedOptions, excludeInitialSelectedAttributes: excludeInitialSelectedAttributes, requestor: "simple-configurator-with-no-preview" }, configurator));
    }
};

/**
 * Displays a simple product option configurator
 */
const SimpleConfigurator = ({ debugProductOptionsUi = false, debugDisabledOptions = false, debugIncompatibleOptions = false, ...props }) => {
    return (React__default.createElement(ScreenClassProvider, null,
        React__default.createElement(DisplayContextProvider, { debugDisabledOptions: debugDisabledOptions, debugIncompatibleOptions: debugIncompatibleOptions, debugProductOptionsUi: debugProductOptionsUi },
            React__default.createElement(EditOptions, { ...props }))));
};

export { ContextAwareConfigurator, FooterPrice, ProductOptions, QuantityAndPrice, ResponseButtons$1 as ResponseButtons, SimpleConfigurator };
//# sourceMappingURL=index.mjs.map
